(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var config = {
  topPlayed: {
    homeLimit: 4,
    pageLimit: 51
  },
  topRated: {
    pageLimit: 51
  }
};

module.exports = config;

},{}],2:[function(require,module,exports){
function AmipageController($rootScope, $scope, amiSvc, gatheringSvc) {
    $rootScope.showNormalNav = true;
    $scope.busy = true;
    var myPlayer;

    amiSvc.downloadAmi($rootScope.amiModalGameContentId, true);

    $scope.installAmiCall = function () {
        Arrow.show();
        amiSvc.downloadAmi($rootScope.amiModalGameContentId, true);
        $rootScope.tagEvent('ami-popup-force-download-click');
        gatheringSvc.sendBiAmiInfo('click-downloadNotStarted', $rootScope.gameManager.sessionGamesByContentId[$rootScope.amiModalGameContentId].id);            
    

        if (!myPlayer) { myPlayer = videojs('ami-video');} 
        myPlayer.load();
        myPlayer.play();       
        myPlayer.on('play', function(){          
          $rootScope.sendClickTracking($rootScope.player.userId, 'play');
        });
        myPlayer.on('ended', function() {          
          Arrow.show();
          $rootScope.sendClickTracking($rootScope.player.userId, 'complete');
        });        
    };

    window.scrollTo(0,0);
    Arrow.show();
    
    if (!myPlayer) { myPlayer = videojs('ami-video');} 
    myPlayer.ready(function () { 
        myPlayer = this;
        this.on('play', function(){
            $rootScope.sendClickTracking($rootScope.player.userId, 'play');
        });
        this.on('ended', function() {
            Arrow.show();
            $rootScope.sendClickTracking($rootScope.player.userId, 'complete');
        });        
    });

    $scope.$on("$destroy", function(){
        // dispose video when out of the page
        videojs('ami-video').dispose();
    });
}

AmipageController.$inject = ['$rootScope', '$scope', 'amiSvc', 'gatheringSvc'];
module.exports = AmipageController;
},{}],3:[function(require,module,exports){
function EmailVerificationController($scope, $rootScope, $routeParams, $timeout, $location, userSvc, emailVerificationService) {

  $location.path('/');

  var result = $routeParams.result;

  if (result !== 'success')
    emailVerificationService.sendValidationEmail($routeParams.id, $routeParams.hash);

  $timeout(function() {
    if (result === 'success') {
      if ($rootScope.player && $rootScope.player.isLoggedIn)
        $rootScope.player.isValidated = true;

      $rootScope.$broadcast('modal.close');
      $rootScope.$broadcast('modal.open', {
        templateUrl: 'popups/emailVerificationSuccess.html'
      });
    } else {
      $rootScope.$broadcast('modal.close');
      $rootScope.$broadcast('modal.open', {
        templateUrl: 'popups/emailVerificationFailure.html'
      });
    }
  }, 500);
}

EmailVerificationController.$inject = ['$scope', '$rootScope', '$routeParams', '$timeout', '$location', 'userSvc', 'emailVerificationService'];
module.exports = EmailVerificationController;

},{}],4:[function(require,module,exports){
function ExclusiveGamesController($rootScope, $scope, $location, gameDataSvc) {
  // Set header
  $rootScope.showNormalNav = true;

  gameDataSvc.getExclusiveGames(51).success(function(exclusiveGamesResults) {
    if (!exclusiveGamesResults.error) {
      exclusiveGamesResults.size === 0
        ? ($scope.exclusiveGames = null)
        : ($scope.exclusiveGames = exclusiveGamesResults.items);
    } else {
      $location.path('/');
    }
  });
}

ExclusiveGamesController.$inject = [
  '$rootScope',
  '$scope',
  '$location',
  'gameDataSvc'
];
module.exports = ExclusiveGamesController;

},{}],5:[function(require,module,exports){
function GamepageController ($rootScope, $scope, $routeParams, $sce, gameDataSvc, gatheringSvc, amiSvc, $window, abtestService, $location) {
    // Set header
    $rootScope.showNormalNav = true;

    var seoName = $routeParams.seoName;
    $scope.videoPlayTracked = false;
    // convertedPlayerRating is the number of stars that should be displayed, so an integer from 0 to 5
    // make sure we convert this from and to the database scale, which is an integer from 0 to 10
    $scope.convertedPlayerRating = null;
    $scope.showMessage = [];
    $scope.showMessage.thanksForRating = false;
    $scope.showMessage.ratingWarning = false;
    $scope.userReviews = {
        "all": [],
        "even": [],
        "odd": [],
        "persisted": false
    };
    $scope.isRatingEnabled = false;
    $scope.isSupportedOperatingSystem = true;
    $scope.ratingCheckInterval = setInterval(function onRateInterval() {
       $scope.checkRatingAccess();
     }, 60 * 1000);

    $scope.checkRatingAccess = function() {
      if (!$scope || !$scope.game || !$scope.game.contentId) {
        return;
      }

      amiSvc.getGame($scope.game.contentId, function(gameData) {
        if (gameData) {
          $scope.$apply(function() {
            $scope.isRatingEnabled = gameData.stats.total_execution_time > 60 * 10;
          });
        } else {
          $scope.$apply(function() { $scope.isRatingEnabled = false; });
        }
      });
    };

    // $scope.playGame = function (game, event, pos, angularEvent) {
    //   $rootScope.playGame(game, event, pos, angularEvent);
    // };

    gameDataSvc.getSpecificGame(seoName).success(function(data){
        if (data && data.contentId && data.id) {
            $scope.game = data;
            if ($scope.game != null) {
                //Set meta descriptions to have correct value
                $rootScope.metaTitle = $scope.game.title + " - GameHouse";
                // remove any HTML from the game description to create the META title
                if ($scope.game.description.indexOf('<') !== -1) {
                    $rootScope.metaDescription = $scope.game.description.substr(0, $scope.game.description.indexOf('<'));
                } else {
                    $rootScope.metaDescription = $scope.game.description;
                }

                // descriptions can contain HTML
                $scope.game.unsafeDescription = $sce.trustAsHtml($scope.game.description);

                $scope.checkRatingAccess();
                if ($scope.game.contentId !== null && $rootScope.player.preloadingEnabled && $scope.game.preloading) {
                    amiSvc.startGamePreload($scope.game);
                }

                if ($scope.game.rating !== null) {
                    if ($scope.game.rating.playerRating === null) {
                        $scope.game.rating.playerRating = 0;
                    }
                    $scope.game.rating.hasPlayerRating = ($scope.game.rating.playerRating > 0);
                    // convert the database value of rating (0..10) to the number of stars to be displayed (0..5)
                    $scope.game.rating.convertedPlayerRating = Math.ceil($scope.game.rating.playerRating / 2);
                }

                // populate the game-based recommendation
                getGameBasedRecommendation($scope.game.id, $rootScope.recommendedGameLimit);

                if ($scope.game.series && $scope.game.series.seoName) {
                    getSeriesGames($scope.game.series.seoName);
                }
            }
        } else {
            gatheringSvc.sendErrorInfo('GetGamePageSpecificGame1', ' Error: failed getting game page specific game info. FunctionalId: ' + seoName);
            $window.location.href = '/';
        }
    }).error(function(data){
        gatheringSvc.sendErrorInfo('GetGamePageSpecificGame2', ' Error: failed getting game page specific game info. FunctionalId: ' + seoName);
        $window.location.href = '/';
    });

    $scope.postGameRating = function(gameId, ratingObject) {
        $rootScope.tagEvent('game-body-rating-click', {'score': ratingObject.convertedPlayerRating});

        if (ratingObject != null && gameId != null) {
            // convert the number of stars being displayed (0..5) to the database value of rating (0..10)
            ratingObject.playerRating = ratingObject.convertedPlayerRating * 2;

            gameDataSvc.postGameRating(gameId, ratingObject).success(function (data) {
                if (data != null && !data.error && data.averageRating != null && data.ratingScore != null && data.ratingCount != null && data.playerRating != null) {
                    $scope.game.rating.hasPlayerRating = true;
                    $scope.game.rating.averageRating = data.averageRating;
                    $scope.game.rating.ratingScore = data.ratingScore;
                    $scope.game.rating.ratingCount = data.ratingCount;
                    $scope.game.rating.playerRating = data.playerRating;
                    // convert the database value of rating (0..10) to the number of stars to be displayed (0..5)
                    $scope.game.rating.convertedPlayerRating = Math.ceil($scope.game.rating.playerRating / 2);
                    $scope.showMessage.ratingWarning = false;
                    $scope.showMessage.thanksForRating = true;
                } else {
                    $scope.showMessage.thanksForRating = false;
                    $scope.showMessage.ratingWarning = true;
                }
            }).error(function (data, status) {
                $scope.showMessage.thanksForRating = false;
                $scope.showMessage.ratingWarning = true;
            });
        } else {
            $scope.showMessage.thanksForRating = false;
            $scope.showMessage.ratingWarning = true;
        }
    };


    function getGameBasedRecommendation(gameId, numberOfGames) {
        gameDataSvc.getGameBasedRecommendationsForceGenre(gameId, numberOfGames).success(function (recommendedGameBasedGames) {
            if (!recommendedGameBasedGames.error) {
                $scope.recommendedGameBased = recommendedGameBasedGames.gameList;
                $rootScope.categoryCounter['recommendedGameBased-' + seoName] = $scope.recommendedGameBased.length;

                if (recommendedGameBasedGames.total > $rootScope.recommendedGameLimit) {
                    $rootScope.showLoadMore['recommendedGameBased'] = true;
                }
            } else {
                gatheringSvc.sendErrorInfo('GetGamePageRecommendedGame1', ' Error: failed getting game page recommended games. Reason: ' + recommendedGameBasedGames.error);
            }
        }).error(function (data) {
            gatheringSvc.sendErrorInfo('GetGamePageRecommendedGame2', ' Error: failed getting game page recommended games. Reason: ' + recommendedGameBasedGames.error);
        });
    }

    function handleError() {
        gatheringSvc.sendErrorInfo('gamePage getSeriesGames', 'Error: loading games in series. SeoName: ' + $routeParams.seoName);
    }

    var getSeriesGames = function (seriesSeoName) {
        gameDataSvc.getSeriesGames(seriesSeoName, 0, 1000, 'launchDate', 'DESC').success(function (gameData) {
            if (!gameData.error) {
                // remove any HTML from the game description
                for (var i=0; i < gameData.gameList.length; i++) {
                    var game = gameData.gameList[i];
                    if (game.description.indexOf('<') !== -1) {
                        game.description = game.description.substr(0, $scope.game.description.indexOf('<'));
                    }
                }
                $scope.seriesGames = gameData.gameList;
            } else {
                // error detected
                handleError();
            }
        }).error(function () {
            // error detected
            handleError();
        });
    };

    $scope.$on('$viewContentLoaded', function (event) {
        setInterval(function(){
            var videoElement = document.getElementsByTagName('video')[0];
            if(videoElement){
                if (videoElement.paused !== 'undefined' && !$scope.videoPlayTracked){
                    $scope.videoPlayTracked = true;
                }
            }
        },2000);
    });

    $scope.$on("$destroy", function(){
        // stop preloading of the game when we leave this page
        amiSvc.stopAllGamePreloads();
        gameDataSvc.cancelRequest();
    });
}



GamepageController.$inject = ['$rootScope', '$scope', '$routeParams', '$sce', 'gameDataSvc', 'gatheringSvc', 'amiSvc', '$window', 'abtestService', '$location'];
module.exports = GamepageController;

},{}],6:[function(require,module,exports){
function GenrepageController ($rootScope, $scope, $routeParams, $filter, $location, gameDataSvc, genreService, gatheringSvc) {
    // Set header
    $rootScope.showNormalNav = true;

    $scope.haveAllGamesBeenRetrieved = false;

    var setCurrentGenre = function (genreDetails) {
        $scope.genreDetails = genreDetails;

        // Retrieve the currently open Genre Identifier from the array
        // Set the full genre as the current one.
        $scope.currentGenre = $scope.genreDetails.reduce(function (memory, genre) {
            if (memory) {
                    return memory;
                }
                else {
                    if (genre.functionalId === $routeParams.functionalId) {
                        return genre;
                    }
                }
                return null;
            }, null);
        //Set meta descriptions to have correct values
        $rootScope.metaTitle = "All " + $scope.currentGenre.title + " Games - GameHouse";
        $rootScope.metaDescription = $scope.currentGenre.description;
    };
    genreService.getGenreDetails().then(setCurrentGenre);

    // Wrapper function to make it easier to retrieve genre games based on the selected sorting
    var getCategoryGames= function (isFirstCall) {
        var pageSize = 28;
        if (!isFirstCall) {
            pageSize = 1000;
        }
        var sortBy = $rootScope.genrePageSorting.selectedOption.propertyBackend;
        var sortOrder = ($rootScope.genrePageSorting.selectedOption.reverse ? "DESC" : "ASC");
        return gameDataSvc.getCategoryGames($routeParams.functionalId, 0, pageSize, sortBy, sortOrder);
    };

    // load the first 28 games of the category
    // (we don't load all of them because of performance issues)
    getCategoryGames(true).success( function(firstGamesInCategory) {
        if (!firstGamesInCategory.error && firstGamesInCategory && firstGamesInCategory.gameList && (firstGamesInCategory.gameList.length > 0)) {
            $scope.allGamesInCategory = firstGamesInCategory.gameList;
            // load the rest of the games in the genre
            getCategoryGames(false).success( function(restGamesInCategory) {
                if (!restGamesInCategory.error) {
                    $scope.allGamesInCategory = restGamesInCategory.gameList;
                    $scope.haveAllGamesBeenRetrieved = true;
                    // apply sorting, use the latest sorting used
                    $scope.updateSorting($rootScope.genrePageSorting.selectedOption.id);
                } else {
                    // error detected
                    gatheringSvc.sendErrorInfo('genrePage getCategoryGamesFalse', 'Error: failed getting genre page secondary load. FunctionalId: ' + $routeParams.functionalId);
                }
            }).error( function() {
                // error detected
                gatheringSvc.sendErrorInfo('genrePage getCategoryGamesFalse', 'Error: failed getting genre page secondary load. FunctionalId: ' + $routeParams.functionalId);
            });
        } else {
            // error detected
            gatheringSvc.sendErrorInfo('genrePage getCategoryGames True', 'Error: failed getting genre page initial load. FunctionalId: ' + $routeParams.functionalId);
            $location.path('/');
        }
    }).error( function() {
        // error detected
        gatheringSvc.sendErrorInfo('genrePage getCategoryGames True', 'Error: failed getting genre page initial load. FunctionalId: ' + $routeParams.functionalId);
        $location.path('/');
    });

    $scope.updateSorting = function(sortingOptionId) {
        // find the correct selected option via sortingOptionId
        for (var i=0; i< $rootScope.genrePageSorting.sortingOptions.length; i++) {
            var currentOption = $rootScope.genrePageSorting.sortingOptions[i];
            if (currentOption.id === sortingOptionId) {
                $rootScope.genrePageSorting.selectedOption = currentOption;
                break;
            }
        }

        if (!$scope.haveAllGamesBeenRetrieved) {
            // we haven't retrieved all the games in the category yet. Sorting the initial batch only would lead
            // to strange behaviour, so instead make a new back-end call
            getCategoryGames(true).success( function(firstGamesInCategory) {
                if (!firstGamesInCategory.error && firstGamesInCategory && firstGamesInCategory.gameList && (firstGamesInCategory.gameList > 0)) {
                    $scope.allGamesInCategory = firstGamesInCategory.gameList;
                }
            });
        } else {
            // all the games in the category have been retrieved so we can sort on the front-end only
            $scope.allGamesInCategory = $filter('orderBy')($scope.allGamesInCategory, $rootScope.genrePageSorting.selectedOption.property, $rootScope.genrePageSorting.selectedOption.reverse);
        }
    };
}

GenrepageController.$inject = ['$rootScope', '$scope', '$routeParams', '$filter', '$location', 'gameDataSvc', 'genreService', 'gatheringSvc'];
module.exports = GenrepageController;

},{}],7:[function(require,module,exports){
var config = require('../config.js');

function HomeController(
  $rootScope,
  $scope,
  $timeout,
  gameDataSvc,
  gatheringSvc,
  seriesService
) {
  // Set header
  $rootScope.showNormalNav = true;

  // Check if browser is IE to show banner
  this.isBrowserIE = /MSIE|Trident/.test(window.navigator.userAgent);

  //-----------------------
  //Run homepage
  function initHomepage() {
    initUpcoming();
    initPromoNotification();
    initRecommended();
    initExclusive();
    initRecommendedBecauseYouPlayed();
    initNew();
    initTopPlayed();
    initCategories();
    initSeries();
    $rootScope.homeInitDone = true;
  }

  var initRecent = function() {
    gameDataSvc
      .getRecentGames($rootScope.recentGameLimit)
      .success(function(recentGames) {
        if (!recentGames.error) {
          if (recentGames.gameList.length === 0) {
            $rootScope.recentGames = null;
          } else {
            $rootScope.recentGames = recentGames.gameList;
          }
        } else {
          gatheringSvc.sendErrorInfo(
            'GetRecentGames',
            ' Error: failed getting recent games. Reason: ' + recentGames.error
          );
        }
      });
  };

  var initUpcoming = function() {
    gameDataSvc
      .getMostRecentUpcomingGame()
      .then(function(response) {
        if (response.data && !response.data.error) {
          $rootScope.upcomingGame = response.data;
          $rootScope.upcomingGame.feature = 'UPCOMING';
        } else {
          gatheringSvc.sendErrorInfo(
            'getMostRecentUpcomingGame',
            ' Error: failed getting most recent upcoming game. Reasons: Status: ' +
              response.status +
              '; Data: ' +
              response.data
          );
        }
      })
      .catch(function(response) {
        gatheringSvc.sendErrorInfo(
          'getMostRecentUpcomingGame',
          ' Error: failed getting most recent upcoming game. Reasons: Status: ' +
            response.status +
            '; Data: ' +
            response.data
        );
      });
  };

  var initPromoNotification = function() {
    gameDataSvc
      .getCarouselPromoNotification()
      .then(function(response) {
        if (response.data && !response.data.error) {
          $rootScope.promoNotification = response.data;
        } else {
          gatheringSvc.sendErrorInfo(
            'getCarouselPromoNotification',
            ' Error: failed getting promo notification. Reasons: Status: ' +
              response.status +
              '; Data: ' +
              response.data
          );
        }
      })
      .catch(function(response) {
        gatheringSvc.sendErrorInfo(
          'getCarouselPromoNotification',
          ' Error: failed getting promo notification. Reasons: Status: ' +
            response.status +
            '; Data: ' +
            response.data
        );
      });
  };

  var initNew = function() {
    gameDataSvc
      .getNewGames($rootScope.gameStartCount, $rootScope.newGameLimit)
      .success(function(games) {
        if (!games.error) {
          if (games.gameList.length === 0) {
            $rootScope.newGames = null;
          } else {
            $rootScope.newGames = games.gameList;
          }
          if ($rootScope.newGames !== null) {
            $rootScope.categoryCounter['newGames'] = parseInt(
              $rootScope.newGames.length
            );
            $rootScope.showLoadMore['newGames'] =
              games.gameListSize > $rootScope.newGameLimit;
          }
        } else {
          gatheringSvc.sendErrorInfo(
            'GetNewGames',
            ' Error: failed getting new games. Reason: ' + newGames.error
          );
        }
      });
  };

  var initRecommendedBecauseYouPlayed = function() {
    gameDataSvc
      .getRecommendedBecauseYouPlayedGames(
        $rootScope.recommendedBecauseYouPlayedGamesRequestedLimit
      )
      .success(function(recommendedBecauseYouPlayedGames) {
        if (!recommendedBecauseYouPlayedGames.error) {
          if (
            recommendedBecauseYouPlayedGames.gameList.length === 0 ||
            recommendedBecauseYouPlayedGames.gameBasedTitle === null
          ) {
            $rootScope.recommendedBecauseYouPlayedGames = null;
            $rootScope.recommendedBecauseYouPlayedGameTitle = null;
          } else {
            $rootScope.recommendedBecauseYouPlayedGamesRequested =
              recommendedBecauseYouPlayedGames.gameList;
            $rootScope.recommendedBecauseYouPlayedGames = $rootScope.recommendedBecauseYouPlayedGamesRequested.slice(
              0,
              $rootScope.recommendedBecauseYouPlayedGameLimit
            );
            $rootScope.recommendedBecauseYouPlayedGameTitle =
              recommendedBecauseYouPlayedGames.gameBasedTitle;
          }
        } else {
          gatheringSvc.sendErrorInfo(
            'GetRecommendedBecauseYouLikedGames',
            ' Error: failed getting item-based recommended games. Reason: ' +
              recommendedBecauseYouPlayedGames.error
          );
        }
      });
  };

  var initExclusive = function() {
    gameDataSvc
      .getExclusiveGames($rootScope.exclusiveLimit)
      .success(function(exclusiveGames) {
        if (!exclusiveGames.error) {
          if (exclusiveGames.items.length === 0) {
            $rootScope.exclusiveGames = null;
          } else {
            $rootScope.exclusiveGames = exclusiveGames.items;
          }
        } else {
          gatheringSvc.sendErrorInfo(
            'getExclusiveGames',
            ' Error: failed getting exclusive games. Reason: ' +
              recommendedGames.error
          );
        }
      });
  };

  var initRecommended = function() {
    // Total amount to be displayed in Hero image and recommended games bar
    var amountDisplayable =
      $rootScope.recommendedGameLimit + $rootScope.heroGamesLimit;

    gameDataSvc.getHomeCarousel().success(function(recommendedGames) {
      if (!recommendedGames.error) {
        if (recommendedGames.items.length === 0) {
          $rootScope.recommendedGames = null;
        } else {
          $rootScope.recommendedGames = recommendedGames.items;
        }

        if ($rootScope.recommendedGames !== null) {
          $rootScope.categoryCounter['recommendedGames'] = parseInt(
            $rootScope.recommendedGames.length
          );
          $rootScope.recommendedGamesRow = $rootScope.recommendedGames.slice(
            $rootScope.heroGamesLimit
          );
          $rootScope.showLoadMore['recommendedGames'] =
            recommendedGames.items.length >
            $rootScope.categoryCounter['recommendedGames'];
        }
      } else {
        gatheringSvc.sendErrorInfo(
          'GetHomeCarousel',
          ' Error: failed getting home carousel games. Reason: ' +
            recommendedGames.error
        );
      }
    });
  };

  var initTopPlayed = function() {
    gameDataSvc
      .getTopPlayedGames(config.topPlayed.homeLimit)
      .success(function(topPlayedGames) {
        if (!topPlayedGames.error) {
          $rootScope.topPlayedGames =
            topPlayedGames.size > 0 ? topPlayedGames.items : null;
        } else {
          gatheringSvc.sendErrorInfo(
            'getTopPlayed',
            ' Error: failed getting top plaed games. Reason: ' +
              recommendedGames.error
          );
        }
      });
  };

  var initCategories = function() {
    gameDataSvc
      .getAllCategories('allCategories')
      .success(function(allCategories) {
        if (!allCategories.error) {
          Object.keys(allCategories).length === 0
            ? ($rootScope.allCategories = null)
            : ($rootScope.allCategories = allCategories);
        } else {
          gatheringSvc.sendErrorInfo(
            'GetAllCategories',
            ' Error: failed getting all categories. Reason: ' +
              allCategories.error
          );
        }
      })
      .then(function() {
        angular.forEach($rootScope.allCategories, function(value) {
          gameDataSvc
            .getCategoryGames(
              value.functionalId,
              $rootScope.gameStartCount,
              $rootScope.categoryGameLimit
            )
            .success(function(categoryGames) {
              if (!categoryGames.error) {
                var gameList;
                if (categoryGames.gameList.length === 0) {
                  gameList = null;
                } else {
                  gameList = categoryGames.gameList;
                }
                if (gameList !== null) {
                  $rootScope.allCategoryGames[value.functionalId] = gameList;
                  $rootScope.categoryCounter[value.functionalId] =
                    categoryGames.gameListSize;
                  $rootScope.showLoadMore[value.functionalId] =
                    categoryGames.gameListSize > gameList.length;
                }
              } else {
                gatheringSvc.sendErrorInfo(
                  'GetCategoryGames',
                  ' Error: failed getting ' +
                    value.functionalId +
                    ' games. Reason: ' +
                    categoryGames.error
                );
              }
            });
        });
      });
  };

  var initSeries = function() {
    seriesService.getSeriesDetails().then(function(seriesDetails) {
      $rootScope.allSeries = seriesDetails.slice(0, $rootScope.seriesLimit);
    });
  };

  //--------------------------
  // "Load More" events for games
  $scope.loadMoreNewGames = function() {
    $rootScope.tagEvent('home-new-more-games-click', { 'ui-position': 0 });

    gameDataSvc
      .getNewGames(
        Math.floor(
          $rootScope.categoryCounter['newGames'] / $rootScope.moreGameLimit
        ),
        $rootScope.moreGameLimit
      )
      .success(function(games) {
        if (!games.error) {
          $rootScope.newGames.push.apply($rootScope.newGames, games.gameList);
          $rootScope.categoryCounter['newGames'] = parseInt(
            $rootScope.newGames.length
          );
          $rootScope.showLoadMore['newGames'] =
            games.gameListSize > $rootScope.categoryCounter['newGames'];
        } else {
          gatheringSvc.sendErrorInfo(
            'GetNewGames',
            ' Error: failed getting MORE new games. Reason: ' + games.error
          );
        }
      });
  };
  $scope.showMyGames = function() {
    $rootScope.tagEvent('home-my-games-click', { 'ui-position': 0 });
  };
  $scope.showMoreTopPlayedGames = function() {
    $rootScope.tagEvent('home-top-played-more-games-click', {
      'ui-position': 0
    });
  };
  $scope.showExclusiveGames = function() {
    $rootScope.tagEvent('home-exclusive-more-games-click', {
      'ui-position': 0
    });
  };
  $scope.showAllCategoryGames = function(category) {
    $rootScope.tagEvent('home-categories-more-games-click', {
      'ui-position': 0
    });
  };

  if ($rootScope.homeInitDone === false) {
    initHomepage();
  } else {
    // only refresh rows that can change often depending on the behavior of the user
    initRecent();
  }

  angular.element(document).ready(function() {
    $timeout(function() {
      $rootScope.loading = true;
    }, 10);
  });
}

HomeController.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  'gameDataSvc',
  'gatheringSvc',
  'seriesService'
];
module.exports = HomeController;

},{"../config.js":1}],8:[function(require,module,exports){
function MyAccountMembershipController(
  $rootScope,
  $scope,
  $routeParams,
  accountService,
  $timeout,
  $location,
  $interval,
  gatheringSvc,
  userSvc,
  messageService
) {
  userSvc.getPlayer().then(function(response) {
    if (!response.data || !response.data.isLoggedIn) {
      $rootScope.login('myaccount-auto-redirect');
    }

    $scope.currentPlayer = response.data;
  });

  $scope.titleCase = function(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  };

  // Set header
  $rootScope.showNormalNav = true;

  $scope.timer = null;
  $scope.loading = true;

  // Fetch the first name from cache or server (fallback)
  accountService.getName().then(function(name) {
    $scope.firstName = name;
  });

  var loadMembershipDetails = function() {
    accountService.getEntitlement().then(setMembershipDetails);
  };

  var setMembershipDetails = function(response) {
    if ($scope.loading) {
      $rootScope.$broadcast('modal.close');
    }

    $scope.loading = false;
    $scope.membership = response.data;
    $rootScope.membership = $scope.membership;
    if ($scope.membership) {
      //When not all data is synced in the background, check every second for the data to be synced
      if (!$scope.membership.synced && $scope.timer == null) {
        $scope.timer = $interval(reloadData, 1000);
      }
    }
  };

  var reloadData = function() {
    if ($scope.membership.synced) {
      if ($scope.timer) {
        $interval.cancel($scope.timer);
        $scope.timer = null;
      }
    }

    loadMembershipDetails();
  };

  $scope.isActiveMember = function() {
    if ($scope.membership) {
      if (
        $scope.membership.status === 'ACTIVE' ||
        $scope.membership.status === 'PENDING'
      ) {
        return true;
      }
      return false;
    }

    return undefined;
  };

  $scope.isDiscountSubscription = function() {
    if ($scope.membership) {
      if (
        $scope.membership.subscriptionType === 'DISCOUNT' &&
        $scope.isCancelledMember()
      ) {
        return true;
      }
      return false;
    }
  };

  $scope.isCancelledMember = function() {
    if ($scope.membership) {
      var isActive = $scope.membership.status === 'ACTIVE';
      var today = moment();
      var endDate = $scope.membership.endDateISO
        ? moment($scope.membership.endDateISO)
        : null;
      var canUndo = !endDate || (endDate && today.isBefore(endDate));
      if (!isActive && canUndo) {
        return true;
      }
      return false;
    }

    return undefined;
  };

  $scope.hasUnprocessedPaymentTasks = function() {
    if ($scope.membership) {
      return $scope.membership.hasUnprocessedPaymentMethodTasks;
    }

    return undefined;
  };

  $scope.openCancelMembershipDialog = function() {
    // The modal is part of the rootScope, not the local scope, so we
    // have to hoist everything into the rootScope to be able to access
    // it :-(
    $rootScope.cancellationSurvey = [
      {
        questionId: 1,
        text: 'What is the main reason for canceling your Membership?',
        answers: [
          {
            answerId: 1,
            text: 'I no longer use my Membership',
            answers: [
              {
                answerId: 1,
                text: 'Not enough time to play'
              },
              {
                answerId: 2,
                text: 'I don’t like the games'
              },
              {
                answerId: 3,
                text: 'Other:'
              }
            ]
          },
          {
            answerId: 2,
            text: 'Financial reasons',
            answers: [
              {
                answerId: 1,
                text: 'Not enough value for money'
              },
              {
                answerId: 2,
                text: 'Change in financial priorities'
              },
              {
                answerId: 3,
                text: 'I don’t want to be charged monthly'
              },
              {
                answerId: 4,
                text: 'Other:'
              }
            ]
          },
          {
            answerId: 3,
            text: 'Technical difficulties',
            answers: [
              {
                answerId: 1,
                text: 'Downloading & installing issues'
              },
              {
                answerId: 2,
                text: 'In-game issues'
              },
              {
                answerId: 3,
                text: 'Payment issues'
              },
              {
                answerId: 4,
                text: 'Other:'
              }
            ]
          },
          {
            answerId: 4,
            text: 'Game Content',
            answers: [
              {
                answerId: 1,
                text: 'I am not happy with the quality of the games'
              },
              {
                answerId: 2,
                text: 'I am not happy with the variety of genres,',
                textInputPrefix: 'I want more ',
                textInputPostfix: ' games'
              },
              {
                answerId: 3,
                text: 'Other:'
              }
            ]
          },
          {
            answerId: 5,
            text: 'I can’t use my Membership on my tablet or mobile device'
          },
          {
            answerId: 6,
            text: 'Other:'
          }
        ]
      },
      {
        questionId: 2,
        text:
          'What could we improve to make you want to continue using your Membership?'
      }
    ];

    $rootScope.cancellationSurveyResults = {
      question1: {
        text: $rootScope.cancellationSurvey[0].text,
        answerId: null,
        answerText: null,
        followUpAnswerId: null,
        followUpAnswerText: null,
        freeUserInput: null,
        freeUserInputs: {
          answer1Answer3: null,
          answer2Answer4: null,
          answer3Answer4: null,
          answer4Answer2: null,
          answer4Answer3: null,
          answer6: null
        }
      },
      question2: {
        text: $rootScope.cancellationSurvey[1].text,
        freeUserInput: null
      }
    };
    $rootScope.showLoadingAnimation = false;

    $rootScope.cancellationSurveySelectQuestion1Answer = function(answerId) {
      $rootScope.cancellationSurveyResults.question1.followUpAnswerId = null;
      $rootScope.cancellationSurveyResults.question1.followUpAnswerText = null;
      $rootScope.cancellationSurveyResults.question1.freeUserInput = null;
      $rootScope.cancellationSurveyResults.question1.answerId = answerId;
    };

    $rootScope.cancelMembership = function() {
      // clean up results so we can pass it to datagathering
      // without freaking out BI
      var results = $rootScope.cancellationSurveyResults;
      if (results.question1.followUpAnswerId === 'question1-answer1-answer3') {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer1Answer3;
      } else if (
        results.question1.followUpAnswerId === 'question1-answer2-answer4'
      ) {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer2Answer4;
      } else if (
        results.question1.followUpAnswerId === 'question1-answer3-answer4'
      ) {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer3Answer4;
      } else if (
        results.question1.followUpAnswerId === 'question1-answer4-answer2'
      ) {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer4Answer2;
      } else if (
        results.question1.followUpAnswerId === 'question1-answer4-answer3'
      ) {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer4Answer3;
      } else if (results.question1.answerId === 'question1-answer6') {
        results.question1.freeUserInput =
          results.question1.freeUserInputs.answer6;
      }

      // send results to datagathering
      gatheringSvc.cancelSubscription($rootScope.cancellationSurveyResults);
      $rootScope.showLoadingAnimation = true;
      $scope.loading = true;

      // try to cancel the membership and reload the player's details
      accountService.cancelMembership().then(loadMembershipDetails);
    };

    $rootScope.inputFocus = function(answerId) {
      // wrap the click call in a timeout to avoid problems with the digest cycle:
      // https://docs.angularjs.org/error/$rootScope/inprog?p0=$apply
      $timeout(
        function() {
          document.getElementById(answerId).click();
        },
        0,
        false
      );
    };

    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/cancelSubscription.html'
    });
  };

  $scope.openUndoCancellationDialog = function() {
    $rootScope.tagEvent('account-body-member-renew-click');
    gatheringSvc.sendClickTracking('myaccount', 'Show renew membership popup');
    $rootScope.showLoadingAnimation = false;
    $rootScope.keepMembership = function() {
      $rootScope.showLoadingAnimation = true;
      $scope.loading = true;
      accountService.keepMembership().then(loadMembershipDetails);
      gatheringSvc.sendClickTracking('myaccount', 'Clicked keep membership');
      messageService.removeSubscriptionExpiringMessage();
    };
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/undoCancellation.html'
    });
  };

  $scope.navigateToPaymentUpdate = function() {
    $rootScope.tagEvent('account-body-member-update-click');
    $rootScope.zuoraErrorMessage = null;
    const planName =
      'one-' +
      $scope.membership.billingFrequencyPeriod +
      '-' +
      $scope.membership.price +
      '-';
    $location.path('/paymentupdate').search('plan', planName);
  };

  loadMembershipDetails();
}

MyAccountMembershipController.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  'accountService',
  '$timeout',
  '$location',
  '$interval',
  'gatheringSvc',
  'userSvc',
  'messageService'
];
module.exports = MyAccountMembershipController;

},{}],9:[function(require,module,exports){
function MyAccountPasswordController ($rootScope, $scope, accountService, userSvc, $location) {
    userSvc.getPlayer().then(function(response){
        if(!response.data || !response.data.isLoggedIn){
            $rootScope.login('myaccount-auto-redirect');
        }

        $scope.currentPlayer = response.data;
    });

    // Set header
    $rootScope.showNormalNav = true;

    $scope.busy = false; // keep track of in-progress HTTP-POST-calls

    // Set some defaults
    $scope.showPassword = false;

    $scope.changePassword = {
        oldPassword: '',
        newPassword: ''
    };


    // Fetch the first name from cache or server (fallback)
    accountService.getName().then(function (name) {
        $scope.firstName = name;
    });



    $scope.submitPasswordChange = function () {
        if ($scope.busy === true) {
            return;
        }

        // Do not submit of there are errors in the form
        if ($scope.changePassword.$valid !== true) {
            return;
        }

        $scope.busy = true;

        // Reset error messages
        $scope.changePasswordErrors = {};

        // Do the request to change the password
        accountService.changePassword($scope.changePassword).then(passwordChangeSuccess, passwordChangeError);
    };


    var passwordChangeSuccess = function () {
        $scope.busy = false;

        // Reset the form
        $scope.changePassword.newPassword = '';
        $scope.changePassword.oldPassword = '';
        $scope.changePassword.$setPristine();

        // Send notification
        $rootScope.$broadcast('notification:confirm', 'Your account has been updated!');
    };


    var passwordChangeError = function (response) {
        $scope.busy = false;

        // Set error messages for use in the view
        $scope.changePasswordErrors = accountService.getErrors(response);

        // Send notification
        $rootScope.$broadcast('notification:error', 'Something went wrong changing your password.');
    };

}

MyAccountPasswordController.$inject = ['$rootScope', '$scope', 'accountService', 'userSvc', '$location'];
module.exports = MyAccountPasswordController;
},{}],10:[function(require,module,exports){
function MyAccountPrivacyController(
  $rootScope,
  $scope,
  $window,
  $location,
  accountService,
  userSvc
) {
  $scope.currentPlayer = undefined;

  userSvc.getPlayer().then(function(response) {
    if (!response.data || !response.data.isLoggedIn) {
      $rootScope.login('myaccount-auto-redirect');
    }

    $scope.currentPlayer = response.data;
  });

  // Set header
  $rootScope.showNormalNav = true;

  $scope.busy = false; // keep track of in-progress HTTP-POST-calls
  $scope.canDeleteAccount = false;

  accountService.getEntitlement().then(function(response) {
    const entitlement = response.data;
    $scope.canDeleteAccount =
      entitlement === null || entitlement.status !== 'ACTIVE';
  });

  // Sets the account details from the response
  const setAccount = function setAccount(response) {
    const account = response.data;
    $scope.firstName = account.name;
  };

  // Initiate fetching the account details
  const loadAccountDetails = function loadAccountDetails() {
    accountService.getAccount().then(setAccount);
  };

  $scope.goToPreferences = function goToPreferences() {
    $location.path('/my-account/settings');
  };

  const vmScope = $scope;

  $scope.checkEntitlement = function checkEntitlement() {
    if ($scope.canDeleteAccount) {
      $rootScope.$broadcast('modal.open', {
        templateUrl: 'popups/removeMyAccount.html',
        controller: function removeAccountController($scope) {
          $scope.removeMyAccount = function onRemoveMyAccount() {
            $scope.error = undefined;
            $scope.showLoadingAnimation = true;
            $scope.loading = true;
            accountService
              .removeAccount($scope.password)
              .then(function() {
                setTimeout(function onSetTimeout() {
                  $rootScope.$broadcast('modal.close');
                  setTimeout(function onSetTimeout() {
                    $rootScope.$broadcast('modal.open', {
                      controller: function($scope) {
                        $scope.goToHomepage = function goToHomepage() {
                          $window.location.href = '/';
                        };
                      },
                      templateUrl: 'popups/accountRemoved.html'
                    });
                  }, 100);
                }, 10 * 1000);
              })
              .catch(function(err) {
                $scope.showLoadingAnimation = false;
                $scope.password = undefined;
                $scope.error = err.data.error;
                setTimeout(function() {
                  $scope.error = undefined;
                }, 3000);
              });
          };
        }
      });
    } else {
      $rootScope.goToMyMembership = function goToMyMembership() {
        $location.path('/my-account/membership');
      };
      $rootScope.$broadcast('modal.open', {
        templateUrl: 'popups/pleaseUnsubscribeFirst.html'
      });
    }
  };

  $scope.onPasswordVerified = function onPasswordVerified() {
    $scope.password = null;
    $scope.passwordInvalid = false;
    $rootScope.$broadcast('modal.close');
    setTimeout(function() {
      vmScope.checkEntitlement();
    }, 50);
  };

  $scope.openRemoveMyAccountDialog = function openRemoveMyAccountDialog() {
    if ($scope.busy === true) {
      return;
    }
    $rootScope.showLoadingAnimation = false;
    $scope.busy = true;

    if ($scope.currentPlayer.isPasswordLess === true) {
      $scope.onPasswordVerified();
    } else {
      // Password verify
      $rootScope.$broadcast('modal.open', {
        controller: function controller($scope) {
          $scope.password = null;
          $scope.passwordInvalid = false;
          $scope.validatePassword = function validatePassword() {
            $scope.error = undefined;
            $scope.showLoadingAnimation = true;
            $scope.loading = true;
            accountService
              .verifyPassword($scope.password)
              .then(function() {
                vmScope.onPasswordVerified();
              })
              .catch(function(err) {
                $scope.passwordInvalid = true;
                $scope.showLoadingAnimation = false;
                $scope.password = undefined;
                $scope.error = err.data.error;
                setTimeout(function() {
                  $scope.error = undefined;
                }, 3000);
              });
          };
        },
        templateUrl: 'popups/askPasswordConfirmation.html'
      });
    }
    $scope.busy = false;
  };

  loadAccountDetails();
}

MyAccountPrivacyController.$inject = [
  '$rootScope',
  '$scope',
  '$window',
  '$location',
  'accountService',
  'userSvc'
];
module.exports = MyAccountPrivacyController;

},{}],11:[function(require,module,exports){
function MyAccountProfileController ($rootScope, $scope, accountService, userSvc, $location) {
    userSvc.getPlayer().then(function(response){
        if(!response.data || !response.data.isLoggedIn){
            $rootScope.login('myaccount-auto-redirect');
        }

        $scope.currentPlayer = response.data;
    });

    // Set header
    $rootScope.showNormalNav = true;

    $scope.busy = false; // keep track of in-progress HTTP-POST-calls


    // Initiate fetching the account details
    var loadAccountDetails = function () {
        accountService.getAccount().then(setAccount);
    };


    // Sets the account details from the response
    var setAccount = function (response) {
        var account = response.data;
        $scope.firstName = account.name;
        $scope.account = angular.copy(account);
    };


    $scope.submitAccountDetails = function () {
        if ($scope.busy === true) {
            return;
        }

        // Do not submit of there are errors in the form
        if ($scope.profile.$valid !== true) {
            return;
        }

        $scope.busy = true;

        // Reset the error messages
        $scope.accountErrors = {};

        // Request to change the details
        accountService.setAccount($scope.account).then(accountSuccess, accountError);
    };


    var accountSuccess = function () {
        $scope.busy = false;

        // Re-load the account details
        loadAccountDetails();

        // Reset the form status to unsubmitted
        $scope.profile.$setPristine();

        //Reload the user object on the scope
        userSvc.getPlayer().then(function(response) {
            $rootScope.player = response.data;
        });

        // Show a notification
        $rootScope.$broadcast('notification:confirm', 'Your account has been updated!');
        
    };


    var accountError = function (response) {
        $scope.busy = false;

        // Set the error messages for use in the view
        $scope.accountErrors = accountService.getErrors(response);

        // Show a notification
        $rootScope.$broadcast('notification:error', 'Something went wrong saving your account.');
    };

    loadAccountDetails();

}

MyAccountProfileController.$inject = ['$rootScope', '$scope', 'accountService', 'userSvc', '$location'];
module.exports = MyAccountProfileController;
},{}],12:[function(require,module,exports){
function MyAccountPurchasedGamesController ($rootScope, $scope, accountService, userSvc, $location) {

    userSvc.getPlayer().then(function(response){
        if(!response.data || !response.data.isLoggedIn){
            $rootScope.login('myaccount-auto-redirect');
        }

        loadLegacyGames(response.data);
    });

    // Set header
    $rootScope.showNormalNav = true;

    // Fetch the first name from cache or server (fallback)
    accountService.getName().then(function (name) {
        $scope.firstName = name;
    });

    var loadLegacyGames = function (player) {
        $scope.currentPlayer = player;
        // Fetches legacy games
        accountService.getLegacyGames($scope.currentPlayer.legacyId).then(function (response) {
            $scope.games = response.data.games;

            for (var i = 0; i < $scope.games.length; i++) {
                if ($scope.games[i].downloadLink == '') {
                    $scope.games.splice(i, 1);
                }
            }
        });
    }
}

MyAccountPurchasedGamesController.$inject = ['$rootScope', '$scope', 'accountService', 'userSvc', '$location'];
module.exports = MyAccountPurchasedGamesController;
},{}],13:[function(require,module,exports){
function MyAccountSettingsController ($rootScope, $scope, accountService, userSvc, $location) {
    userSvc.getPlayer().then(function(response){
        if(!response.data || !response.data.isLoggedIn){
            $rootScope.login('myaccount-auto-redirect');
        }

        $scope.currentPlayer = response.data;
    });

    // Set header
    $rootScope.showNormalNav = true;

    $scope.busy = false; // keep track of in-progress HTTP-POST-calls

    // Initiate fetching the account details
    var loadAccountDetails = function () {
        accountService.getAccount().then(setAccount);
    };


    // Sets the account details from the response
    var setAccount = function (response) {
        var account = response.data;
        $scope.firstName = account.name;
        $scope.account = angular.copy(account);
    };


    $scope.submitAccountSettings = function () {
        if ($scope.busy === true) {
            return;
        }

        // Do not submit of there are errors in the form
        if ($scope.profile.$valid !== true) {
            return;
        }

        $scope.busy = true;

        // Reset the error messages
        $scope.accountErrors = {};

        $rootScope.tagEvent('account-body-prefs-update-click', {'newsletter': $scope.account.newsletterActive, 'quickplay': $scope.account.preloadingEnabled});

        // Request to change the details
        accountService.setAccountSettings($scope.account).then(accountSuccess, accountError);
    };

    $scope.togglePreloadingHelp = function () {
        $("#preloading_help_text").slideToggle();
    };

    var accountSuccess = function () {
        $scope.busy = false;

        // Re-load the account details
        loadAccountDetails();

        // Reset the form status to unsubmitted
        $scope.profile.$setPristine();

        // Show a notification
        $rootScope.$broadcast('notification:confirm', 'Your account has been updated!');

    };


    var accountError = function (response) {
        $scope.busy = false;

        // Set the error messages for use in the view
        $scope.accountErrors = accountService.getErrors(response);

        // Show a notification
        $rootScope.$broadcast('notification:error', 'Something went wrong saving your account.');
    };

    loadAccountDetails();
}

MyAccountSettingsController.$inject = ['$rootScope', '$scope', 'accountService', 'userSvc', '$location'];
module.exports = MyAccountSettingsController;
},{}],14:[function(require,module,exports){
/**
 * Created by evaniersel on 19-8-2016.
 */

function MyGamesController ($rootScope, $scope, gameDataSvc, amiSvc, messageService) {

    // Set header
    $rootScope.showNormalNav = true;

    $scope.categoryTitle = 'My Games';

    $scope.myGamesList = [];

    //Play logic copied from directive
    $scope.clickPlay = function (game, index, angularEvent) {
        if (game === null || game.id === null) {
            game.id = 0;
        }
        //Log the click on play
        $rootScope.sendClickTracking('mygames_item-' + (index+1), 'play_id-' + game.id);
        $rootScope.playGame(game, 'mygames-play-click', index, angularEvent);
    };

    //More info logic copied from directive
    $scope.clickInfo = function (game, index) {
        if (game === null || game.id === null) {
            game.id = 0;
        }
        $rootScope.sendClickTracking('mygames_item-' + (index+1), 'more-info_id-' + game.id);
        $rootScope.tagEvent('mygames-more-info-click', {'game-name': game.title, 'genre-name': game.genre.title, 'game-id': game.id, 'ui-position': index});
    };

    $scope.removeGameFromRecentlyPlayed = function (game) {
        angular.element('.item-' + game.id).addClass('fade-out');
        setTimeout(function(){
            angular.element('.item-' + game.id).css('display', 'none');
        }, 1000);
        //Remove recently played from database
        gameDataSvc.removeplayerrecentlyplayed(game.id);
        //Remove the game from the pc
        amiSvc.uninstall(game.contentId);
        //Remove from messagelist
        messageService.removeGameMessage(game.contentId);

        $rootScope.sendClickTracking('mygames_gameId-' + game.id, 'uninstall');
    };

    var reversedMessageList = $rootScope.messageList.slice();
    reversedMessageList.reverse();
    reversedMessageList.forEach(function (messageGame) {
        if(messageGame.type === 'game' &&
            $scope.myGamesList.indexOf(messageGame.contentId) === -1) {
            var contentId = messageGame.contentId;
            if($rootScope.gameManager.sessionGamesInfo[contentId]){
                if($rootScope.gameManager.sessionGamesInfo[contentId].state !== 'stopped' &&
                    $rootScope.gameManager.sessionGamesInfo[contentId].state !== 'deleted'){
                    $scope.myGamesList.push(contentId);
                }
            } else {
                $scope.myGamesList.push(contentId);
                gameDataSvc.getSpecificGameByContentId(contentId).success(function (data) {
                    if (data && data.id) {
                        amiSvc.insertGame(data);
                    } else {
                        $scope.myGamesList.splice($scope.myGamesList.indexOf(contentId), 1);
                    }
                });
            }
        }
    });
    gameDataSvc.getAllRecentGames().success(function(recentGames) {
        if(!recentGames.error) {
            recentGames.gameList.forEach(function (recentGame) {
                var contentId = recentGame.contentId;
                if($scope.myGamesList.indexOf(contentId) === -1){
                    $scope.myGamesList.push(contentId);
                    if(!$rootScope.gameManager.sessionGamesInfo[contentId]){
                        gameDataSvc.getSpecificGameByContentId(contentId).success(function (data) {
                            if (data && data.id) {
                                amiSvc.insertGame(data);
                            } else {
                                $scope.myGamesList.splice($scope.myGamesList.indexOf(contentId), 1);
                            }
                        });
                    }
                }
            });
        }
        //Retrieve all installed games and add them if they are not already in the recently played list.
        amiSvc.getInstalledGames(
            function(installedGames) {
                installedGames.forEach(function (installedGame) {
                    var contentId = installedGame.content_id;
                    if($scope.myGamesList.indexOf(contentId) === -1){
                        $scope.myGamesList.push(contentId);
                        if(!$rootScope.gameManager.sessionGamesInfo[contentId]){
                            gameDataSvc.getSpecificGameByContentId(contentId).success(function (data) {
                                if (data && data.id) {
                                    amiSvc.insertGame(data);
                                } else {
                                    $scope.myGamesList.splice($scope.myGamesList.indexOf(contentId), 1);
                                }
                            });
                        }
                    }
                });
            }
        );
        //Push installing games to the front no mather where they are.
        $rootScope.messageList.forEach(function (messageGame) {
            if(messageGame.type === 'game' &&
                messageGame.status === 'installing') {
                var contentId = messageGame.contentId;
                $scope.myGamesList.splice($scope.myGamesList.indexOf(contentId), 1);
                $scope.myGamesList.unshift(contentId);
            }
        });
    });
}

MyGamesController.$inject = ['$rootScope', '$scope', 'gameDataSvc', 'amiSvc', 'messageService'];
module.exports = MyGamesController;
},{}],15:[function(require,module,exports){
function PaymentCallbackController(
  $rootScope,
  $scope,
  $routeParams,
  userSvc,
  gatheringSvc,
  customPaymentService,
  $location
) {
  //Check if player is logged in (global load is sometimes to late), need to redesign to more efficient way.
  userSvc.getPlayer().then(function(response) {
    if (!response.data) {
      $location.path('/');
    } else {
      if (response.data.isEntitled && !isPaymentUpdate()) {
        $location.path('/');
      }
      if (!response.data.isLoggedIn) {
        $location.path('/signup');
      }
    }
  });

  //When payment error
  $rootScope.$on('payment:error', function(event, response) {
    var plan = '';
    if (response.data.planName) {
      plan = response.data.planName;
    }
    $rootScope.zuoraErrorMessage = response.data.errorMessage;
    $location.url(response.data.path).search('plan', plan);
  });

  // When a payment has been done
  var paymentDone = $rootScope.$on('payment:done', function(event, response) {
    $rootScope.tagEvent('payment-success');

    //Retrieve the latest player details with the correct entitlement status so the user can play!
    userSvc
      .getPlayer()
      .then(function(response) {
        $rootScope.player = response.data;

        if (!response.data) {
          gatheringSvc.sendErrorInfo(
            'GetPlayer',
            ' Error: failed getting player after subscribing / ' +
              response.error
          );
        }
      })
      .then(function() {
        //When we retrieved the player account send them to either myaccount if payment details are updated or the success page.
        if (isPaymentUpdate(response)) {
          $location.url('/my-account/membership/updated');
        } else {
          $location.url('/success' + (response.promoName ? '/promo' : ''));
        }
      });
  });

  var isPaymentUpdate = function(response) {
    var path = $routeParams.field_passthrough1;
    if (response && response.data) {
      path = response.data.path;
    }
    if (typeof path === 'undefined') {
      return true;
    }
    return path.indexOf('/paymentupdate') != -1;
  };
  $scope.paymentUpdate = isPaymentUpdate();

  $scope.$on('$destroy', function() {
    paymentDone();
  });

  customPaymentService.handleCallback($routeParams);
}

PaymentCallbackController.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  'userSvc',
  'gatheringSvc',
  'customPaymentService',
  '$location'
];
module.exports = PaymentCallbackController;

},{}],16:[function(require,module,exports){
/* eslint-disable */
function PaymentController(
  $rootScope,
  $sce,
  $scope,
  $location,
  $routeParams,
  $cookies,
  userSvc,
  gatheringSvc,
  customPaymentService,
  abtestService,
  PromoService
) {
  $location.search('planName', null);

  $scope.isPromo = function() {
    return $location.path().indexOf('/promo/') != -1;
  };
  $scope.promoInfo = {};

  const planName = $routeParams.plan;
  const promoName = $routeParams.promo;
  const promoCode = $routeParams.code;
  if (!$scope.isPromo() && (!planName || planName === '')) {
    if ($location.path().indexOf('/paymentupdate') != -1) {
      return $location.path('/my-account/membership');
    }
    return $location.path('/membership-plans');
  }

  if (!$scope.isPromo()) {
    const plan_parts = planName.split('-');
    $scope.price = plan_parts[2];
    $scope.period = plan_parts[1];
  } else {
    PromoService.promoInfo(promoName).then(function(promoInfo) {
      $scope.promoInfo = promoInfo.data;
    });
  }

  var loadScript = function(url, type, charset) {
    if (type === undefined) type = 'text/javascript';
    if (url) {
      var script = document.querySelector("script[src*='" + url + "']");
      if (!script) {
        var heads = document.getElementsByTagName('head');
        if (heads && heads.length) {
          var head = heads[0];
          if (head) {
            script = document.createElement('script');
            script.setAttribute('src', url);
            script.setAttribute('type', type);
            if (charset) script.setAttribute('charset', charset);
            head.appendChild(script);
          }
        }
      }
      return script;
    }
  };

  var endpoint = '/api/v1/payment-system/zuora.js?product_id=1234567890';
  var library = loadScript(endpoint, 'text/javascript', 'utf8');

  var waitUntilLoaded = function() {
    setTimeout(checkLoaded, 150);
  };

  var checkLoaded = function() {
    if (!window.payment_form) {
      return waitUntilLoaded();
    }
    paymentFormLoaded();
  };

  var paymentFormLoaded = function() {
    var isPaymentUpdate = function() {
      return $location.path().indexOf('/paymentupdate') != -1;
    };

    $scope.paymentUpdate = isPaymentUpdate();

    //Check if player is logged in (global load is sometimes to late), need to redesign to more efficient way.
    if (!$scope.isPromo()) {
      userSvc.getPlayer().then(function(response) {
        if (!response.data) {
          $location.path('/');
        } else {
          if (response.data.isEntitled && !isPaymentUpdate()) {
            $location.path('/');
          }
          if (!response.data.isLoggedIn) {
            if (planName !== '') {
              $location.path('/signup').search('planName', planName);
            } else {
              $location.path('/signup');
            }
          }
        }
      });
    }

    // set current path
    $scope.currentPath = $location.path();

    $scope.plan = !$scope.isPromo() ? planName : '';
    $scope.promo = $scope.isPromo() ? promoName : '';
    $scope.code = $scope.isPromo() ? promoCode : '';

    // Set header adjustments for payment flow
    $rootScope.showNormalNav = false;

    //set the default payment method to paypal
    $scope.paymentmethod = 'paypal';

    if ($rootScope.zuoraErrorMessage) {
      $scope.errorMessage = $rootScope.zuoraErrorMessage;
      $scope.paymentmethod = 'creditcard';
    }

    var isPayPal = function() {
      return $scope.paymentmethod === 'paypal';
    };

    if (isPayPal() && $routeParams && $routeParams.message) {
      if ($routeParams.message === 'error') {
        $scope.errorMessage =
          'Something went wrong while processing your PayPal account. Please try again or contact us for help.';
      } else if ($routeParams.message === 'cancelled') {
        $scope.errorMessage =
          'You did not complete your payment via PayPal. Please try again or select another payment method below.';
      } else {
        $scope.errorMessage = $routeParams.message;
      }
    }

    $scope.$watch('paymentmethod', function(newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.errorMessage = '';
      }
    });

    var loadPaymentMethodDetails = function() {
      customPaymentService
        .getPaymentMethodDetails()
        .then(setPaymentMethodDetails);
    };

    var loadPaymentFormSelectFields = function() {
      customPaymentService
        .getPaymentFormSelectFields()
        .then(setPaymentFormSelectFields);
    };

    var setPaymentFormSelectFields = function(response) {
      $scope.paymentFormSelectFields = response.data;
    };

    var setPaymentMethodDetails = function(response) {
      $scope.zuoraPaymentDetails = response.data;
      $scope.zuoraPaymentDetails.paymentForm.uri = $sce.trustAsResourceUrl(
        $scope.zuoraPaymentDetails.paymentForm.uri
      );
    };

    var init = function() {
      $scope.cc = {};
      $scope.showLoader = false;
      setErrorMessages();
      window.payment_form.init($scope, $cookies);
    };

    var setErrorMessages = function() {
      $scope.requiredFieldMsg = 'Please fill in all of the required fields.';
      $scope.invalidCCNumMsg = 'Invalid Card Number';
      $scope.invalidCCTypeMsg = 'Invalid Card Type';
      $scope.invalidCVV = 'Invalid CVV Number';
    };

    $scope.submitPayment = function() {
      if (isPayPal()) {
        gatheringSvc.sendPaymentMethod($scope.paymentmethod);
        $scope.showLoader = true;
        var redirect;
        if (!$scope.isPromo()) {
          redirect =
            '/myaccount/api/paypal/billingagreement/' +
            (isPaymentUpdate() ? 'update' : 'subscribe') +
            '/' +
            (planName || promoName);
        } else {
          redirect =
            '/myaccount/api/paypal/billingagreement/promo/subscribe/' +
            (planName || promoName);
          if (promoCode && promoCode.length > 0) {
            redirect = redirect + '/' + promoCode;
          }
        }
        window.location.href = redirect;
      } else {
        $scope.paymentForm.$setSubmitted();
        if ($scope.paymentForm.$valid) {
          gatheringSvc.sendPaymentMethod($scope.paymentmethod);
          $scope.showLoader = true;
          $rootScope.tagEvent('payment-body-submit');
          window.payment_form.submit($scope, $cookies);
        }
      }
    };

    init();
    loadPaymentFormSelectFields();
    loadPaymentMethodDetails();
  };

  checkLoaded();
}

PaymentController.$inject = [
  '$rootScope',
  '$sce',
  '$scope',
  '$location',
  '$routeParams',
  '$cookies',
  'userSvc',
  'gatheringSvc',
  'customPaymentService',
  'abtestService',
  'PromoService'
];
module.exports = PaymentController;

},{}],17:[function(require,module,exports){
/**
 * Created by evaniersel on 13-6-2016.
 */
function PlanpageController(
  $rootScope,
  $scope,
  $location,
  $anchorScroll,
  gatheringSvc
) {
  $rootScope.showNormalNav = true;
  $scope.busy = false;
  $scope.scrollTo = function(id) {
    $location.hash(id);
    $anchorScroll();
  };

  $scope.setPlan = function(planName) {
    if ($scope.busy === true) {
      return;
    }
    $scope.busy = true;

    gatheringSvc.sendClickTracking('planpage', 'signUp');
    $location.path('/signup').search('planName', planName);
  };
}

PlanpageController.$inject = [
  '$rootScope',
  '$scope',
  '$location',
  '$anchorScroll',
  'gatheringSvc'
];
module.exports = PlanpageController;

},{}],18:[function(require,module,exports){
function PrivacyPolicyController($rootScope, $location, privacySvc, userSvc, welcomeLandingPageService) {
  const privacyVm = this;

  privacyVm.isRegistered = false;
  privacyVm.showBanner = false;

  function isPrivacyPolicyOutdated() {
    return privacySvc.isOutdated();
  }

  function moreInformation() {
    $rootScope.$broadcast('modal.open', {
      controller: 'PrivacyPolicyPopupController',
      templateUrl: 'popups/privacyPolicy.html'
    });
  }

  function showBanner(show) {
    privacyVm.showBanner = show;
    welcomeLandingPageService.showBannerChanged(show);
  }

  function gotIt() {
    privacySvc.acceptActiveVersion();
  }

  function goToTermsPage() {
    $location.path('/terms-of-service');
  }

  function goToCookiesPage() {
    $location.path('/cookie-policy');
  }

  privacyVm.isPrivacyPolicyOutdated = isPrivacyPolicyOutdated;
  privacyVm.moreInformation = moreInformation;
  privacyVm.gotIt = gotIt;
  privacyVm.goToTermsPage = goToTermsPage;
  privacyVm.goToCookiesPage = goToCookiesPage;

  function showPrivacyModal() {
    privacySvc.isOutdatedSync().then (function (privacyOutdated) {
      if (privacyOutdated) {
        userSvc
        .getPlayer()
        .then(function onSuccess(response) {
          if (response.data && response.data.isLoggedIn) {
            showBanner(false);
            privacyVm.moreInformation();
          }
          else {
            showBanner(true);
          }
        })
        .catch(function () {
          showBanner(true);
        });
      }
      else {
        showBanner(true);
      }
    });
  }

  $rootScope.$on ('$routeChangeStart', function ($event, next, current) {
    if (next) {
      if (
        (next.templateUrl !== 'termsOfServiceView.html') &&
        (next.templateUrl !== 'privacyPolicyPageView.html') &&
        (next.templateUrl !== 'contactpageView.html') &&
        (next.templateUrl !== 'cookiesView.html')
       ) {
        showPrivacyModal();
      }
      else {
        showBanner(false);
      }
    }
  });
}

PrivacyPolicyController.$inject = ['$rootScope', '$location', 'privacyService', 'userSvc', 'welcomeLandingPageService'];
module.exports = PrivacyPolicyController;

},{}],19:[function(require,module,exports){
function PrivacyPolicyPopupController(
  $scope,
  $rootScope,
  privacySvc,
  accountSvc,
  userSvc,
  retryService
) {
  $scope.previouslyAccepted = false;
  $scope.isRegistered = false;
  $scope.showOtherOptions = false;
  $scope.newsletters = undefined;
  $scope.preloadingEnabled = undefined;
  $scope.error = false;

  function isPrivacyPolicyOutdated() {
    return privacySvc.isOutdated();
  }

  function reviewPrivacyPolicy() {
    $rootScope.$broadcast('modal.open', {
      controller: 'PrivacyPolicyController',
      templateUrl: 'popups/privacyPolicy.html'
    });
  }

  function agreeClicked() {
    if ($scope.isRegistered && $scope.newsletters === undefined) {
      $scope.error = true;
    } else {
      acceptPrivacyPolicy();
    }
  }

  function acceptPrivacyPolicy() {
    $rootScope.$broadcast('modal.close');

    retryService
      .retry(
        function() {
          return privacySvc.acceptActiveVersion();
        },
        {
          delay: 1000,
          retries: 10
        }
      )
      .then(function() {
        var settings = {
          newsletterActive: $scope.newsletters,
          preloadingEnabled: $scope.preloadingEnabled
        };
        if (
          typeof settings.newsletterActive === 'undefined' ||
          typeof settings.preloadingEnabled === 'undefined'
        ) {
          $rootScope.$broadcast(
            'notification:error',
            'Something went wrong saving your preferences.'
          );
          return;
        }
        retryService.retry(
          function() {
            return accountSvc.setAccountSettings(settings);
          },
          {
            delay: 1500,
            retries: 10
          }
        );
      });
  }

  function loadIsRegistered() {
    userSvc.getPlayer().then(function(response) {
      if (response.data && response.data.isLoggedIn) {
        $scope.isRegistered = true;
      } else {
        $scope.isRegistered = false;
      }
    });
  }

  function loadNewsletter() {
    accountSvc
      .getAccount()
      .then(function onSuccess(response) {
        const data = response.data;
        $scope.preloadingEnabled = data.preloadingEnabled;
        if (data.newsletterActive) {
          $scope.previouslyAccepted = true;
        }
      })
      .catch(function onError() {
        $scope.previouslyAccepted = false;
      });
  }

  $scope.isPrivacyPolicyOutdated = isPrivacyPolicyOutdated;
  $scope.reviewPrivacyPolicy = reviewPrivacyPolicy;
  $scope.agreeClicked = agreeClicked;
  $scope.acceptPrivacyPolicy = acceptPrivacyPolicy;
  $scope.loadNewsletter = loadNewsletter;
  $scope.loadIsRegistered = loadIsRegistered;

  $scope.loadIsRegistered();
  $scope.loadNewsletter();
}

PrivacyPolicyPopupController.$inject = [
  '$scope',
  '$rootScope',
  'privacyService',
  'accountService',
  'userSvc',
  'retryService'
];
module.exports = PrivacyPolicyPopupController;

},{}],20:[function(require,module,exports){
function PromotionPageController(
  $rootScope,
  $scope,
  $routeParams,
  $location,
  PromoService,
  $timeout
) {
  var promoName = '';
  if ($routeParams.name !== null) {
    promoName = $routeParams.name;
  } else {
    $location.path('/');
  }
  var promoCode = '';
  if ($routeParams.code !== null) {
    promoCode = $routeParams.code;
  }

  // Set header
  $rootScope.showNormalNav = true;
  $scope.htmlContent = null;

  PromoService.renderPromo(promoName, promoCode)
    .success(function(renderData) {
      $scope.renderInfo = renderData.renderInfo;
      $scope.htmlContent = renderData.htmlContent.replace(
        /__PROMO_CODE__/g,
        promoCode
      );
      $scope.renderContent();
    })
    .catch(function(err) {
      if (err.status === 404) {
        $location.path('/404');
      }
    });

  $scope.validatePromo = function() {
    if ($scope.renderInfo.isUserLogged) {
      if ($scope.renderInfo.isUserAlreadySubscribedToPlan) {
        return $scope.showAlreadySubscribedDialog();
      }
      if (!$scope.renderInfo.isPromoCodeValid) {
        if ($scope.renderInfo.isPromoCodeExpired) {
          return $scope.showExpiredPromoCodeDialog();
        }
        if ($scope.renderInfo.isPromoCodeMaxUsesReached) {
          return $scope.showMaxUsedPromoCodeReachedDialog();
        }
        return $scope.showInvalidPromoCodeDialog();
      }
      if (!$scope.renderInfo.isPromoApplicableToUser) {
        return $scope.showIncompatibleUserDialog();
      }
    }
  };

  $scope.renderContent = function() {
    var contentElement = angular.element('#promo-content');
    contentElement.empty();
    contentElement.append($scope.htmlContent);
    $scope.validatePromo();
  };

  $scope.showLoginDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoLogin.html',
      controller: function promoLoginController($scope) {
        $scope.signup = function signup() {
          $rootScope.$broadcast('modal.close');
          window.location.href = '/signup?promoName=' + promoName;
        };
        $scope.login = function login() {
          $rootScope.$broadcast('modal.close');
          window.location.href =
            '/csi/login?promoName=' +
            promoName +
            '&redirecturl=' +
            encodeURIComponent($location.absUrl());
        };
      }
    });
  };

  $scope.showAlreadySubscribedDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoAlreadySubscribed.html',
      controller: function promoAlreadySubscribedController($scope) {
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
          $location.path('/');
        };
      }
    });
  };

  $scope.showIncompatibleUserDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoIncompatibleUser.html',
      controller: function promoIncompatibleUserController($scope) {
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
          $location.path('/');
        };
      }
    });
  };

  $scope.showInvalidPromoCodeDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoCodeInvalid.html',
      controller: function promoCodeInvalidController($scope) {
        $scope.code = promoCode;
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
          $location.path('/');
        };
      }
    });
  };

  $scope.showExpiredPromoCodeDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoCodeExpired.html',
      controller: function promoCodeExpiredController($scope) {
        $scope.code = promoCode;
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
          $location.path('/');
        };
      }
    });
  };

  $scope.showMaxUsedPromoCodeReachedDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoCodeMaxUsesReached.html',
      controller: function promoCodeMaxUsesReachedController($scope) {
        $scope.code = promoCode;
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
          $location.path('/');
        };
      }
    });
  };

  $scope.applyPromotion = function() {
    if (!$scope.renderInfo.isUserLogged) {
      return $scope.showLoginDialog();
    }
    $scope.validatePromo();

    $timeout(function() {
      if ($scope.renderInfo.isUpsell) {
        $scope.showPromoVerifyDialog();
      } else {
        $scope.applyPromotionVerified();
      }
    });
  };

  $scope.applyPromotionVerified = function() {
    if ($scope.renderInfo.isUpsell) {
      PromoService.applyPromoUpsell(promoName, promoCode)
        .then(function(response) {
          $location.path('/success/promo');
        })
        .catch(function(err) {
          $rootScope.$broadcast('modal.open', {
            templateUrl: 'popups/promoError.html',
            controller: function promoErrorController($scope) {
              $scope.closeModal = function closeModal() {
                $rootScope.$broadcast('modal.close');
                $location.path('/promo/' + promoName);
              };
            }
          });
        });
    } else {
      $timeout(function() {
        let buyPromoPath = '/payment/promo/' + promoName;
        if (promoCode) {
          // $location.path(buyPromoPath).search('promo_code', promoCode);
          buyPromoPath = buyPromoPath + '/code/' + promoCode;
        }
        $location.path(buyPromoPath);
      });
    }
  };

  var mainScope = $scope;
  $scope.showPromoVerifyDialog = function() {
    $rootScope.$broadcast('modal.open', {
      templateUrl: 'popups/promoVerify.html',
      controller: function promoVerifyController($scope) {
        $scope.closeModal = function closeModal() {
          $rootScope.$broadcast('modal.close');
        };
        $scope.applyPromotion = function applyPromotion() {
          $rootScope.$broadcast('modal.close');
          mainScope.applyPromotionVerified();
        };
      }
    });
  };
}

PromotionPageController.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  '$location',
  'PromoService',
  '$timeout'
];
module.exports = PromotionPageController;

},{}],21:[function(require,module,exports){
function SeriespageController ($rootScope, $scope, $routeParams, gameDataSvc, seriesService, gatheringSvc, $location) {
    // Set header
    $rootScope.showNormalNav = true;

    var setCurrentSeries = function (seriesDetails) {
        $scope.seriesDetails = seriesDetails;

        // Retrieve the currently open series Identifier from the array
        // Set the full series as the current one.
        $scope.currentSeries = $scope.seriesDetails.reduce(function (memory, series) {
            if (memory) {
                    return memory;
                }
                else {
                    if (series.seoName === $routeParams.seoName) {
                        return series;
                    }
                }
                return null;
            }, null);
        //Set meta descriptions to have correct values
        $rootScope.metaTitle = $scope.currentSeries.name + " Series Games - GameHouse";
        $rootScope.metaDescription = $scope.currentSeries.description;
    };
    seriesService.getSeriesDetails().then(setCurrentSeries);

    function handleError() {
        gatheringSvc.sendErrorInfo('seriesPage getSeriesGames', 'Error: loading games in series. SeoName: ' + $routeParams.seoName);
        $location.path('/');
    }

    var getSeriesGames = function () {
        var pageSize = 1000;
        var sortBy = $rootScope.seriesPageSorting.selectedOption.propertyBackend;
        var sortOrder = ($rootScope.seriesPageSorting.selectedOption.reverse ? "DESC" : "ASC");
        gameDataSvc.getSeriesGames($routeParams.seoName, 0, pageSize, sortBy, sortOrder).success(function (gameData) {
            if (!gameData.error) {
                if(gameData.gameList.length === 0){
                    handleError();
                }
                $scope.seriesGames = gameData.gameList;
            } else {
                // error detected
                handleError();
            }
        }).error( function() {
            // error detected
            handleError();
        });
    };

    $scope.updateSorting = function(sortingOptionId) {
        // find the correct selected option via sortingOptionId
        for (var i=0; i< $rootScope.seriesPageSorting.sortingOptions.length; i++) {
            var currentOption = $rootScope.seriesPageSorting.sortingOptions[i];
            if (currentOption.id === sortingOptionId) {
                $rootScope.seriesPageSorting.selectedOption = currentOption;
                break;
            }
        }
        getSeriesGames();
    };
    getSeriesGames();
}

SeriespageController.$inject = ['$rootScope', '$scope', '$routeParams', 'gameDataSvc', 'seriesService', 'gatheringSvc', '$location'];
module.exports = SeriespageController;

},{}],22:[function(require,module,exports){
function SignupController(
  $routeParams,
  $rootScope,
  $scope,
  $sce,
  accountService,
  $location,
  gatheringSvc,
  userSvc
) {
  $scope.isPromo = function() {
    return $routeParams.promoName;
  };

  if ($scope.isPromo()) {
    $scope.login = function(event) {
      window.location.href =
        '/csi/login?promoName=' +
        $routeParams.promoName +
        '&redirecturl=' +
        encodeURIComponent('/promo/' + $routeParams.promoName);
    };
  }

  //Check if player is logged in (global load is sometimes to late), need to redesign to more efficient way.
  userSvc.getPlayer().then(function(response) {
    if (!$scope.isPromo()) {
      if (!response.data) {
        $location.path('/');
      } else {
        if (response.data.isEntitled) {
          $location.path('/');
        }
        if (response.data.isLoggedIn) {
          if ($routeParams.planName) {
            $location
              .path('/payment/' + $routeParams.planName)
              .search('planName', null)
              .replace();
          } else {
            $location.path('/membership-plans').replace();
          }
        }
      }
    } else {
      if (!response.data || response.data.isLoggedIn) {
        $location
          .path('/promo/' + $routeParams.promoName)
          .search('promoName', null)
          .replace();
      }
    }
  });

  // Set the default value of inputType and EyeIcon
  $scope.inputType = 'password';
  $scope.classEyeIcon = 'glyphicon glyphicon-eye-open field-icon';

  // Hide & show password function
  $scope.hideShowPassword = function() {
    if ($scope.inputType == 'password') {
      $scope.inputType = 'text';
      $scope.classEyeIcon = 'glyphicon glyphicon-eye-close field-icon';
    } else {
      $scope.inputType = 'password';
      $scope.classEyeIcon = 'glyphicon glyphicon-eye-open field-icon';
    }
  };

  //Initialize
  $scope.account = {};

  $scope.busy = false; // keep track of in-progress HTTP-POST-calls

  // Set header adjustments for payment flow
  $rootScope.showNormalNav = false;

  // Set some defaults
  $scope.showPassword = false;

  $scope.submitSignUp = function() {
    if ($scope.busy === true) {
      return;
    }
    // Do not submit if plan or promo are empty
    if (
      (!$routeParams.planName || $routeParams.planName === '') &&
      (!$routeParams.promoName || $routeParams.promoName === '')
    ) {
      //
      // Check if we can log other error here
      //
      gatheringSvc.sendCreateAccountSubmitError(
        $scope.signup.emailAddress.$viewValue + '',
        !$scope.signup.emailAddress.$invalid,
        !$scope.signup.password.$invalid
      );
      gatheringSvc.sendCreateAccountError(
        $scope.signup.emailAddress.$viewValue + '',
        'Empty plan value'
      );
      // Come back to plan selection page
      $location.path('/membership-plans').replace();
    }

    // Do not submit if there are errors in the form
    if ($scope.signup.$valid !== true) {
      gatheringSvc.sendCreateAccountSubmitError(
        $scope.signup.emailAddress.$viewValue + '',
        !$scope.signup.emailAddress.$invalid,
        !$scope.signup.password.$invalid
      );
      return;
    }

    $scope.busy = true;

    // Reset error messages
    $scope.signupErrors = {};

    //Retrieve deviceId if available
    if ($rootScope.player) {
      $scope.account.deviceId = $rootScope.player.deviceId;
    }

    // Do the request to signup user
    accountService
      .createAccount($scope.account)
      .then(signUpSuccess, signUpError);
  };

  var signUpSuccess = function() {
    $rootScope.tagEvent('signup-success');
    $scope.busy = false;

    //Signup was a succes, let's retrieve the player account and set it on the scope. Also push
    //the details to google/other services.
    userSvc
      .getPlayer()
      .then(function(response) {
        $rootScope.player = response.data;

        if (!response.data) {
          gatheringSvc.sendErrorInfo(
            'GetPlayer',
            ' Error: failed getting player after registration data / ' +
              response.error
          );
        } else {
          $rootScope.tagEvent('signup-body-submit', {
            email: $rootScope.player.email
          });
        }
      })
      .then(function() {
        //If we retrieved the player details notify the user.
        gatheringSvc.sendCreateAccountSuccess();

        // Reset the form status to unsubmitted
        $scope.signup.$setPristine();

        if (!$scope.isPromo()) {
          //Let's continue to the payment step.
          $location
            .path('/payment/' + $routeParams.planName)
            .search('planName', null)
            .replace();
        } else {
          //Let's return to the promotion page.
          $location
            .path('/promo/' + $routeParams.promoName)
            .search('promoName', null)
            .replace();
        }
      });
  };

  var signUpError = function(response) {
    $scope.busy = false;

    // Set error messages for use in the view
    $scope.signupErrors = accountService.getErrors(response);

    // Trust HTML injected in the resulting error string
    if ($scope.signupErrors && $scope.signupErrors.emailAddress) {
      $scope.signupErrors.emailAddress = $sce.trustAsHtml(
        $scope.signupErrors.emailAddress
      );
    }

    gatheringSvc.sendCreateAccountError(
      $scope.account.emailAddress,
      $scope.signupErrors
    );

    //If the error is because of a legacy account already existing send them to the legacy website,
    //the cookies are already prepared by the backend.
    if ($scope.signupErrors.legacy === 'true') {
      window.location.href = '/';
    } else {
      // Send notification
      $rootScope.$broadcast(
        'notification:error',
        'Something went wrong with creating your account.'
      );
    }
  };
}

SignupController.$inject = [
  '$routeParams',
  '$rootScope',
  '$scope',
  '$sce',
  'accountService',
  '$location',
  'gatheringSvc',
  'userSvc'
];
module.exports = SignupController;

},{}],23:[function(require,module,exports){
function SuccessController(
  $rootScope,
  $scope,
  $routeParams,
  gameDataSvc,
  $location,
  $cookies,
  messageService
) {
  // Set header adjustments for payment flow
  $rootScope.showNormalNav = true;

  $scope.hideLoader = true;
  $scope.buttonText = 'BROWSE GAMES';

  if (typeof $cookies.get('postTrialContentId') != 'undefined') {
    $scope.buttonText = 'CONTINUE PLAYING';
  }
  var message = $routeParams.message || '';
  if (message.indexOf('paypal') >= 0) {
    $scope.payPal = true;
  }

  if (message.indexOf('promo') >= 0) {
    $scope.promo = true;
    $rootScope.promoNotification = null;
  }

  $scope.continuePlaying = function() {
    if (typeof $cookies.get('postTrialContentId') != 'undefined') {
      $scope.buttonText = '';
      $scope.hideLoader = false;
      gameDataSvc
        .getSpecificGameByContentId($cookies.get('postTrialContentId'))
        .success(function(data) {
          if (data && data.contentId && data.id) {
            $rootScope.playGame(data);
            setTimeout(function() {
              $location.path('/');
            }, 20000);
          }
        });
    } else {
      $location.path('/');
    }
  };

  messageService.removeSubscriptionExpiringMessage();
}

SuccessController.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  'gameDataSvc',
  '$location',
  '$cookies',
  'messageService'
];
module.exports = SuccessController;

},{}],24:[function(require,module,exports){
var config = require('../config.js');

function TopPlayedGamesController($rootScope, $scope, $location, gameDataSvc) {
  // Set header
  $rootScope.showNormalNav = true;

  gameDataSvc
    .getTopPlayedGames(config.topPlayed.pageLimit)
    .success(function(topPlayedGames) {
      if (!topPlayedGames.error) {
        topPlayedGames.size === 0
          ? ($scope.topPlayedGames = null)
          : ($scope.topPlayedGames = topPlayedGames.items);
      } else {
        $location.path('/');
      }
    });
}

TopPlayedGamesController.$inject = [
  '$rootScope',
  '$scope',
  '$location',
  'gameDataSvc'
];
module.exports = TopPlayedGamesController;

},{"../config.js":1}],25:[function(require,module,exports){
var config = require('../config.js');

function TopRatedGamesController($rootScope, $scope, $location, gameDataSvc) {
  // Set header
  $rootScope.showNormalNav = true;

  gameDataSvc
    .getTopRatedGames(0, config.topRated.pageLimit)
    .success(function(topRatedGames) {
      if (!topRatedGames.error) {
        topRatedGames.gameList.length === 0
          ? ($scope.topRatedGames = null)
          : ($scope.topRatedGames = topRatedGames.gameList);
      } else {
        $location.path('/');
      }
    });
}

TopRatedGamesController.$inject = [
  '$rootScope',
  '$scope',
  '$location',
  'gameDataSvc'
];
module.exports = TopRatedGamesController;

},{"../config.js":1}],26:[function(require,module,exports){
function UpcomingGamePageController(
  $rootScope,
  $scope,
  $routeParams,
  $location,
  gatheringSvc,
  userSvc,
  gameDataSvc
) {
  if ($routeParams.seoName !== null) {
    var seoName = $routeParams.seoName;
    gameDataSvc
      .getUpcomingGame(seoName)
      .success(function(data) {
        if (data && data !== null) {
          $scope.game = data;
          if ($scope.game !== null) {
            //Set meta descriptions to have correct value
            $rootScope.metaTitle = $scope.game.title + ' - GameHouse';
            $rootScope.metaDescription = $scope.game.description;
          }
        } else {
          // the API call returned null, redirect to the homepage
          gatheringSvc.sendErrorInfo(
            'GetUpcomingGame3',
            'Error: failed getting upcoming game page specific game info. seoName: ' +
              seoName
          );
          $location.path('/');
        }
      })
      .error(function(error) {
        // no upcoming game with this SEO name was found, redirect to the homepage
        gatheringSvc.sendErrorInfo(
          'GetUpcomingGame2',
          'Error: failed getting upcoming game page specific game info. seoName: ' +
            seoName
        );
        $location.path('/');
      });
  } else {
    // no SEO name was supplied, redirect to the homepage
    gatheringSvc.sendErrorInfo(
      'GetUpcomingGame1',
      'Error: failed getting upcoming game page specific game info. seoName: null'
    );
    $location.path('/');
  }

  // Set header
  $rootScope.showNormalNav = true;
  $scope.isEmailSubmitted = false;
  // the model doesn't update if we create it as $scope.emailAddress so instead putting it in a wrapper object
  $scope.user = {
    emailAddress: ''
  };

  // pre-fill email if the user is logged in
  userSvc.getPlayer().success(function(data) {
    var seoName = $routeParams.seoName;
    if (
      data.isLoggedIn &&
      data.email !== null &&
      data.email.trim() !== '' &&
      seoName !== null
    ) {
      $scope.user.emailAddress = data.email.trim();

      // Check if user is already subscribed
      gameDataSvc
        .isPlayerSubscribed(seoName)
        .success(function(result) {
          if (
            result.isSubscribed &&
            result.playerEmail === $scope.user.emailAddress
          )
            $scope.isEmailSubmitted = true;
        })
        .error(function(error) {
          $scope.isEmailSubmitted = false;
        });
    }
  });

  // submit email address
  $scope.submitEmail = function() {
    $scope.user.emailAddress = $scope.user.emailAddress.trim();
    gameDataSvc
      .postUpcomingGameEmail($scope.user.emailAddress, $scope.game.seoName)
      .success(function(data) {
        $scope.isEmailSubmitted = true;
      })
      .error(function(error) {
        $scope.isEmailSubmitted = false;
      });
  };

  // copied pure JavaScript smooth-scrolling from http://stackoverflow.com/a/18071824
  $scope.smoothScroll = function(target) {
    target = document.getElementById(target);
    var scrollContainer = target;
    do {
      //find scroll container
      scrollContainer = scrollContainer.parentNode;
      if (!scrollContainer) {
        return;
      }
      scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    var targetY = 0;
    do {
      //find the top of target relatively to the container
      if (target == scrollContainer) {
        break;
      }
      targetY += target.offsetTop;
    } while ((target = target.offsetParent));

    var scroll = function(c, a, b, i) {
      i++;
      if (i > 30) {
        return;
      }
      c.scrollTop = a + ((b - a) / 30) * i;
      setTimeout(function() {
        scroll(c, a, b, i);
      }, 20);
    };
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
  };
}

UpcomingGamePageController.$inject = [
  '$rootScope',
  '$scope',
  '$routeParams',
  '$location',
  'gatheringSvc',
  'userSvc',
  'gameDataSvc'
];
module.exports = UpcomingGamePageController;

},{}],27:[function(require,module,exports){
function AdvertisementModal($rootScope) {
  return {
    restrict: 'E',
    templateUrl: 'popups/displayAdvertisement.html',
    scope: true,
    link: function(scope, element, args) {

      // TODO! Move this all logic to a advertisement service

      $rootScope.advertisement = {
        display: false,
        activatedAdBlock: true,
        loading: true
      }

      // Checking if the user has the adblock activated
      $.ajax({
        method:"GET",
        async: true,
        dataType: "script",
        url: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
        complete: function(data, status) {
          if (data.status === 200) {
            $rootScope.advertisement.activatedAdBlock = false;
          }
        }
      });

      scope.close = function() {
        $rootScope.advertisement.display = false;
        $rootScope.advertisement.loading = true;
      }

      scope.showAd = function() {
        $rootScope.advertisement.loading = false;
      }

      // Event triggered by Controller
      $rootScope.$on('advertisement.play', function (event, args) {
        scope.startGame = args.startGame;
        $('#load-ad-button').data('reference-id', args.referenceId).click();
      });
    }
  };
}

AdvertisementModal.$inject = ['$rootScope'];

module.exports = AdvertisementModal;

},{}],28:[function(require,module,exports){
function Carousel ($sce, $rootScope, abtestService) {
    return {
        replace: 'true',
        restrict: 'E',
        scope: {
            gamebox: '=',
            isIE9: '=isIe9'
        },
        templateUrl: 'subviews/carousel.html',
        link: function(scope) {
            var trustedVideoUrl = $sce.trustAsResourceUrl(scope.gamebox.gameVideos.video1);
            var videoPosterUrl = scope.gamebox.gameImages.large;
            var screenShots = scope.gamebox.gameScreenShots;

            scope.slides = [
                {'type': 'video','url': trustedVideoUrl, 'posterUrl': videoPosterUrl},
                {'type': 'image','url': screenShots.screenShot1},
                {'type': 'image','url': screenShots.screenShot2},
                {'type': 'image','url': screenShots.screenShot3}
            ];

            scope.indexOfSelectedSlide = 0;
            scope.numberOfItems = scope.slides.length;
            scope.selectSlide = function (index) {
                $rootScope.tagEvent('game-body-preview-click', {'type': scope.slides[index].type, 'ui-position': index});
                scope.indexOfSelectedSlide = (index % scope.numberOfItems + scope.numberOfItems) % scope.numberOfItems;
            };
        }
    };
}



Carousel.$inject = ['$sce', '$rootScope', 'abtestService'];
module.exports = Carousel;
},{}],29:[function(require,module,exports){
function CreditCardValidator() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, elem, attrs, ctrl) {

            function validate(cardNumber) {
                //reset validity on focus event
                elem.on('focus', function () {
                    ctrl.$setValidity('ccNumberValidator', true);
                    ctrl.$setValidity('ccTypeValidator', true);
                    $scope.$apply();
                });

                elem.on('blur', function () {
                    validateCardNumber(cardNumber);
                    validateCreditCardType(cardNumber);
                });

                return cardNumber;
            }

            function validateCreditCardType(cardNumber) {
                var v = cardNumber.replace(/[^\d]/g, "");
                var checkedType = isVisa(v) ? 'Visa' : (isMC(v) ? 'MasterCard'
                    : (isAmex(v) ? 'AmericanExpress' : (isDiscover(v) ? 'Discover'
                    : (isJCB(v) ? 'Discover' /*JCB is supported as Discover*/
                    : (isDiners(v) ? 'Discover' /*Diners Club is supported as Discover*/ : checkedType)))));
                if (!checkedType || !isCardTypeSupported(checkedType)) {
                    $scope.cc.cardtype = '';
                    ctrl.$setValidity('ccTypeValidator', false);
                } else {
                    $scope.cc.cardtype = checkedType;
                    ctrl.$setValidity('ccTypeValidator', true);

                    // set authorization amount default to zero
                    $scope.cc.authorizationAmount = 0;
                    if (checkedType === 'AmericanExpress' || checkedType === 'Discover') {
                        $scope.cc.authorizationAmount = 1;
                    }
                }
            }

            function isCreditCard(cc) {
                // use Luhn checksum algorithm to check if the credit card is valid
                return luhnCheck(cc);
            }

            function validateCardNumber(cardNumber) {
                if (cardNumber == '') {
                    return '';
                }

                if (!isCreditCard(cardNumber.replace(/ /g, ""))) {
                    ctrl.$setValidity('ccNumberValidator', false);
                    $scope.$apply();
                } else {
                    ctrl.$setValidity('ccNumberValidator', true);
                    $scope.$apply();
                }
            }

            var isCardTypeSupported = function (cardType) {
                var supportedTypes = [];
                supportedTypes.push("Visa");
                supportedTypes.push("MasterCard");
                supportedTypes.push("AmericanExpress");
                supportedTypes.push("Discover");

                for (var i = 0; i < supportedTypes.length; i++) {
                    if (supportedTypes[i] === cardType) {
                        return true;
                    }
                }
                return false;
            };
            ctrl.$parsers.push(validate);
        }
    };
}

/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following Visa specs */
/*---------------------------------------------------------------*/
function isVisa(cc) {
    if (cc && cc.match(/^4[0-9]{12}(?:[0-9]{3})?$/g)) {
        return true
    }
    return (false);
}

/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following MasterCard specs */
/*---------------------------------------------------------------*/
function isMC(cc) {
    if (cc && cc.match(/^5[1-5][0-9]{14}(?:\d{3})?$/g)) {
        return true
    }
    return (false);
}
/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following AMEX specs */
/*---------------------------------------------------------------*/
function isAmex(cc) {
    if (cc && cc.match(/^3[47][0-9]{13}$/g)) {
        return true
    }
    return (false);
}
/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following Discover specs */
/*---------------------------------------------------------------*/
function isDiscover(cc) {
    if (cc
        && cc
            .match(/^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/)
        && cc.length == 16) {
        return true
    }
    return (false);
}

/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following JCB specs */
/*---------------------------------------------------------------*/
function isJCB(cc) {
    if (cc && cc.match(/^(?:2131|1800|35[0-9]{3})[0-9]{11}$/g)) {
        return true;
    }
    return false;
}

/*---------------------------------------------------------------*/
/* Purpose : Validate CC number following Diners specs */
/*---------------------------------------------------------------*/
function isDiners(cc) {
    if (cc && cc.match(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/g)) {
        return true;
    }
    return false;
}

/**
 * Checks whether a given credit card number has a valid Luhn checksum.
 * This allows you to spot most randomly made-up or garbled credit card numbers immediately.
 * Reference: http://www.speech.cs.cmu.edu/~sburke/pub/luhn_lib.html
 */
function luhnCheck(cardNumber) {
    if (isLuhnNum(cardNumber)) {
        var no_digit = cardNumber.length;
        var oddoeven = no_digit & 1;
        var sum = 0;
        for (var count = 0; count < no_digit; count++) {
            var digit = parseInt(cardNumber.charAt(count));
            if (!((count & 1) ^ oddoeven)) {
                digit *= 2;
                if (digit > 9) digit -= 9;
            }
            sum += digit;
        }
        if (sum == 0) return false;
        if (sum % 10 == 0) return true;
    }
    return false;
}

function isLuhnNum(argvalue) {
    argvalue = argvalue.toString();
    if (argvalue.length == 0) {
        return false;
    }
    for (var n = 0; n < argvalue.length; n++) {
        if ((argvalue.substring(n, n + 1) < "0") ||
            (argvalue.substring(n, n + 1) > "9")) {
            return false;
        }
    }
    return true;
}

module.exports = CreditCardValidator;
},{}],30:[function(require,module,exports){
//validate credit card security number (cvc)
function CreditCardSecurityValidator() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, elem, attrs, ctrl) {

            function validate(cvc) {
                validateCardSecurity(cvc);
                return cvc;
            }

            function validateCardSecurity(cvc) {
                var v = cvc;
                var sec = v.replace(/\D+/g, "");
                if (v != sec) {
                    ctrl.$setValidity('cvcValidator', false);
                } else {
                    ctrl.$setValidity('cvcValidator', true);
                }
            }

            ctrl.$parsers.push(validate);
        }
    };
}
module.exports = CreditCardSecurityValidator;
},{}],31:[function(require,module,exports){
function Gamebox ($rootScope) {
    return {
        replace: 'true',
        restrict: 'E',
        scope: {
            games: '=',
            irregular: '=',
            irregularcount: '=',
            continueplaying: '=',
            showgenreinfo: '=',
            boxcontainer: '@',
            currentpage: '@'
        },
        templateUrl: 'subviews/gamebox.html',
        link: function(scope, element) {
            scope.gameManager = $rootScope.gameManager;
            scope.defaultPlayLabel = $rootScope.defaultPlayLabel;

            scope.clickPlay = function (game, index, angularEvent) {
                if (game === null || game.id === null) {
                    game.id = 0;
                }
                //Log the click on play
                $rootScope.sendClickTracking(scope.boxcontainer +'_item-' + (index+1), 'play_id-' + game.id);

                if (scope.continueplaying) {
                    $rootScope.playGame(game, scope.boxcontainer + '-continue-click', index, angularEvent);
                } else {
                    $rootScope.playGame(game, scope.boxcontainer + '-play-click', index, angularEvent);
                }
            };

            scope.clickInfo = function (game, index) {
                if (game === null || game.id === null) {
                    game.id = 0;
                }
                $rootScope.sendClickTracking(scope.boxcontainer +'_item-' + (index+1), 'more-info_id-' + game.id);
                $rootScope.tagEvent(scope.boxcontainer + '-more-info-click', {'game-name': game.title, 'genre-name': game.genre.title, 'game-id': game.id, 'ui-position': index});
            };
        }
    };
}



Gamebox.$inject = ['$rootScope'];
module.exports = Gamebox;
},{}],32:[function(require,module,exports){
function Carousel($interval, abtestService, $rootScope) {
  // next slide only if there are no installations in progress
  var nextSlide = function(scope, amiSvc) {
    var activeGame = scope.carouselItems[scope.activeIndex];
    if (!amiSvc.isInstallationInProgress(activeGame)) {
      var index = (scope.activeIndex + 1) % scope.carouselItems.length;
      scope.goToSlide(index);
    }
  };

  return {
    restrict: 'E',
    templateUrl: 'subviews/hero-carousel.view.html',
    controller: function controller($scope, amiSvc) {
      $scope.timer = null;
      $scope.activeIndex = null;
      $scope.carouselItems = [];
      $scope.carouselDuration = 8000;

      $scope.goToSlide = function goToSlide(index) {
        $scope.activeIndex = index;
      };

      $scope.pauseSlides = function pauseSlides() {
        if ($scope.timer) {
          $interval.cancel($scope.timer);
          $scope.timer = null;
        }
      };

      $scope.continueSlides = function continueSlides() {
        if ($scope.timer == null) {
          $scope.timer = $interval(
            nextSlide.bind({}, $scope, amiSvc),
            $scope.carouselDuration
          );
        }
      };

      var addCarouselItems = function addCarouselItems(items) {
        var joined = $scope.carouselItems.concat(items);
        for (var index = 0; index < joined.length; ++index) {
          for (var j = index + 1; j < joined.length; ++j) {
            if (joined[index].id == joined[j].id) {
              joined.splice(j--, 1);
            }
          }
        }
        return joined;
      };

      var setCarouselItems = function() {
        $scope.activeIndex = 0;
        if ($scope.$root.recommendedGames) {
          $scope.carouselItems = $scope.$root.recommendedGames.slice(
            0,
            $scope.$root.heroGamesLimit
          );
        }

        if ($scope.$root.upcomingGame) {
          $scope.carouselItems.splice(
            $scope.$root.upcomingGame.carouselPosition - 1,
            0,
            $scope.$root.upcomingGame
          );
        }

        if ($scope.$root.promoNotification) {
          $scope.carouselItems.splice(0, 0, $scope.$root.promoNotification);
        }
      };

      // method iterates through array starting from 1 element(assuming that backend returned featured game and this game is on position 0)
      // and changes flag from GAME_OF_THE_MONTH to NONE.
      var filterOutGamesOfTheMonth = function(gameArray) {
        for (var i = 1; i < gameArray.length; i++) {
          if (gameArray[i].feature === 'GAME_OF_THE_MONTH') {
            gameArray[i].feature = 'NONE';
          }
        }
      };

      $scope.$root.$watch('recommendedGames', setCarouselItems);
      $scope.$root.$watch(
        'recommendedBecauseYouPlayedGamesRequested',
        setCarouselItems
      );
      $scope.$root.$watch('upcomingGame', setCarouselItems);
      $scope.$root.$watch('promoNotification', setCarouselItems);
      $scope.continueSlides();
    },
    link: function(scope, element) {
      var resetSlideInterval = function() {
        scope.pauseSlides();
        scope.continueSlides();
      };

      element.on('mousemove', resetSlideInterval);
      // TODO: on mouse over the play button, the carousel should be paused
    }
  };
}

Carousel.$inject = ['$interval', 'abtestService', '$rootScope'];
module.exports = Carousel;

},{}],33:[function(require,module,exports){
function ModalManager ($rootScope, $modal) {
    return {
        restrict: 'E',
        scope: true,
        link: function(scope, element) {
            var _modal;
            var _isOpen = false;
            var _closeCallback;

            $rootScope.$on('modal.open', function (event, args) {

                if (!_isOpen) {
                    _modal  = $modal.open({
                        controller: args.controller || null,
                        templateUrl: args.templateUrl,
                        size: args.size ? args.size : 'md',
                        backdrop: args.backdrop ? args.backdrop : 'static',
                        keyboard: args.keyboard ? args.keyboard : false
                    });

                    if (args.closeCallback) {
                        _closeCallback = args.closeCallback;
                    }

                    _modal.opened
                        .then(function (success) {
                            _isOpen = true;
                        });

                } else {
                    return;
                }
            });

            $rootScope.$on('modal.close', function (event) {
                if (_modal) {
                    if (_isOpen) {

                        _modal.result
                            .then(function (success) {
                                _isOpen = false;
                                _modal = undefined;
                                if(_closeCallback){
                                    _closeCallback();
                                    _closeCallback = undefined;
                                }
                            });

                        _modal.close();
                    }
                } else {
                    return;
                }
            });
        }
    };
}

ModalManager.$inject = ['$rootScope', '$modal'];
module.exports = ModalManager;

},{}],34:[function(require,module,exports){
function MyAccountNavigation () {
    return {
        restrict: 'E',
        scope: {
            'player': '=',
            'active': '@'
        },
        templateUrl: 'subviews/my-account-navigation.html',
        controller: function ($scope) {
            $scope.tabs = [
                { url: 'profile', title: 'Profile' },
                { url: 'password', title: 'Password' },
                { url: 'membership', title: 'Membership' },
                { url: 'settings', title: 'Preferences' },
                { url: 'privacy', title: 'Privacy Settings' },
                { url: 'purchasedgames', title: 'Purchased Games' }
            ];
        }
    };
}

module.exports = MyAccountNavigation;
},{}],35:[function(require,module,exports){
function NotificationBanner ($rootScope, $timeout) {

    return {
        restrict: 'E',
        controller: function($scope, $element) {

            var timer;

            $scope.className = null;
            $scope.message = '';
            $scope.open = null;


            var openBanner = function () {
                // Be sure to add the CSS-class a bit later to trigger the CSS-transition
                $timeout(function () {
                    $scope.open = 'is-open';
                }, 0);

                $timeout.cancel(timer);
                timer = $timeout(closeBanner, 5000);
            };

            var closeBanner = function () {
                $scope.$apply(function () {
                    $scope.open = null;
                });
            };

            $rootScope.$on('notification:confirm', function (event, message) {
                $scope.className = 'confirm';
                $scope.message = message;
                openBanner();
            });

            $rootScope.$on('notification:error', function (event, message) {
                $scope.className = 'error';
                $scope.message = message;
                openBanner();
            });

            $element.on('click', closeBanner);

        }
    };
}



NotificationBanner.$inject = ['$rootScope', '$timeout'];
module.exports = NotificationBanner;
},{}],36:[function(require,module,exports){
function PostalCodeFormatter() {
    return {
      restrict: 'A',
      require: 'ngModel',
        link: function ($scope) {
            var countryElem = $scope.paymentForm.field_creditCardCountry;

            $scope.countryChange = function () {
                checkUKPostCode();
            };

            $scope.postalCodeOnBlur = function () {
                checkUKPostCode();
            };

            var checkUKPostCode = function () {
                var country = countryElem.$modelValue.countryName;

                if (country === "United Kingdom" && isValidUKPostCode()) {
                    formatUKPostCode();
                }
            }

            var isValidUKPostCode = function() {
                var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s*[0-9][A-Z]{2}/i;
                return postcodeRegEx.test($scope.retainValues.zipcode);
            }

            var formatUKPostCode = function() {
                var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2}[A-Z]?)\s*([0-9][A-Z]{2}$)/i;
                $scope.retainValues.zipcode = $scope.retainValues.zipcode.replace(postcodeRegEx,"$1 $2");
            }
        }
    };
}

module.exports = PostalCodeFormatter;
},{}],37:[function(require,module,exports){
function processPaymentOverlay() {
  return {
    templateUrl: 'subviews/process-payment-overlay.html'
  };
}

module.exports = processPaymentOverlay;

},{}],38:[function(require,module,exports){
function scrollToTop() {
    return {
        replace: 'true',
        restrict: 'E',
        template: '<a href="" class="back-to-top"><i class="icon-arrow-up"></i></a>',
        link: function ($scope, element) {
            $(element).on('mouseover', function () {
                $(this).css('color', 'rgb(244, 124, 21)')
            }).on('mouseout', function () {
                $(this).css('color', 'rgb(45, 176, 234)')
            });
            $(window).scroll(function () {
                if ($(window).scrollTop() <= 0) {
                    $(element).fadeOut();
                }
                else {
                    $(element).fadeIn();
                }
            });
            $(element).on('click', function () {
                $('html, body').animate({scrollTop: 0}, 'fast');
            });
        }
    };
}

module.exports = scrollToTop;

},{}],39:[function(require,module,exports){
function Search(gameDataSvc, gatheringSvc) {
  return {
    replace: 'true',
    restrict: 'E',
    scope: {},
    templateUrl: 'subviews/search.html',
    controller: function($scope, $rootScope) {
      $scope.allGamesList = [];
      $scope.genreResults = [];
      $scope.query = '';
      $scope.queryHasFocus = false;
      // boolean flag that denotes whether the user has started clicking in the results
      // used to delay hiding the results until click is done
      $scope.clickOnSearchResultHasStarted = false;
      $scope.results = [];
      $scope.hiddenResults = null;
      $scope.totalNumberOfResults = 0;

      $scope.tagEvent = function(tag, params) {
        $rootScope.tagEvent(tag, params);
      };

      $scope.resetQuery = function() {
        $scope.query = '';
      };

      // Show the results only when the input field had focus
      $scope.showResults = function() {
        $scope.queryHasFocus = true;
      };

      $scope.hideResults = function() {
        $scope.queryHasFocus = false;
      };

      $scope.setClickOnSearchResultHasStarted = function(hasStarted) {
        $scope.clickOnSearchResultHasStarted = hasStarted;
      };

      // add all the hidden search results to the visible results
      $scope.showAllResults = function() {
        $scope.queryHasFocus = true;
        $scope.results = $scope.results.concat($scope.hiddenResults);
        $scope.hiddenResults = null;

        gatheringSvc.sendBiSearchInfo(
          $scope.query.trim(),
          $scope.results.length,
          'showall'
        );

        // give focus to the search input to avoid automatically closing the search results
        var elementResult = angular.element(
          document.getElementById('game-query')
        );
        elementResult.focus();
      };

      $scope.getGames = function() {
        var query = $scope.query.trim();
        if (query.length > 0) {
          gameDataSvc
            .getSearchedGames(query)
            .success(function(data) {
              if (data && !data.error) {
                gatheringSvc.sendBiSearchInfo(query, data.length, 'searchbar');

                // Filter games from genres
                const gamesResult = data.filter(function(g) {
                  return !g.isGenre;
                });

                $scope.genreResults = data.filter(function(g) {
                  return g.isGenre;
                });

                // if there are more than 20 games results, only show the first 15
                $scope.totalNumberOfResults = gamesResult.length;
                if (gamesResult.length > 20) {
                  $scope.results = gamesResult.slice(0, 15);
                  $scope.hiddenResults = gamesResult.slice(15);
                } else {
                  // reset the remainder
                  $scope.results = gamesResult;
                  $scope.hiddenResults = null;
                }
              }
            })
            .error(function() {
              gatheringSvc.sendErrorInfo(
                'SearchForGamesByQuery',
                ' Error: failed getting search results. Search term: ' +
                  $scope.query
              );
            });
        }
      };

      var dropdown = angular.element('#search-dropdown');

      $scope.$watch(
        function() {
          return dropdown.is(':visible');
        },
        function(newVal, oldVal) {
          if (!oldVal && newVal && dropdown.is(':visible')) {
            $scope.tagEvent('header-search-result-show');
          }
        }
      );
    }
  };
}

Search.$inject = ['gameDataSvc', 'gatheringSvc'];
module.exports = Search;

},{}],40:[function(require,module,exports){
function Seriesbox($rootScope) {
    return {
        replace: 'true',
        restrict: 'E',
        scope: {
            serieslist: '=',
            boxcontainer: '@',
            currentpage: '@'
        },
        templateUrl: 'subviews/seriesbox.html',
        link: function (scope, element) {
            scope.clickInfo = function (series, index) {
                if (series === null || series.id === null) {
                    series.id = 0;
                }
                $rootScope.sendClickTracking(scope.boxcontainer + '_item-' + (index + 1), 'more-info_id-' + series.id);
                $rootScope.tagEvent(scope.boxcontainer + '-more-info-click', {
                    'series-name': series.name,
                    'genre-name': series.genre.title,
                    'series-id': series.id,
                    'ui-position': index
                });
            };
        }
    };
}


Seriesbox.$inject = ['$rootScope'];
module.exports = Seriesbox;
},{}],41:[function(require,module,exports){
function StaticBanner($rootScope, $http, emailVerificationService) {
    return {
        restrict: 'E',
        scope: true,
        link: function(scope, element) {

            scope.resend = function() {
                emailVerificationService.sendValidationEmail();
            };

            const adjustPosition = function() {
                setTimeout(function() {
                    $(element).css({
                        'margin-top': $('.navbar-fixed-top').height() + 'px'
                    });
                }, 100);
            };

            $(window).resize(function() {
                adjustPosition();
            });

            adjustPosition();
        }
    };
}

StaticBanner.$inject = ['$rootScope', '$http', 'emailVerificationService'];

module.exports = StaticBanner;

},{}],42:[function(require,module,exports){
function IsEmpty () {
    var bar;
    return function (obj) {
        for (bar in obj) {
            if (obj.hasOwnProperty(bar)) {
                return false;
            }
        }
        return true;
    };
}




module.exports = IsEmpty;
},{}],43:[function(require,module,exports){
function Range() {
    return function (input, min, max) {
        min = parseInt(min);
        max = parseInt(max);
        for (var i = min; i <= max; i++)
            input.push(i);
        return input;
    };
}

module.exports = Range;
},{}],44:[function(require,module,exports){
// show a star rating and the number of ratings. Expects a rating (float, 0 <= rating <= 10) and a number of ratings (integer, nrOfRatings >= 0)
// If there are any ratings:
// - a number of "active" stars and half-stars is displayed corresponding to half the rating (since the maximum number of stars is 5)
// - 5 inactive stars are displayed
// - active stars are placed on top of the inactive stars
function ShowRatingStars ($sce) {
    // We expect "rating" to be integer from 0 to 10 which we'll display on a scale from 0 to 5 stars
    return function(rating, nrOfRatings) {
        var noRatingMessage = '<span class="ratingMessage">There aren\'t enough ratings yet</span>';
        var backgroundStars = '<span class="backgroundStars"><span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span></span>';
        // sanitize rating parameter
        if (isFinite(String(rating).trim() || NaN) && nrOfRatings >= 20) {
            // clean up strange edge cases that should never happen
            if (rating <= 0) {
                return $sce.trustAsHtml(backgroundStars + noRatingMessage);
            } else if (rating > 10) {
                rating = 10;
            }

            // We're displaying Wilson rating and therefore we're rounding up,
            // otherwise use Math.round(rating);
            var roundedRating = Math.ceil(rating);
            var halfRating = Math.floor(roundedRating/2);
            var nrOfRemainingStars = 5;

            // open "active" block that is placed over the backgroundStars block
            var activeStars = '<span class="active">';

            // fill active block with full and half stars
            for (var i = 0; i < halfRating; i++) {
                activeStars += '<span class="icon-star"></span>';
                nrOfRemainingStars--;
            }
            if (roundedRating % 2 === 1) {
                activeStars += '<span class="icon-star-half"></span>';
                nrOfRemainingStars--
            }

            // fill the remainder of the block with inactive stars to get the message after the stars positioned correctly
            var inactiveStars = '';
            for (var j = 0; j < nrOfRemainingStars; j++ ) {
                inactiveStars += '<span class="icon-star inactive"></span>';
            }

            // close "active" block
            activeStars += inactiveStars + '</span>';

            // display number of ratings
            var nrOfRatingsMessage = '<span class="ratingMessage">' + nrOfRatings;
            if (nrOfRatings == 1) {
                nrOfRatingsMessage += ' rating</span>';
            } else {
                nrOfRatingsMessage += ' ratings</span>';
            }
            // assemble full display of stars & number of ratings message
            return $sce.trustAsHtml('<span class="ratingStars">' + backgroundStars + activeStars + '</span>' + nrOfRatingsMessage);
        } else {
            // no ratings are present
            return $sce.trustAsHtml(backgroundStars + noRatingMessage);
        }
    }
}


ShowRatingStars.$inject = ['$sce'];
module.exports = ShowRatingStars;
},{}],45:[function(require,module,exports){
function ToArray () {
  return function (obj, addKey) {
    if (!angular.isObject(obj)) return obj;
    if ( addKey === false ) {
      return Object.keys(obj).map(function(key) {
        return obj[key];
      });
    } else {
      return Object.keys(obj).map(function (key) {
        var value = obj[key];
        return angular.isObject(value) ?
          Object.defineProperty(value, '$key', { enumerable: false, value: key}) :
          { $key: key, $value: value };
      });
    }
  };
}




module.exports = ToArray;
},{}],46:[function(require,module,exports){
function unauthorizedReloadInterceptor($q, $cookies, $injector) {
  var responseInterceptor = {
    responseError: function(response) {
      var deferred = $q.defer();

      if (
        response.status == '401' &&
        typeof $cookies.get('gamehouse.pid') != 'undefined'
      ) {
        var $http = $injector.get('$http');
        $http.get('/csi/logout').then(function() {
          deferred.resolve(response);
          window.location.reload();
        });
      }
      return $q.reject(response);
    }
  };
  return responseInterceptor;
}

unauthorizedReloadInterceptor.$inject = ['$q', '$cookies', '$injector'];
module.exports = unauthorizedReloadInterceptor;

},{}],47:[function(require,module,exports){
var app = angular.module('gamehouseApp', [
  'ngResource',
  'ngRoute',
  'ngSanitize',
  'angulartics',
  'angulartics.google.analytics',
  'ui.bootstrap',
  'angular-svg-round-progress',
  'templates',
  'angular-mailcheck',
  'vAccordion',
  'ngCookies',
  'ngMessages',
  'credit-cards',
  'LocalStorageModule'
]);

/*
 * Routing
 */
app
  .config([
    '$routeProvider',
    '$sceDelegateProvider',
    '$httpProvider',
    'localStorageServiceProvider',
    '$locationProvider',
    function(
      $routeProvider,
      $sceDelegateProvider,
      $httpProvider,
      localStorageServiceProvider,
      $locationProvider
    ) {
      $httpProvider.interceptors.push('unauthorizedReloadInterceptor');
      // whitelist the CDN URL for purposes of getting Angular resources
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        memberStaticHostUrl + '/**'
      ]);

      // NOTE: the URL goes to '/#_=_' after logging with Facebook. This is to prevent our controller
      // to go to a 404 page
      if (window.location.hash == '#_=_') {
        window.location.hash = '';
      }

      localStorageServiceProvider.setDefaultToCookie(false);

      $routeProvider
        // "Regular" pages: home page, game, listing pages
        // Set up meta tag defaults
        .when('/', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'homeView.html',
          controller: 'HomeController'
        })
        .when('/games/:seoName', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'gamepageView.html',
          controller: 'GamepageController'
        })
        .when('/genre/:functionalId', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'genrepageView.html',
          controller: 'GenrepageController'
        })
        .when('/series/:seoName', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'seriespageView.html',
          controller: 'SeriespageController'
        })
        .when('/my-games', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'myGamesView.html',
          controller: 'MyGamesController'
        })
        .when('/exclusive-games', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'exclusiveGamesView.html',
          controller: 'ExclusiveGamesController'
        })
        .when('/top-rated', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'topRatedGamesView.html',
          controller: 'TopRatedGamesController'
        })
        .when('/top-played', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'topPlayedGamesView.html',
          controller: 'TopPlayedGamesController'
        })
        // My Account tabs
        // Redirect some obvious My Account URLs to the first tab
        .when('/my-account', {
          metaTitle: 'My Account - GameHouse',
          redirectTo: 'my-account/profile'
        })
        .when('/my-account/', {
          metaTitle: 'My Account - GameHouse',
          redirectTo: 'my-account/profile'
        })
        .when('/my-account/profile', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountProfileView.html',
          controller: 'MyAccountProfileController'
        })
        .when('/my-account/password', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountPasswordView.html',
          controller: 'MyAccountPasswordController'
        })
        .when('/my-account/membership/:message?', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountMembershipView.html',
          controller: 'MyAccountMembershipController'
        })
        .when('/my-account/settings', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountSettingsView.html',
          controller: 'MyAccountSettingsController'
        })
        .when('/my-account/purchasedgames', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountPurchasedGamesView.html',
          controller: 'MyAccountPurchasedGamesController'
        })
        .when('/my-account/privacy', {
          metaTitle: 'My Account - GameHouse',
          templateUrl: 'myAccountPrivacyView.html',
          controller: 'MyAccountPrivacyController'
        })
        // Sign-up flow
        .when('/signup', {
          metaTitle: 'Sign Up - GameHouse',
          templateUrl: 'signupView.html',
          controller: 'SignupController'
        })
        .when('/payment/promo/:promo/code/:code/:message?', {
          metaTitle: 'Promotion - GameHouse',
          templateUrl: 'paymentView.html',
          controller: 'PaymentController'
        })
        .when('/payment/promo/:promo?/:message?', {
          metaTitle: 'Promotion - GameHouse',
          templateUrl: 'paymentView.html',
          controller: 'PaymentController'
        })
        .when('/payment/:plan?/:message?', {
          metaTitle: 'Sign Up - GameHouse',
          templateUrl: 'paymentView.html',
          controller: 'PaymentController'
        })
        .when('/callback', {
          metaTitle: 'Sign Up - GameHouse',
          templateUrl: 'paymentLoadingView.html',
          controller: 'PaymentCallbackController'
        })
        .when('/paymentupdate/:plan?/:message?', {
          metaTitle: 'Sign Up - GameHouse',
          templateUrl: 'paymentView.html',
          controller: 'PaymentController'
        })
        .when('/success/:message?', {
          metaTitle: "You're a Member! - GameHouse",
          templateUrl: 'successView.html',
          controller: 'SuccessController'
        })
        .when('/ami-install', {
          metaTitle: 'Install Your Game to Start Playing - GameHouse',
          templateUrl: 'ami-installPageView.html',
          controller: 'AmipageController'
        })
        .when('/membership-plans', {
          metaTitle: 'Pick Your Plan - GameHouse',
          templateUrl: 'planPageView.html',
          controller: 'PlanpageController'
        })
        // "Edge" pages like Help, Contact, etc
        .when('/about-us', {
          metaTitle: 'About Us - GameHouse',
          templateUrl: 'aboutpageView.html'
        })
        .when('/contact', {
          metaTitle: 'Contact - GameHouse',
          templateUrl: 'contactpageView.html'
        })
        .when('/help', {
          metaTitle: 'Help - GameHouse',
          templateUrl: 'faqpageView.html'
        })
        .when('/terms-of-service', {
          metaTitle: 'Terms of Service - GameHouse',
          templateUrl: 'termsOfServiceView.html'
        })
        .when('/privacy-policy', {
          metaTitle: 'Privacy Policy - GameHouse',
          templateUrl: 'privacyPolicyPageView.html'
        })
        .when('/cookie-policy', {
          metaTitle: 'Cookie Policy - GameHouse',
          templateUrl: 'cookiesView.html'
        })
        .when('/arbitration-dispute-resolution-provisions', {
          metaTitle:
            'Arbitration and Dispute Resolution Provisions - GameHouse',
          templateUrl: 'arbitrationAndDispute.html'
        })
        .when('/upcoming/:seoName', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: 'upcomingGamePageView.html',
          controller: 'UpcomingGamePageController'
        })
        .when('/verify/:result/:id/:key/:hash', {
          metaTitle: 'Email Verification - GameHouse',
          template: ' ',
          controller: 'EmailVerificationController'
        })
        .when('/welcome', {
          metaTitle: 'Welcome - GameHouse',
          templateUrl: 'welcomeLandingPage.html'
        })
        .when('/promo/:name/:code?', {
          metaTitle: 'Promotion - GameHouse',
          templateUrl: 'promotionPageView.html',
          controller: 'PromotionPageController'
        })
        .when('/404', {
          metaTitle: 'Play All The Games You Love - GameHouse',
          metaDescription:
            'Looking for great games? You will find them on GameHouse! Try any game free or get unlimited access to all the games you love from your favorite genres.',
          templateUrl: '404View.html'
        })

        //Global redirects
        .when('/recently-played', {
          redirectTo: 'my-games'
        })
        .otherwise({
          redirectTo: '/404'
        });

      // use the HTML5 History API
      //$locationProvider.html5Mode(true);

      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
      });
    }
  ])
  .run([
    '$rootScope',
    'gatheringSvc',
    'userSvc',
    'amiSvc',
    'gameDataSvc',
    '$modal',
    '$location',
    '$cookies',
    'abtestService',
    'httpsRedirectService',
    'messageService',
    'emailVerificationService',
    'welcomeLandingPageService',
    function(
      $rootScope,
      gatheringSvc,
      userSvc,
      amiSvc,
      gameDataSvc,
      $modal,
      $location,
      $cookies,
      abtestService,
      httpsRedirectService,
      messageService,
      emailVerificationService,
      welcomeLandingPageService
    ) {
      // ----------------- TO DO -------------------------
      // PASS ALL THE DEFAULT VALUES TO THE CONFIG.JS FILE
      // -------------------------------------------------
      //Initiate some default values to assure correct function of the website.
      userSvc.checkVisitorId();

      // Set the meta content for the correct pages
      $rootScope.$on('$routeChangeSuccess', function(event, current, previous) {
        $rootScope.metaTitle = current.$$route.metaTitle;
        $rootScope.metaDescription = current.$$route.metaDescription;
      });

      $rootScope.defaultPlayLabel = 'PLAY';

      //Get default user params
      $rootScope.player = userSvc.getDefaultPlayer();

      //Get/check if is a logged user
      userSvc.getPlayer().success(function(data) {
        //Update default user params
        $rootScope.player = data;
        welcomeLandingPageService.setUserRetrieved();
      });

      $rootScope.playerOs = '';
      $rootScope.playerBrowser = '';
      $rootScope.playerDevice = '';
      $rootScope.playerLocation = { country: '', city: '' };

      $rootScope.messageCenterWindow = {
        show: false
      };

      //Put players in a abtest if any is running, and active the tests.
      abtestService.initialize();
      //Indicates the local time in milliseconds when the page is loaded.
      //Useful to indicate unique page loads and connect datagathering following that.
      $rootScope.pageLoadTime = new Date().getTime();

      // TODO This var needs to be removed when we have a decent video player
      $rootScope.isIE9 = false;

      $rootScope.denyPlayerAccess = false;
      $rootScope.homeInitDone = false;
      $rootScope.loading = false;
      $rootScope.newGames = null;
      $rootScope.recommendedGames = null;
      // object to represent the upcoming game we want to display in the hero carousel (if any)
      $rootScope.upcomingGame = null;
      // object to represent the promo notification on the carousel
      $rootScope.promoNotification = null;
      $rootScope.allCategories = [];
      $rootScope.allSeries = [];
      $rootScope.allCategoryGames = [];
      $rootScope.categoryCounter = [];
      $rootScope.newGameCounter = [];
      $rootScope.hideGameRow = [];
      $rootScope.showLoadMore = [];
      $rootScope.mobileView = false;
      $rootScope.gameStartCount = 0;
      $rootScope.playGameContentId = 0;
      $rootScope.hasHeroData = false;
      // AB-test V19 date check for anti-virus popup
      $rootScope.date = new Date();
      // Set header adjustments for payment flow
      $rootScope.showNormalNav = true;

      // make cdn image resources available within angular views
      $rootScope.cdnUrl = memberStaticHostUrl;

      // initial number of gameboxes, ordered by appearance on homepage
      // irregular rows (first box in row is double-sized)
      $rootScope.recentGameLimit = 3;

      // regular rows (all boxes are single-sized)
      $rootScope.recommendedGameLimit = 4;
      $rootScope.categoryGameLimit = 4;
      $rootScope.seriesLimit = 8;
      $rootScope.newGameLimit = 4;

      // number of (regular) boxes that's loaded when the "MORE GAMES" button is pressed
      $rootScope.moreGameLimit = 4;
      $rootScope.heroGamesLimit = 10;

      // -- "BECAUSE YOU PLAYED" RECOMMENDATION VARIABLES -- //
      // limit of the displayed games in box(row) in member page
      $rootScope.recommendedBecauseYouPlayedGameLimit = 7;
      // array holds games for "because you played" box(row) in member page. the array is populated from recommendedBecauseYouPlayedGamesRequested[].
      // recommendedBecauseYouPlayedGameLimit sets size of the array.
      $rootScope.recommendedBecauseYouPlayedGames = [];
      // limit for recommendedBecauseYouPlayedGamesRequested[]. in current cases is sum of recommendedBecauseYouPlayedGameLimit and heroGamesLimit(recommendedBecauseYouPlayedGameLimit + heroGamesLimit) :)
      $rootScope.recommendedBecauseYouPlayedGamesRequestedLimit =
        $rootScope.recommendedBecauseYouPlayedGameLimit +
        $rootScope.heroGamesLimit;
      // array  holds games list returned from getRecommendedBecauseYouPlayedGames() method.
      // this array is used to populate recommendedBecauseYouPlayedGames[] and if necessary hero image/carousel($scope.carouselItems).
      // e.g
      //  recommendedBecauseYouPlayedGames = recommendedBecauseYouPlayedGamesRequested.slice(0,recommendedBecauseYouPlayedGameLimit);
      //  carouselItems = recommendedBecauseYouPlayedGamesRequested.slice(recommendedBecauseYouPlayedGameLimit,recommendedBecauseYouPlayedGameLimit + heroGamesLimit);
      $rootScope.recommendedBecauseYouPlayedGamesRequested = [];

      // "because you played" recommendation is based on randomly selected game, and this variable hold this name.
      $rootScope.recommendedBecauseYouPlayedGameTitle = null;

      // --- EXCLUSIVE RELATED VARIABLES --- //

      // limit of the displayed games in box(row) in member page
      $rootScope.exclusiveLimit = 4;

      // Variables and functions related to sorting of the gameboxes
      var sortingOptions = [
        {
          id: 0,
          property: 'title',
          propertyBackend: 'title',
          reverse: false,
          title: 'Name',
          description: 'A-Z'
        },
        {
          id: 2,
          property: 'launchDate',
          propertyBackend: 'launchDate',
          reverse: true,
          title: 'Release Date',
          description: 'Newest First'
        },
        {
          id: 3,
          property: 'launchDate',
          propertyBackend: 'launchDate',
          reverse: false,
          title: 'Release Date',
          description: 'Oldest First'
        },
        {
          id: 4,
          property: 'rating.ratingScore',
          propertyBackend: 'rating.score',
          reverse: true,
          title: 'Top Rated',
          description: ''
        }
      ];
      $rootScope.genrePageSorting = {
        sortingOptions: sortingOptions,
        // initialize with "Release Date, Newest First"
        selectedOption: sortingOptions[1]
      };
      $rootScope.seriesPageSorting = {
        sortingOptions: sortingOptions,
        // initialize with "Release Date, Newest First"
        selectedOption: sortingOptions[1]
      };

      //-------------------------------------------------------------------
      // Declaration and initialisation of variables related to the Game Manager

      //GAMEMANAGER VARS
      $rootScope.hasAMI = false;
      $rootScope.hasOGM = false;
      $rootScope.deviceId = '';
      $rootScope.amiModalGameContentId = '';

      $rootScope.gameManager = [];
      $rootScope.gameManager.sessionGamesById = [];
      $rootScope.gameManager.sessionGamesByContentId = [];
      $rootScope.gameManager.sessionGamesInfo = [];
      $rootScope.gameManager.downloadQueue = [];

      // End of Trial Time pre-game popup recommended games
      $rootScope.gameManager.recommendedGames = [];
      // End of Hour Trial post-game popup recommended games
      $rootScope.gameManager.recommendedGamesEndOfHourTrial = [];

      $rootScope.surveyResults = {
        reason: '',
        followup: ''
      };

      //List with active messages for the user
      $rootScope.messageList = [];
      messageService.initialize();
      $rootScope.removeMessage = function(id) {
        messageService.removeMessage(id);
      };

      //-------------------------------------------------------------------
      // register media query breakpoints by using enquire.js
      enquire
        .register('screen and (max-width: 767px)', function() {
          $rootScope.mobileView = true;
          $rootScope.recommendedBecauseYouPlayedGameLimit = 3;
        })
        .register(
          'screen and (min-width: 768px) and (max-width: 991px)',
          function() {
            $rootScope.mobileView = false;
            $rootScope.recommendedBecauseYouPlayedGameLimit = 3;
          }
        )
        .register(
          'screen and (min-width: 992px) and (max-width: 1199px)',
          function() {
            $rootScope.mobileView = false;
            $rootScope.recommendedBecauseYouPlayedGameLimit = 7;
          }
        )
        .register('screen and (min-width: 1200px)', function() {
          $rootScope.mobileView = false;
          $rootScope.recommendedBecauseYouPlayedGameLimit = 7;
        });

      function checkPlayerAccessAllowed() {
        function openMacModal() {
          $rootScope.$broadcast('modal.open', {
            templateUrl: 'popups/wrongOsBrowserMac.html'
          });
        }

        if (
          $rootScope.playerOs === 'MAC_OS' ||
          $rootScope.playerOs === 'MAC_OS_X'
        ) {
          $rootScope.denyPlayerAccess = true;
          // suppress the Mac popup if you're on the contact page, otherwise it's inaccessible
          if ($location.path() !== '/contact') {
            openMacModal();
          }
        } else if ($rootScope.playerBrowser === 'IE9') {
          $rootScope.isIE9 = true;
        }
      }

      function showWelcomeToClassicPlayer() {
        if ($cookies.get('classicPlayer') === 'true') {
          $cookies.remove('classicPlayer', {
            path: '/',
            domain: '.gamehouse.com'
          });

          userSvc.getPlayer().then(function(response) {
            refreshPlayer(response.data);
          });

          var refreshPlayer = function(player) {
            $rootScope.player = player;
            $rootScope.$broadcast('modal.open', {
              templateUrl: 'popups/welcomeBackClassicPlayer.html'
            });
          };
        }
      }

      /**
       * When somebody is kicked out of a game and signsup we want to start
       * the game directly after signup. In other cases this value need to be reset.
       */
      function checkPostTrialSignUp() {
        if (
          $location.path() !== '/signup' &&
          $location.path() !== '/payment' &&
          $location.path() !== '/payment/promo' &&
          $location.path() !== '/callback' &&
          $location.path() !== '/success' &&
          $location.path() !== '/success/paypal' &&
          $location.path() !== '/success/promo' &&
          $location.path() !== '/success/promo-paypal' &&
          $location.path() !== '/membership-plans'
        ) {
          $cookies.remove('postTrialContentId', { path: '/' });
        }
      }

      // -------------------------------------------------------------------
      // Set player details in rootScope
      //
      // BI PageVisit integration
      $rootScope.isUserLoaded = false;
      userSvc
        .getPlayer()
        .then(function(response) {
          $rootScope.isUserLoaded = true;
          $rootScope.player = response.data;
          if (!response.data) {
            gatheringSvc.sendErrorInfo(
              'GetPlayer',
              ' Error: failed getting player data / ' + response.error
            );
          }

          if ($rootScope.player.userId === -1) {
            if (typeof aminstant != 'undefined') {
              aminstant.ready(function() {
                $cookies.put('deviceId', aminstant.device_id, { path: '/' });
                userSvc
                  .getPlayerByDeviceId(aminstant.device_id)
                  .then(function(playerResponse) {
                    $rootScope.player = playerResponse.data;
                  });
              });
            } else {
              var cookieDeviceId = $cookies.get('deviceId');
              userSvc
                .getPlayerByDeviceId(cookieDeviceId)
                .then(function(playerResponse) {
                  $rootScope.player = playerResponse.data;
                });
            }
          } else {
            messageService.triggerEndOfSubscriptionMessage();
          }
        })
        .then(function() {
          userSvc
            .getPlayerBrowserOs()
            .success(function(data) {
              $rootScope.playerOs = data.operatingSystem;
              $rootScope.playerBrowser = data.browser;
              $rootScope.playerDevice = data.device;
            })
            .then(function() {
              //Validate the player is allowed to access the website.
              checkPlayerAccessAllowed();
              //Track this page visit.
              gatheringSvc.sendBiPageVisitInfo();
              //Track some additional data like screen resolution and useragent.
              gatheringSvc.sendExtendedPlayerDetails();
            });
        })
        .then(function() {
          userSvc.getPlayerLocation().success(function(data) {
            $rootScope.playerLocation = data;
          });
        });

      // Load data needed to display the "Genres" dropdown menu
      gameDataSvc
        .getAllCategories('allCategories')
        .success(function(allCategories) {
          if (!allCategories.error) {
            $rootScope.allCategories = allCategories;
          } else {
            gatheringSvc.sendErrorInfo(
              'GetCategories',
              ' Error: failed getting game categories'
            );
          }
        });

      // Load data needed to display the GamesManager dropdown menu -- Recently played games
      $rootScope.loadRecentlyPlayedGames = function() {
        gameDataSvc
          .getRecentGames($rootScope.recentGameLimit)
          .success(function(recentGames) {
            if (!recentGames.error) {
              if (recentGames.gameList.length === 0) {
                $rootScope.recentGames = [];
              } else {
                $rootScope.recentGames = recentGames.gameList;
              }
            } else {
              gatheringSvc.sendErrorInfo(
                'GetRecentGames',
                ' Error: failed getting recent games. Reason: ' +
                  recentGames.error
              );
            }
          });
      };
      $rootScope.loadRecentlyPlayedGames();

      $rootScope.playGame = function(game, event, pos, angularEvent) {
        event = event || undefined;
        pos = pos || 0;

        $rootScope.tagEvent(event, {
          'game-name': game.title,
          'genre-name': game.genre.title,
          'game-id': game.id,
          'ui-position': pos
        });

        if (
          $rootScope.player.isLoggedIn &&
          !$rootScope.player.isValidated &&
          $rootScope.player.isEmailValidationGracePeriodExpired
        ) {
          $rootScope.$broadcast('modal.close');
          $rootScope.$broadcast('modal.open', {
            controller: function($scope) {
              $scope.sendValidationEmail = function sendValidationEmail() {
                emailVerificationService.sendValidationEmail();
              };
            },
            templateUrl: 'popups/emailVerificationExpiredGraceTime.html'
          });
          return;
        }

        if (!$rootScope.hasAMI) {
          $rootScope.tagEvent('gameplay-first', {
            'game-name': game.title,
            'genre-name': game.genre.title,
            'game-id': game.id,
            'ui-position': pos
          });
          $rootScope.tagEvent('ami-install-click', {
            'game-name': game.title,
            'genre-name': game.genre.title,
            'game-id': game.id,
            'ui-position': pos
          });
        } else {
          $rootScope.tagEvent('gameplay-after-first', {
            'game-name': game.title,
            'genre-name': game.genre.title,
            'game-id': game.id,
            'ui-position': pos
          });
        }

        // TODO! Move this all logic to a advertisement service
        if (
          $rootScope.hasAMI &&
          $rootScope.player.isEntitled === false &&
          $rootScope.advertisement.activatedAdBlock === false
        ) {
          var contentId = game.contentId;
          var hasGameInstalled = false;

          // Check if the user has installed the clicked game
          aminstant.listGames(contentId, function(result) {
            if (result.error === null) {
              for (var index = 0; index < result.games.length; index++) {
                const game = result.games[index];
                if (
                  game.content_id === contentId &&
                  game.is_installed === true
                ) {
                  hasGameInstalled = true;
                }
              }
            }

            // If the user has already the game installed then display the ad
            if (hasGameInstalled) {
              $rootScope.$broadcast('modal.close');
              $rootScope.advertisement.display = true;

              $rootScope.$broadcast('advertisement.play', {
                referenceId: game.referenceId,
                closeModal: function closeModal() {
                  $rootScope.advertisement.display = false;
                },
                startGame: function startGame() {
                  launchGame();
                }
              });
            } else {
              // If the game has to be installed, then not display ad
              launchGame();
            }
          });
        } else {
          // If the user has not AMI or
          // is not freemium
          // or the ad server has an error
          // or the adblock is activen
          // then display AD
          launchGame();
        }

        function launchGame() {
          if (angularEvent) {
            amiSvc.startGame(
              game,
              angular.element(angularEvent.target).offset()
            );
          } else {
            amiSvc.startGame(game);
          }
        }
      };

      $rootScope.deleteFromQueue = function(contentId, messageId) {
        amiSvc.deleteFromQueue(contentId);
        if (messageId) {
          messageService.removeGameMessageWithFadeOut(contentId, messageId);
        }
      };

      $rootScope.stopInstallation = function(contentId, messageId) {
        amiSvc.stopInstallation(contentId);
        if (messageId) {
          messageService.removeGameMessageWithFadeOut(contentId, messageId);
        }
      };

      $rootScope.insertGame = function(game) {
        amiSvc.insertGame(game);
      };

      $rootScope.subscribe = function() {
        $rootScope.$broadcast('modal.close');
        $location.path('/membership-plans');
      };

      $rootScope.animateGamePlay = function(
        elementOffSet,
        imageSource,
        callback
      ) {
        var bellElement = angular.element(
          document.getElementsByClassName('icon-bell')
        );
        var imgClone = angular.element('<img src="' + imageSource + '"/>');

        var offsetLeft = elementOffSet.left - bellElement.offset().left;
        var offsetTop = elementOffSet.top - bellElement.offset().top;
        imgClone.css({
          height: '0px',
          width: '0px',
          position: 'absolute',
          top: offsetTop + 'px',
          left: offsetLeft + 'px',
          opacity: 0.2,
          transition: 'all ease-in-out 0.25s',
          '-webkit-transition': 'all ease-in-out 0.25s',
          '-moz-transition': 'all ease-in-out 0.25s',
          '-o-transition': 'all ease-in-out 0.25s'
        });
        bellElement.append(imgClone);

        setTimeout(function() {
          imgClone.css({
            height: '267px',
            width: '267px',
            position: 'absolute',
            top: offsetTop - 125 + 'px',
            left: offsetLeft + 'px',
            opacity: 0.7
          });
          setTimeout(function() {
            imgClone.css({
              height: '75px',
              width: '75px',
              top: '56px',
              left: '-18px',
              opacity: 0.7,
              transition: 'all ease-in-out 1.0s',
              '-webkit-transition': 'all ease-in-out 1.0s',
              '-moz-transition': 'all ease-in-out 1.0s',
              '-o-transition': 'all ease-in-out 1.0s'
            });
            setTimeout(function() {
              callback();
              setTimeout(function() {
                imgClone.remove();
              }, 500);
            }, 900);
          }, 250);
        }, 0);
      };

      //Clicktracking on the rootscope to access from html views.
      $rootScope.sendClickTracking = function(location, item) {
        gatheringSvc.sendClickTracking(location, item);
      };

      $rootScope.login = function(event) {
        event = event || 'header-login-click';
        //Tag the click login event
        $rootScope.tagEvent(event);
        window.location.href =
          '/csi/login?redirecturl=' + encodeURIComponent($location.absUrl());
      };

      $rootScope.logout = function(event) {
        event = event || 'header-logout-click';
        //Tag the click logout event
        $rootScope.tagEvent(event);
        window.location.href = '/csi/logout';
      };

      //Adds event to data layer
      //Method is attached to $rootScope so it can be accessed at member.jsp page
      $rootScope.tagEvent = function(tag, params) {
        //Default data layer params
        var parameters = params || {};

        parameters['event'] = tag;
        parameters['has-ami'] = $rootScope.hasAMI ? 'yes' : 'no';
        parameters['is-member'] = $rootScope.player.isLoggedIn
          ? $rootScope.player.isEntitled
            ? 'yes'
            : 'no'
          : 'no';
        parameters['is-logged'] = $rootScope.player.isLoggedIn ? 'yes' : 'no';
        parameters['url'] = $location.path();
        parameters['game-played-count'] = $rootScope.player.gamePlayedCount
          ? $rootScope.player.gamePlayedCount
          : 0;

        dataLayer.push(parameters);
      };

      //Helper method to split the current URL's session
      var getPage = function() {
        var page = $location.path().split('/')[1] || '/';
        return page;
      };

      // before going to the new URL, make sure it shouldn't be in https instead of http (or vice versa)
      $rootScope.$on('$locationChangeStart', function(event, next, current) {
        if (httpsRedirectService.redirectHttps(next)) {
          event.preventDefault();
        }

        //If ami install after refresh send to root because data is missing.
        if (
          next.indexOf('/ami-install') > -1 &&
          !$rootScope.amiModalGameContentId
        ) {
          gatheringSvc.sendClickTracking(
            'ami-install',
            'Redirect to home after refresh/direct visit.'
          );
          event.preventDefault();
          $location.path('/');
        }
      });

      //Set the behaviour on virtual page view.
      $rootScope.$on('$routeChangeSuccess', function() {
        //Replacing analytics by tag manager
        //every loaded page goes thru this validation

        //Set default params

        if ($rootScope.isUserLoaded) {
          processPageView();
        } else {
          $rootScope.$watch('isUserLoaded', function(nv, ov) {
            if (nv) {
              processPageView();
            }
          });
        }

        function processPageView() {
          var params = {
            url: $location.path(),
            event: 'page-event',
            'user-id': $rootScope.player.userId,
            'user-email': $rootScope.player.email,
            'has-ami': $rootScope.hasAMI ? 'yes' : 'no',
            'page-type': null,
            'is-member': $rootScope.player.isLoggedIn
              ? $rootScope.player.isEntitled
                ? 'yes'
                : 'no'
              : 'no',
            'is-logged': $rootScope.player.isLoggedIn ? 'yes' : 'no',
            'page-genre': null,
            'game-name': null,
            'game-id': null,
            'game-played-count': $rootScope.player.gamePlayedCount
              ? $rootScope.player.gamePlayedCount
              : 0
          };

          //Handling page's specific attributes
          var page = getPage();
          switch (page) {
            case 'games':
              params['page-type'] = 'Game';
              //Get BD game data structure based on the URL
              var gameName = $location
                .path()
                .split('/')[2]
                .toString();
              gameDataSvc
                .getSpecificGame(gameName)
                .success(function(data) {
                  params['game-name'] = data.title.toString();
                  params['game-id'] = data.id.toString();
                  dataLayer.push(params);
                })
                .error(function(data) {
                  dataLayer.push(params);
                });
              break;
            case 'genre':
              params['page-type'] = 'Genre';
              params['genre-name'] = $location
                .path()
                .split('/')[2]
                .toString();
              dataLayer.push(params);
              break;
            case 'signup':
              params['page-type'] = 'Signup';
              dataLayer.push(params);
              break;
            case '/':
              params['page-type'] = 'Home';
              dataLayer.push(params);
              break;
            case 'help':
              params['page-type'] = 'Help';
              dataLayer.push(params);
              break;
            case 'about us':
              params['page-type'] = 'About us';
              dataLayer.push(params);
              break;
            default:
              params['page-type'] = page
                .replace(/-/g, ' ')
                .replace(/\w\S*/g, function(txt) {
                  return (
                    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                  );
                });
              dataLayer.push(params);
              break;
          }
        }

        // Close all popups
        $rootScope.$broadcast('modal.close');

        // Validate the player is allowed to access the website.
        checkPlayerAccessAllowed();

        //If the player just logged in with a classic account, show them a welcome screen
        showWelcomeToClassicPlayer();

        //Indicates the local time in milliseconds when the page is loaded.
        //Useful to indicate unique page loads and connect datagathering following that.
        $rootScope.pageLoadTime = new Date().getTime();
        if ($rootScope.isUserLoaded) {
          gatheringSvc.sendBiPageVisitInfo();
        }

        checkPostTrialSignUp();
      });
    }
  ]);

app.controller(
  'GamepageController',
  require('./controllers/gamepageController.js')
);
app.controller(
  'GenrepageController',
  require('./controllers/genrepageController.js')
);
app.controller(
  'SeriespageController',
  require('./controllers/seriespageController.js')
);
app.controller('HomeController', require('./controllers/homeController.js'));
app.controller(
  'MyGamesController',
  require('./controllers/myGamesController.js')
);
app.controller(
  'ExclusiveGamesController',
  require('./controllers/exclusiveGamesController.js')
);
app.controller(
  'TopRatedGamesController',
  require('./controllers/topRatedGamesController.js')
);
app.controller(
  'TopPlayedGamesController',
  require('./controllers/topPlayedGamesController.js')
);
app.controller(
  'PlanpageController',
  require('./controllers/planpageController.js')
);
app.controller(
  'UpcomingGamePageController',
  require('./controllers/upcomingGamePageController.js')
);
app.controller(
  'EmailVerificationController',
  require('./controllers/emailVerificationController.js')
);
app.controller(
  'PrivacyPolicyController',
  require('./controllers/privacyPolicyController.js')
);
app.controller(
  'PrivacyPolicyPopupController',
  require('./controllers/privacyPolicyPopupController.js')
);
app.controller(
  'PromotionPageController',
  require('./controllers/promotionPageController.js')
);

// My Account
app.controller(
  'MyAccountProfileController',
  require('./controllers/myAccountProfileController.js')
);
app.controller(
  'MyAccountPasswordController',
  require('./controllers/myAccountPasswordController.js')
);
app.controller(
  'MyAccountMembershipController',
  require('./controllers/myAccountMembershipController.js')
);
app.controller(
  'MyAccountSettingsController',
  require('./controllers/myAccountSettingsController.js')
);
app.controller(
  'MyAccountPrivacyController',
  require('./controllers/myAccountPrivacyController.js')
);
app.controller(
  'MyAccountPurchasedGamesController',
  require('./controllers/myAccountPurchasedGamesController.js')
);

// A-B testpages
app.controller(
  'AmipageController',
  require('./controllers/amipageController.js')
);

app.controller(
  'SignupController',
  require('./controllers/signupController.js')
);
app.controller(
  'PaymentController',
  require('./controllers/paymentController.js')
);
app.controller(
  'SuccessController',
  require('./controllers/successController.js')
);
app.controller(
  'PaymentCallbackController',
  require('./controllers/paymentCallbackController.js')
);

app.factory('amiSvc', require('./services/ami.service.js'));
app.factory('accountService', require('./services/account.service.js'));
app.factory('gameDataSvc', require('./services/gameData.service.js'));
app.factory('gatheringSvc', require('./services/dataGathering.service.js'));
app.factory('genreService', require('./services/genre.service.js'));
app.factory('seriesService', require('./services/series.service.js'));
app.factory('retryService', require('./services/retry.service.js'));
app.factory('userSvc', require('./services/user.service.js'));
app.factory('abtestService', require('./services/abtest.service.js'));
app.factory(
  'customPaymentService',
  require('./services/customPayment.service.js')
);
app.factory(
  'httpsRedirectService',
  require('./services/httpsredirect.service.js')
);
app.factory('messageService', require('./services/message.service.js'));
app.factory(
  'emailVerificationService',
  require('./services/emailVerification.service.js')
);
app.factory('privacyService', require('./services/privacy.service.js'));
app.factory(
  'welcomeLandingPageService',
  require('./services/welcomeLandingPage.service.js')
);
app.factory('PromoService', require('./services/promo.service.js'));

app.factory(
  'unauthorizedReloadInterceptor',
  require('./interceptor/unauthorizedreload.interceptor.js')
);

app.directive('carousel', require('./directives/carousel.directive.js'));
app.directive(
  'heroCarousel',
  require('./directives/hero-carousel.directive.js')
);
app.directive('gamebox', require('./directives/gamebox.directive.js'));
app.directive('seriesbox', require('./directives/seriesbox.directive.js'));
app.directive('search', require('./directives/search.directive.js'));
app.directive(
  'scrollToTop',
  require('./directives/scroll-to-top.directive.js')
);
app.directive(
  'notificationBanner',
  require('./directives/notification-banner.directive.js')
);
app.directive(
  'staticBanner',
  require('./directives/static-banner.directive.js')
);
app.directive(
  'modalManager',
  require('./directives/modal-manager.directive.js')
);
app.directive(
  'myaccountnavigation',
  require('./directives/my-account-navigation.directive.js')
);
app.directive(
  'processpaymentoverlay',
  require('./directives/process-payment-overlay.directive.js')
);
app.directive(
  'postalcodeformatter',
  require('./directives/postalcode-format.directive.js')
);
app.directive('ccvalidator', require('./directives/cc-validator.directive.js'));
app.directive(
  'cvcvalidator',
  require('./directives/cvc-validator.directive.js')
);
app.directive(
  'advertisementModal',
  require('./directives/advertisement-modal.directive.js')
);

app.filter('isEmpty', require('./filters/is-empty.filter.js'));
app.filter('showRatingStars', require('./filters/show-rating-stars.filter.js'));
app.filter('toArray', require('./filters/to-array.filter.js'));
app.filter('range', require('./filters/range.filter.js'));

window.app = app;

},{"./controllers/amipageController.js":2,"./controllers/emailVerificationController.js":3,"./controllers/exclusiveGamesController.js":4,"./controllers/gamepageController.js":5,"./controllers/genrepageController.js":6,"./controllers/homeController.js":7,"./controllers/myAccountMembershipController.js":8,"./controllers/myAccountPasswordController.js":9,"./controllers/myAccountPrivacyController.js":10,"./controllers/myAccountProfileController.js":11,"./controllers/myAccountPurchasedGamesController.js":12,"./controllers/myAccountSettingsController.js":13,"./controllers/myGamesController.js":14,"./controllers/paymentCallbackController.js":15,"./controllers/paymentController.js":16,"./controllers/planpageController.js":17,"./controllers/privacyPolicyController.js":18,"./controllers/privacyPolicyPopupController.js":19,"./controllers/promotionPageController.js":20,"./controllers/seriespageController.js":21,"./controllers/signupController.js":22,"./controllers/successController.js":23,"./controllers/topPlayedGamesController.js":24,"./controllers/topRatedGamesController.js":25,"./controllers/upcomingGamePageController.js":26,"./directives/advertisement-modal.directive.js":27,"./directives/carousel.directive.js":28,"./directives/cc-validator.directive.js":29,"./directives/cvc-validator.directive.js":30,"./directives/gamebox.directive.js":31,"./directives/hero-carousel.directive.js":32,"./directives/modal-manager.directive.js":33,"./directives/my-account-navigation.directive.js":34,"./directives/notification-banner.directive.js":35,"./directives/postalcode-format.directive.js":36,"./directives/process-payment-overlay.directive.js":37,"./directives/scroll-to-top.directive.js":38,"./directives/search.directive.js":39,"./directives/seriesbox.directive.js":40,"./directives/static-banner.directive.js":41,"./filters/is-empty.filter.js":42,"./filters/range.filter.js":43,"./filters/show-rating-stars.filter.js":44,"./filters/to-array.filter.js":45,"./interceptor/unauthorizedreload.interceptor.js":46,"./services/abtest.service.js":48,"./services/account.service.js":49,"./services/ami.service.js":50,"./services/customPayment.service.js":51,"./services/dataGathering.service.js":52,"./services/emailVerification.service.js":53,"./services/gameData.service.js":54,"./services/genre.service.js":55,"./services/httpsredirect.service.js":56,"./services/message.service.js":57,"./services/privacy.service.js":58,"./services/promo.service.js":59,"./services/retry.service.js":60,"./services/series.service.js":61,"./services/user.service.js":62,"./services/welcomeLandingPage.service.js":63}],48:[function(require,module,exports){
function abtestService($cookies, gatheringSvc, $templateCache, $rootScope) {
    $rootScope.playerAbtests = [];
    var runningAbtests = [];

    // TODO: ABTEST NUMBER
    // TODO: Create/Request your next A/B test no. in Confluence
    // Visit: http://confluence.gamehouse.com/display/GFLIX/AB-tests

    //Example test
    /*
     Version: 1, Variants: 2
     Description: Testing if removing hero image on game page generates more plays.
     Changes: Replacing "gamepageView.html".
     */
    //runningAbtests.push(['1:0', '1:1', '1:2']);
    //End of example test

    ///////////////////////Running tests, only have running tests here..///////////////////////////

    /////////////////////// End of Running tests.///////////////////////////

    function activateTemplateTests() {
        //Example test
        /*
         if(isUserInAbtest(1,1)){
         $templateCache.put('gamepageView.html', $templateCache.get('abtests/gamepageView-1-1.html'));
         if(isUserInAbtest(1,2)){
         $templateCache.put('gamepageView.html', $templateCache.get('abtests/gamepageView-1-2.html'));
         }
         */
    }


    /**
     * Check if the given string contains a correctly formatted abtest value.
     * For example: 7:2
     * @param abtest
     * @returns {boolean} true if correct format.
     */
    function isValidFormat(abtest) {
        try {
            var abtestSplit = abtest.split(':');

            return abtestSplit.length === 2 && !isNaN(parseFloat(abtestSplit[0])) && !isNaN(parseFloat(abtestSplit[1])) &&
                isFinite(abtestSplit[0]) &&
                isFinite(abtestSplit[1]);
        } catch (e) {
        }
        return false;
    }

    /**
     * Retrieve the cookie containing the abtests the user is in, check if the format is valid
     * and return an array with valid formatted ab tests.
     * @returns {Array} with valid formatted abtests
     */
    function getAbtestsFromCookie() {
        var abtests = [];
        var cookieValue = $cookies.get('abtest');
        try {
            if (cookieValue != null) {
                var splitValue = decodeURI(cookieValue).split(',');
                splitValue.forEach(function (item) {
                    if (isValidFormat(item)) {
                        abtests.push(item);
                    }
                });
            }
        } catch (e) {
            gatheringSvc.sendErrorInfo('abtest-getAbTestsFromCookie', 'Convert error.');
        }
        return abtests;
    }

    /**
     * Filter the given list with abtest to only contain the currently active tests.
     * This function expects a valid list of abtests.
     * @param abtests
     * @returns {Array}
     */
    function filterInActiveAbtests(abtests) {
        var filteredActiveAbtests = [];
        //Put all active tests in a single dimensional array.
        var allActiveAbTests = [];
        runningAbtests.forEach(function (arr) {
            arr.forEach(function (item) {
                allActiveAbTests.push(item);
            });
        });

        //Loop trough the given list of abtests and check if they are in the given list.
        //If so then put them in the result.
        abtests.forEach(function (item) {
            if (allActiveAbTests.indexOf(item) > -1) {
                filteredActiveAbtests.push(item);
            }
        });
        return filteredActiveAbtests;
    }

    /**
     * Set a cookie with abtests, the given list is the one retrieved from the cookie.
     * Then we skip the groups that the given abtest are in and additionally add abtests from missing groups.
     * Making sure that the player in the end has 1 abtest from every active group.
     * @param abtests
     * @returns {Array.<T>} With an active abtest from every group.
     */
    function setAbtestToCookie(abtests) {
        //Filter given abtests from user cookie to only contain active ones.
        var activeAbtests = filterInActiveAbtests(abtests);
        runningAbtests.forEach(function (runningArr) {
            //For every running abtest group check if we already have one in the players cookie list.
            var isAlreadyActive = false;
            runningArr.forEach(function (item) {
                if (activeAbtests.indexOf(item) > -1) {
                    isAlreadyActive = true;
                }
            });
            //If not yet in the players cookie list randomly pick one from that group.
            if (!isAlreadyActive) {
                activeAbtests.push(runningArr[Math.floor(Math.random() * runningArr.length)]);
            }
        });

        //Filter out any double entries, shouldn't occur.
        var abtestsUnique = activeAbtests.filter(function (elem, pos, arr) {
            return arr.indexOf(elem) == pos;
        });

        //Put the value in a long lasting cookie.
        $cookies.put('abtest', encodeURI(abtestsUnique.toString()),
            {path: '/', expires: new Date((new Date()).getTime() + (90 * 86400000))}); //90 days
        return abtestsUnique;
    }

    /**
     * Check if a user is currently in an abtest, use this to trigger abtest logic.
     * Function should be called after initialize.
     * @param version
     * @param variant
     * @returns {boolean}
     */
    function isUserInAbtest(version, variant) {
        var abtest = version + ':' + variant;
        var result = false;
        angular.forEach($rootScope.playerAbtests, function (current) {
            if(current == abtest){
                result = true;
            }
        });

        return result;
    }

    /**
     * Initializes the players abtest and activates the abtest template replacement.
     * - Retrieves abtests from cookie.
     * - Sets abtests from cookie + missing ones to cookie.
     * - Sets the abtests in a global var
     * - Activates the templates.
     */
    var initialize = function () {
        var abtests = [];
        try {
            abtests = getAbtestsFromCookie();
            abtests = setAbtestToCookie(abtests);
            if($cookies.get('qa') != null){
                abtests = [];
            }
            $rootScope.playerAbtests = abtests;
            activateTemplateTests();
        } catch (e) {
            gatheringSvc.sendErrorInfo('abtest-initliaze', 'Initialization error.');
        }
    };

    var isInAbtest = function (version, variant) {
        return isUserInAbtest(version, variant);
    };

    return {
        initialize: initialize,
        isInAbtest: isInAbtest
    }
}

abtestService.$inject = ['$cookies', 'gatheringSvc', '$templateCache', '$rootScope'];
module.exports = abtestService;
},{}],49:[function(require,module,exports){
function AccountService($http, $q, retryService) {
  // Cache the first name so you do not need to refresh account details every time
  var cachedName = null;

  var saveCachedName = function(response) {
    cachedName = response.data.name;

    // Return the same Angular Promise as we got as argument
    return response;
  };

  // Format errors for use in forms
  var getErrors = function(response) {
    // Errors per field, the field name will be the key
    var errors = {};

    if (response.data && response.data.length) {
      response.data.forEach(function(error) {
        if (!error.field || !error.message) {
          return;
        }

        // Add to exisiting field
        if (errors.hasOwnProperty(error.field)) {
          errors[error.field] += ' – ' + error.message;
        }

        // Set a new error message for this field
        else {
          errors[error.field] = error.message;
        }
      });
    }

    return errors;
  };

  // Create account details
  // After that what is returned can be used as Angular Promise

  var createAccount = function(signup) {
    var url, data;
    url = '/csi/signup';
    data = {
      emailAddress: signup.emailAddress,
      deviceId: signup.deviceId,
      password: signup.password,
      newsletter: signup.newsletter,
      redirectUrl: signup.redirectUrl
    };

    return $http.post(url, data);
  };

  // Fetch account details, then save the first name
  // After that what is returned can be used as Angular Promise
  var getAccount = function() {
    var promise = retryService.retry(function() {
      return $http.get('/myaccount/api/player');
    });

    return promise.then(saveCachedName);
  };

  // Get the name, from cache
  // Or as fallback via the fetch of account details
  // Returns an Angular Promise
  var getName = function() {
    if (cachedName) {
      return $q.resolve(cachedName);
    }

    return getAccount().then(function() {
      // cachedName is now set by getAccount
      // When you return it, it will be the argument of the callback
      // so `.getName().then(function (name) {})`
      // will have `cachedName` as `name`-argument.
      return cachedName;
    });
  };

  // Set account details
  // Returns an Angular Promise
  var setAccount = function(account) {
    var url, data;

    url = '/myaccount/api/player';
    data = {
      emailAddress: account.emailAddress,
      name: account.name
    };

    return $http.post(url, data);
  };

  // Set account settings
  // Returns an Angular Promise
  var setAccountSettings = function(account) {
    var url, data;

    url = '/myaccount/api/player/settings';
    data = {
      newsletterActive: account.newsletterActive,
      preloadingEnabled: account.preloadingEnabled
    };

    return $http.post(url, data);
  };

  // Change the password
  // Returns an Angular Promise
  var changePassword = function(changePassword) {
    var url, data;

    url = '/myaccount/api/password';
    data = {
      oldPassword: changePassword.oldPassword,
      password: changePassword.newPassword
    };

    return $http.post(url, data);
  };

  // Returns a list of legacy games purchased for a player with legacy id
  var getLegacyGames = function(playerLegacyId) {
    var url = '/website/api/player/legacy/games';

    return $http.get(url, {
      params: { legacyid: playerLegacyId }
    });
  };

  var getEntitlement = function() {
    return retryService.retry(function() {
      return $http.get('/myaccount/api/entitlement', {});
    });
  };

  var cancelMembership = function() {
    var url, data;
    url = '/myaccount/api/subscription/cancel';
    return $http.put(url, data);
  };

  var keepMembership = function() {
    var url, data;
    url = '/myaccount/api/subscription/cancel/undo';
    return $http.put(url, data);
  };

  const removeAccount = function removeAccount(password) {
    const url = '/myaccount/api/player/delete';
    const data = {
      password: password
    };
    return $http.post(url, data);
  };

  const verifyPassword = function verifyPassword(password) {
    const url = '/myaccount/api/password/verify';
    const data = {
      password: password
    };
    return $http.post(url, data);
  };

  // Expose parts of this scope to the Angular Controllers/Directives etc
  return {
    getErrors: getErrors,
    getName: getName,
    createAccount: createAccount,
    removeAccount: removeAccount,
    getAccount: getAccount,
    setAccount: setAccount,
    setAccountSettings: setAccountSettings,
    changePassword: changePassword,
    verifyPassword: verifyPassword,
    getEntitlement: getEntitlement,
    cancelMembership: cancelMembership,
    keepMembership: keepMembership,
    getLegacyGames: getLegacyGames
  };
}

AccountService.$inject = ['$http', '$q', 'retryService'];
module.exports = AccountService;

},{}],50:[function(require,module,exports){
function AmiSvc(
  $rootScope,
  $http,
  gatheringSvc,
  $modal,
  $modalStack,
  $location,
  $cookies,
  gameDataSvc,
  abtestService,
  messageService
) {
  var FALLBACK_INSTALLER_URL =
    'http://games-dl.gamehouse.com/gamehouse/activemark/aminstantservice/GameHouse_GamePlayer.exe';
  var AMI_SECONDARY_API_PORT = 27021;
  var OGM_API_PORT = 12071;
  var totalTrialTime = 3600;
  var minTrialTime = 30;
  var ogmAmiInstallTimeout = false;
  var isInstallAmiSuccessDisplayed = false;
  var gamestartTime;
  var detectGameCrashFailurePeriod = 10000; // 10 seconds
  var cookieNameSuppressAfterGamePlayPopup = 'ghSuppressAfterGamePlayPopup';

  if (typeof aminstant != 'undefined') {
    aminstant.ready(function() {
      $rootScope.deviceId = aminstant.device_id;
      $rootScope.hasAMI = true;

      //BEGIN: TEMP AMI UPGRADE CODE
      var is800 = aminstant.service_version.indexOf('v8.00.') > 0;
      var is810 = aminstant.service_version.indexOf('v8.10.') > 0;
      var is820 = aminstant.service_version.indexOf('v8.20.') > 0;
      var is830 = aminstant.service_version.indexOf('v8.30.') > 0;

      // is it an old version?
      if (is800 || is810 || is820 || is830) {
        $rootScope.hasAMI = false;
        $rootScope.$broadcast('modal.close');
        $rootScope.$broadcast('modal.open', {
          templateUrl: 'popups/amiUpgrade.html'
        });
        gatheringSvc.sendBiAmiInfo('Update-starting', -1);

        // force the autoupgrade
        var org_api_version = aminstant.api_version;
        aminstant.api_version = 'v2';
        aminstant.serviceQuery('init', {}, aminstant.onInit);
        aminstant.api_version = org_api_version;

        waitForAMIUpgrade();
      } else {
        //Check for running installations after a refresh.
        aminstant.onInstallationProgress(
          null,
          1000,
          updateInstallationProgress
        );
      }
      try {
        _gscq.push(['trackPage', '/ami-already-installed']);
      } catch (e) {}
    });

    // check if OGM is available by using aminstant.serviceQuery compatible method
    aminstant.serviceQuery('init', { api_port: OGM_API_PORT }, function() {
      $rootScope.hasOGM = true;
    });
  }

  function waitForAMIUpgrade() {
    var amiWaitInterval = setInterval(function() {
      aminstant._initialized = false;
      aminstant.serviceQuery('init', {}, aminstant.onInit);
      aminstant.serviceQuery(
        'init',
        { api_port: AMI_SECONDARY_API_PORT },
        aminstant.onInit
      );

      if (aminstant.isServiceInstalled()) {
        var is800 = aminstant.service_version.indexOf('v8.00.') > 0;
        var is810 = aminstant.service_version.indexOf('v8.10.') > 0;
        var is820 = aminstant.service_version.indexOf('v8.20.') > 0;
        var is830 = aminstant.service_version.indexOf('v8.30.') > 0;

        if (!is800 && !is810 && !is820 && !is830) {
          $rootScope.hasAMI = true;
          clearInterval(amiWaitInterval);
          $modalStack.dismissAll();
          gatheringSvc.sendBiAmiInfo('Update-finished', -1);
        }
      }
    }, 2000);
  }

  //END: TEMP AMI UPGRADE CODE

  /*  <<<<<<<<<<<<< AMI INSTALLATION >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  //show dialog box for installing
  function installAmi(contentId) {
    $rootScope.amiModalGameContentId = contentId;
    $rootScope.$broadcast('modal.close');

    $location.path('/ami-install');
    gatheringSvc.sendBiAmiInfo(
      'show-installAmiInstructions',
      $rootScope.gameManager.sessionGamesByContentId[contentId].id
    );

    playGameAfterAmiInstalls(contentId, function() {
      gatheringSvc.sendBiAmiInfo(
        'show-installAmiSuccess',
        $rootScope.gameManager.sessionGamesByContentId[contentId].id
      );
      $rootScope.tagEvent('ami-install-success');

      // send userback one page after succesful AMI install
      if ($location.path().indexOf('/ami-install') > -1) {
        history.back();
      }
    });
  }

  function startAmiDownload(contentId, skipWait) {
    var downloadUrl = FALLBACK_INSTALLER_URL;
    if (contentId) {
      downloadUrl =
        '/game/download/' +
        $rootScope.gameManager.sessionGamesByContentId[contentId].seoName +
        '.exe';
    }
    //IE blocks the rendering of the modal when opening a download...

    if (!skipWait && $rootScope.playerBrowser.indexOf('IE') > -1) {
      setTimeout(function() {
        window.open(downloadUrl, '_self');
      }, 750);
    } else {
      window.open(downloadUrl, '_self');
    }
  }

  // Waits until AMI is installed to install given game by contentId and invoke
  // the callback to trigger further actions
  function playGameAfterAmiInstalls(contentId, successCallback) {
    var amiWaitInterval = setInterval(function() {
      aminstant.serviceQuery('init', {}, aminstant.onInit);
      aminstant.serviceQuery(
        'init',
        { api_port: AMI_SECONDARY_API_PORT },
        aminstant.onInit
      );

      if (aminstant.isServiceInstalled()) {
        $rootScope.hasAMI = true;
        clearInterval(amiWaitInterval);

        if (contentId) {
          playOrInstallGame(contentId);
        }

        successCallback();
      }
    }, 500);
  }

  // Installs AMI using the OGM from legacy site
  // The idea is to launch installation of AMI using OGM and send some pings to
  // datagathering to be able to find out what happened.
  //
  // There are three main 'error' points that we keep track of:
  //   - installStubby fails: in which case we send error code
  //   - user closes window: in which case we try to send a ping (but is not guaranteed to arrive)
  //   - installation timeout: after some time, if installation did not finish, we revert
  //     to manual AMI installation
  function installAmiWithOgm(contentId) {
    var AMI_INSTALL_TIMEOUT = 60 * 1000;

    gatheringSvc.sendBiAmiInfo(
      'click-installAmiWithOgm',
      $rootScope.gameManager.sessionGamesByContentId[contentId].id
    );

    var amiInstallStart = new Date().getTime();
    var sendBiUserClosedWindowBeforeAmiInstalled = function() {
      // NOTE: doing asynchronous call does not guarantee that the ping is sent
      //       ideally this should be synchronous, even if it freezes user browser
      //       for a second
      gatheringSvc.sendBiAmiInfo(
        'installAmiWithOgmWindowClosed',
        $rootScope.gameManager.sessionGamesByContentId[contentId].id,
        { windowclosedafter: new Date().getTime() - amiInstallStart }
      );
    };
    var cancelSendAmiBiInfoOnClose = function() {
      window.removeEventListener(
        'beforeunload',
        sendBiUserClosedWindowBeforeAmiInstalled
      );
    };
    window.addEventListener(
      'beforeunload',
      sendBiUserClosedWindowBeforeAmiInstalled
    );

    var amiInstallTimeout = setTimeout(function() {
      cancelSendAmiBiInfoOnClose();
      if (ogmAmiInstallTimeout) {
        return;
      }

      // make sure only one of the timeouts triggers AMI install
      ogmAmiInstallTimeout = true;
      gatheringSvc.sendBiAmiInfo(
        'installAmiWithOgmTimeout',
        $rootScope.gameManager.sessionGamesByContentId[contentId].id,
        { timeoutafter: new Date().getTime() - amiInstallStart }
      );

      installAmi(contentId);
    }, AMI_INSTALL_TIMEOUT);

    aminstant.serviceQuery(
      'installStubby',
      {
        api_port: OGM_API_PORT,
        url: FALLBACK_INSTALLER_URL,
        game_id: 'activemark-instant-service',
        installer_args: ''
      },
      function(data) {
        // if OGM cannot start installation, just show normal installAmi flow
        if (data.error != null && data.error != 'installer_already_running') {
          cancelSendAmiBiInfoOnClose();

          gatheringSvc.sendBiAmiInfo(
            'installAmiWithOgmError',
            $rootScope.gameManager.sessionGamesByContentId[contentId].id,
            { ogmerror: data.error }
          );

          installAmi(contentId);
        }

        // when OGM installs AMI, let the flow be as if we were already
        // installing the game, showing the loader until game really
        // starts installing
        else {
          downloadManager.updateGame(contentId, 'showLoader', true);

          playGameAfterAmiInstalls(contentId, function() {
            cancelSendAmiBiInfoOnClose();
            clearTimeout(amiInstallTimeout);

            gatheringSvc.sendBiAmiInfo(
              'installAmiWithOgmSuccess',
              $rootScope.gameManager.sessionGamesByContentId[contentId].id,
              { installduration: new Date().getTime() - amiInstallStart }
            );
          });
        }
      }
    );
  }

  /*  <<<<<<<<<<<<< GAME PLAY/INSTALLATION >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  function installGame(contentId) {
    $http
      .get(
        baseUrlNoContext +
          '/website/api/games/downloaddetails.json?amcontentid=' +
          contentId
      )
      .success(function(data) {
        if (data.result === 'error') {
          downloadManager.deleteGame(contentId);
          downloadManager.installNextFromQueue();
          gatheringSvc.sendErrorInfo(
            'Game-install-downloaddetails',
            contentId + ' Error: ' + JSON.stringify(data)
          );
          return;
        }

        downloadManager.updateGame(contentId, 'trackingCode', data.tracking);
        aminstant.install(data, function(response) {
          if (response.error !== null) {
            downloadManager.deleteGame(contentId);
            downloadManager.installNextFromQueue();
            gatheringSvc.sendErrorInfo(
              'Game-install',
              contentId + ' Error: ' + response.error
            );
            gatheringSvc.sendBiDownloadGameInfo(
              $rootScope.gameManager.sessionGamesByContentId[contentId].id,
              downloadManager.getGameValue(contentId, 'trackingCode'),
              'error'
            );
          } else {
            messageService.addGame(
              $rootScope.gameManager.downloadQueue[0],
              'installing'
            );
            downloadManager.updateGame(contentId, 'state', 'installing');
            downloadManager.updateGame(contentId, 'showLoader', false);
            downloadManager.updateGame(contentId, 'gameLoading', true);
            aminstant.onInstallationProgress(
              contentId,
              1000,
              updateInstallationProgress
            );
            gatheringSvc.sendBiDownloadGameInfo(
              $rootScope.gameManager.sessionGamesByContentId[contentId].id,
              downloadManager.getGameValue(contentId, 'trackingCode'),
              'start'
            );
          }
        });
      })
      .error(function(data) {
        downloadManager.deleteGame(contentId);
        downloadManager.installNextFromQueue();
        gatheringSvc.sendErrorInfo(
          'Game-install-downloaddetails',
          contentId + ' Error: ' + JSON.stringify(data)
        );
      });
  }

  function playOrInstallGame(contentId) {
    //Show loader to give feedback response.
    downloadManager.updateGame(contentId, 'showLoader', true);

    aminstant.listGames(true, function(result) {
      if (result.error == null) {
        var selectedGame;
        for (var j = 0; j < result.games.length; j++) {
          var tempGame = result.games[j];
          if (tempGame.content_id == contentId) {
            selectedGame = tempGame;
            break;
          }
        }

        if (
          isTrial() &&
          selectedGame &&
          totalTrialTime -
            parseInt(selectedGame.stats.total_execution_trial_time) <
            minTrialTime
        ) {
          // trial user expended all trial time for this game: show popup "game trial ended"
          $rootScope.amiModalGameContentId = contentId;
          $cookies.put('postTrialContentId', contentId, { path: '/' });

          // wrap the showing of the modal in a callback function so that it's only executed
          // once the recommendations are fully loaded
          var showEndOfTrialTimePopupCallback = function() {
            $rootScope.tagEvent('trial-popup-game-block');
            $rootScope.$broadcast('modal.close');
            $rootScope.$broadcast('modal.open', {
              templateUrl: 'popups/endOfTrialTimePreGame.html'
            });
            gatheringSvc.sendBiPageVisitInfo(
              'popups/endOfTrialTimePreGame.html'
            );
            downloadManager.deleteGame(contentId);
          };
          prepareExpiredTrialRecommendations(
            contentId,
            false,
            false,
            showEndOfTrialTimePopupCallback
          );
        } else {
          aminstant.play(
            contentId,
            getAuthToken(),
            getPlayerId(),
            $rootScope.gameManager.sessionGamesByContentId[contentId].id,
            isTrial(),
            function(response) {
              if (response.error !== null) {
                //- Add the game to the queue to get downloaded
                downloadManager.addGameToDownloadQueue(contentId);
                if (response.error !== 'cannot_execute_application') {
                  gatheringSvc.sendErrorInfo(
                    'Game-play',
                    contentId + ' Error: ' + response.error
                  );
                }
              } else {
                downloadManager.updateGame(contentId, 'state', 'starting');
                // always prepare "trial" recommendations because we also use them in the
                // "after gameplay" popup that's always shown if the "end-of-trial-time post-game"
                // popup isn't shown
                prepareExpiredTrialRecommendations(contentId, true, true);

                triggerProActiveSupport(true);
                aminstant.onPlayFinished(contentId, function(res) {
                  downloadManager.updateGame(contentId, 'state', 'played');
                  messageService.removeGameMessage(contentId);
                  $rootScope.messageCenterWindow.show = false;
                  gatheringSvc.sendBiGameLeaveInfo(
                    $rootScope.gameManager.sessionGamesByContentId[contentId].id
                  );
                  $rootScope.tagEvent('gameplay-leave');
                  //Always stop the preload after finishing a game.
                  stopAllGamePreloads();
                  //Refresh the recently played games.
                  $rootScope.loadRecentlyPlayedGames();

                  if (!triggerProActiveSupport(false)) {
                    if (isTrial()) {
                      if (res.error != null) {
                        gatheringSvc.sendErrorInfo(
                          'Game-play',
                          contentId +
                            ' Error showing after trial popup: ' +
                            res.error
                        );
                      } else {
                        if (
                          totalTrialTime - res.total_execution_trial_time <
                          minTrialTime
                        ) {
                          //Show game trial ended notification.
                          $rootScope.amiModalGameContentId = contentId;
                          $cookies.put('postTrialContentId', contentId, {
                            path: '/'
                          });
                          $rootScope.tagEvent('trial-popup-game-kick');

                          $rootScope.$broadcast('modal.close');
                          $rootScope.$broadcast('modal.open', {
                            templateUrl: 'popups/endOfTrialTimePostGame.html'
                          });
                          gatheringSvc.sendBiPageVisitInfo(
                            'popups/endOfTrialTimePostGame.html'
                          );
                        } else if (!isAfterGamePlayPopupSuppressed()) {
                          // trial game play that is voluntarily ended
                          // after the first 10 seconds ran out
                          // and before the trial time ran out
                          // and the user didn't disable the popup
                          showAfterGamePlayPopup(
                            contentId,
                            'popup-game-leave-trial'
                          );
                        }
                      }
                    } else if (!isAfterGamePlayPopupSuppressed()) {
                      // non-trial game play that is voluntarily ended
                      // after the first 10 seconds ran out
                      // and before the trial time ran out
                      // and the user didn't disable the popup
                      showAfterGamePlayPopup(
                        contentId,
                        'popup-game-leave-nontrial'
                      );
                    }
                  }
                });

                $modalStack.dismissAll();

                $rootScope.$apply();
                //Show loader of game starting.
                showPlayGameLoader(contentId);
                doPlayTracking(contentId);
              }
            }
          );
        }
      } else {
        // aminstant.listGames() returned an error
        downloadManager.deleteGame(contentId);
        downloadManager.installNextFromQueue();
        gatheringSvc.sendErrorInfo(
          'Game-play',
          contentId + ' Error: ' + result.error
        );
      }
    });
  }

  function updateInstallationProgress(response) {
    var stopCallback = true;
    var installations = response.installations;
    for (var i = 0; i < installations.length; i++) {
      var game = installations[i];
      var contentId = game.content_id;

      if (game.status === 'completed') {
        if (downloadManager.getGameValue(contentId, 'state') === 'installing') {
          downloadManager.updateGame(contentId, 'state', 'installed');

          messageService.addGame(contentId, 'installed');
          downloadManager.deleteFromQueue(contentId);
          downloadManager.installNextFromQueue();
          gatheringSvc.sendBiDownloadGameInfo(
            $rootScope.gameManager.sessionGamesByContentId[contentId].id,
            downloadManager.getGameValue(contentId, 'trackingCode'),
            'completed'
          );
        }

        downloadManager.updateGame(contentId, 'installProgress', 100);
        downloadManager.updateGame(contentId, 'gameLoading', false);
        downloadManager.updateGame(contentId, 'gameReady', true);
        $rootScope.$apply();
      } else if (game.status === 'installing') {
        if (
          downloadManager.getGameValue(contentId, 'state') === 'installing' ||
          !game.is_preload
        ) {
          stopCallback = false;
        }
        //If the game ins't currently known in the gameManager scope retrieve it from backend
        //and add it to the scope.
        if (
          !$rootScope.gameManager.sessionGamesByContentId[contentId] &&
          !game.is_preload
        ) {
          insertGameByContentId(contentId, function(contentId) {
            downloadManager.updateGame(contentId, 'state', 'installing');
            downloadManager.updateGame(contentId, 'showLoader', false);
            downloadManager.updateGame(contentId, 'gameLoading', true);
            messageService.addGame(contentId, 'installing');
          });
          stopCallback = false;
        }
        downloadManager.updateGame(
          contentId,
          'installProgress',
          parseFloat(game.progress)
        );
        $rootScope.$apply();
      } else if (game.status === 'failed') {
        if ($rootScope.gameManager.sessionGamesInfo[contentId]) {
          if (
            downloadManager.getGameValue(contentId, 'state') === 'installing'
          ) {
            downloadManager.deleteFromQueue(contentId);
            downloadManager.installNextFromQueue();
            stopCallback = false;
          }

          downloadManager.deleteGame(contentId);

          //uninstall to not obstruct install/throw errors next time the game is installed
          aminstant.uninstall(contentId);
          $rootScope.$apply();
          gatheringSvc.sendErrorInfo(
            'Game-installListener',
            contentId + ' Error: ' + game.status
          );
        }
      } else {
        if (
          !game.is_preload &&
          (downloadManager.getGameValue(contentId, 'state') === 'inserted' ||
            downloadManager.getGameValue(contentId, 'state') === 'queued' ||
            downloadManager.getGameValue(contentId, 'state') === 'installing')
        ) {
          stopCallback = false;
        }
      }
    }
    if (stopCallback) {
      return false;
    }
  }

  /*  <<<<<<<<<<<<< Helping functions >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  function showPlayGameLoader(contentId) {
    downloadManager.updateGame(contentId, 'showLoader', true);
    $rootScope.$apply();
    setTimeout(function() {
      if (downloadManager.getGameValue(contentId, 'state') === 'starting') {
        downloadManager.updateGame(contentId, 'state', 'playing');
        messageService.removeGameMessage(contentId);
        $rootScope.messageCenterWindow.show = false;
      }

      downloadManager.updateGame(contentId, 'gameStarted', false);
      downloadManager.updateGame(contentId, 'showLoader', false);
      downloadManager.updateGame(contentId, 'gameLoading', false);
      downloadManager.updateGame(contentId, 'installProgress', 0);
      $rootScope.$apply();
    }, 20000);
  }

  /*  <<<<<<<<<<<<< EXTRA FUNCTIONALITY >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  function prepareExpiredTrialRecommendations(
    contentId,
    preloading,
    endOfHourTrial,
    callback
  ) {
    // Utility function: retrieve the ratings for each game in gameList and them to the game objects
    // Assumes gameList holds exactly two games
    function retrieveRatings(gameList) {
      if (
        gameList[0] !== null &&
        gameList[0] !== undefined &&
        gameList[0].seoName !== null &&
        gameList[0].seoName !== ''
      ) {
        gameDataSvc
          .getSpecificGame(gameList[0].seoName)
          .success(function(data) {
            if (data && data.contentId && data.id && data.rating != null) {
              gameList[0].rating = data.rating;
            }
          });
      }
      if (
        gameList[1] !== null &&
        gameList[1] !== undefined &&
        gameList[1].seoName !== null &&
        gameList[1].seoName !== ''
      ) {
        gameDataSvc
          .getSpecificGame(gameList[1].seoName)
          .success(function(data) {
            if (data && data.contentId && data.id && data.rating != null) {
              gameList[1].rating = data.rating;
            }
          });
      }
    }

    function handleRecommendations() {
      if (gameList.length < 2) {
        // We didn't get enough item-based recommendations, fall back to normal anonymous recommendations
        // This should only happen if the game is very new and has not enough game plays to build recommendations
        gameDataSvc.getRecommendedGames(2).then(
          function(success) {
            gameList = success.data.gameList;
            // put the retrieved recommendations into the correct variable
            if (endOfHourTrial) {
              $rootScope.gameManager.recommendedGamesEndOfHourTrial = gameList;
              retrieveRatings(
                $rootScope.gameManager.recommendedGamesEndOfHourTrial
              );
            } else {
              $rootScope.gameManager.recommendedGames = gameList;
              retrieveRatings($rootScope.gameManager.recommendedGames);
            }
            // start preloading the recommended games if preloading is enabled
            if (preloading) {
              for (var i in gameList) {
                startGamePreload(gameList[i]);
              }
            }
            if (callback != null) {
              callback();
            }
          },
          function(failure) {
            gatheringSvc.sendErrorInfo(
              'prepare-expired-trial-recommendations',
              ' Error: ' + JSON.stringify(failure)
            );
            downloadManager.deleteGame(contentId);
          }
        );
      } else {
        // put the retrieved recommendations into the correct variable
        if (endOfHourTrial) {
          $rootScope.gameManager.recommendedGamesEndOfHourTrial = gameList;
          retrieveRatings(
            $rootScope.gameManager.recommendedGamesEndOfHourTrial
          );
        } else {
          $rootScope.gameManager.recommendedGames = gameList;
          retrieveRatings($rootScope.gameManager.recommendedGames);
        }
        // start preloading the recommended games if preloading is enabled
        if (preloading) {
          for (var i in gameList) {
            startGamePreload(gameList[i]);
          }
        }
        if (callback != null) {
          callback();
        }
      }
    }

    try {
      // reset recommended games in the popups
      $rootScope.gameManager.recommendedGamesEndOfHourTrial = [];
      $rootScope.gameManager.recommendedGames = [];

      var gameId = $rootScope.gameManager.sessionGamesByContentId[contentId].id;
      var gameList;

      gameDataSvc.getGameBasedRecommendationsForceGenre(gameId, 2).then(
        function(success) {
          gameList = success.data.gameList;
          handleRecommendations();
        },
        function(failure) {
          gatheringSvc.sendErrorInfo(
            'prepare-expired-trial-recommendations',
            ' Error: ' + JSON.stringify(failure)
          );
          downloadManager.deleteGame(contentId);
        }
      );
    } catch (e) {
      gatheringSvc.sendErrorInfo(
        'prepare-expired-trial-recommendations',
        ' Error: ' + e.message
      );
      downloadManager.deleteGame(contentId);
    }
  }

  /*
   * Returns true if the AMI error popup was triggered
   */
  function triggerProActiveSupport(initialize) {
    if (initialize) {
      gamestartTime = new Date().getTime();
      return false;
    } else if (
      gamestartTime &&
      new Date().getTime() - gamestartTime < detectGameCrashFailurePeriod
    ) {
      gatheringSvc.sendClickTracking('ami', 'offer-crash-support');
      //Crash, offer support.
      $rootScope.$broadcast('modal.close');
      $rootScope.$broadcast('modal.open', {
        templateUrl: 'popups/amiError.html'
      });
      return true;
    }
  }

  function isAfterGamePlayPopupSuppressed() {
    return $cookies.get(cookieNameSuppressAfterGamePlayPopup) === 'true';
  }

  function showAfterGamePlayPopup(contentId, trackingTagName) {
    if (trackingTagName === '') {
      trackingTagName = 'popup-game-leave-nontrial';
    }

    $rootScope.amiModalGameContentId = contentId;
    $rootScope.tagEvent(trackingTagName);
    $rootScope.$broadcast('modal.close');
    $rootScope.$broadcast('modal.open', {
      controller: function($scope, $rootScope, $cookies) {
        $scope.toggleSuppressPopup = function() {
          $cookies.put(
            cookieNameSuppressAfterGamePlayPopup,
            $scope.checkboxSuppressPopup
          );
        };
      },
      templateUrl: 'popups/afterGamePlay.html'
    });
    gatheringSvc.sendBiPageVisitInfo('popups/afterGamePlay.html');
  }

  /*  <<<<<<<<<<<<< TRACKING >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  function doPlayTracking(contentId) {
    aminstant.listGames(function(data) {
      var installations = data.games;
      for (var i = 0; i < installations.length; i++) {
        if (installations[i].content_id === contentId) {
          gatheringSvc.sendBiPlayGameInfo(
            $rootScope.gameManager.sessionGamesByContentId[contentId].id,
            installations[i].tracking
          );
          break;
        }
      }
    });
  }

  /*  <<<<<<<<<<<<< PRIVATE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  function getAuthToken() {
    if (
      $rootScope.player === undefined ||
      $rootScope.player.userName === undefined
    ) {
      return 'unknown';
    }
    return $rootScope.player.userName;
  }

  function getPlayerId() {
    if (
      $rootScope.player === undefined ||
      $rootScope.player.userId === undefined
    ) {
      return -1;
    }
    return $rootScope.player.userId;
  }

  function isTrial() {
    if ($rootScope.player === undefined || !$rootScope.player.isEntitled) {
      return true;
    }
    return false;
  }

  function insertGameByContentId(contentId, callback) {
    gameDataSvc.getSpecificGameByContentId(contentId).success(function(data) {
      if (data && data.contentId && data.id) {
        downloadManager.insertGame(data);
        callback(contentId);
      }
    });
  }

  function startGamePreload(game) {
    $http
      .get(
        baseUrlNoContext +
          '/website/api/games/downloaddetails.json?amcontentid=' +
          game.contentId
      )
      .success(function(data) {
        if (data.result === 'error') {
          gatheringSvc.sendErrorInfo(
            'Game-preload-downloaddetails',
            game.contentId + ' Error: ' + JSON.stringify(data)
          );
          return;
        }

        data.play_likelihood = 30;
        aminstant.preload(data, function(response) {
          if (
            response.error !== null &&
            response.error !== 'game_already_installed'
          ) {
            gatheringSvc.sendErrorInfo(
              'Game-preload-start',
              game.contentId + ' Error: ' + response.error
            );
          } else {
            gatheringSvc.sendBiDownloadGameInfo(
              game.id,
              data.tracking,
              'preload-start'
            );
          }
        });
      });
  }

  function stopAllGamePreloads() {
    // also make sure that the preloading game hasn't finished preloading yet
    aminstant.listInstallations(function(response) {
      if (response.error !== null) {
        gatheringSvc.sendErrorInfo(
          'Game-preload-listInstallations',
          ' Error: ' + response.error
        );
      } else {
        var installations = response.installations;
        for (var i = 0; i < installations.length; i++) {
          if (
            installations[i].is_preload &&
            installations[i].status === 'installing'
          ) {
            // found the game that is preloading and it hasn't finished, so we can safely stop the preloading
            //rfs is dummy url to keep it happy.

            var preloadGameData = {
              content_id: installations[i].content_id,
              play_likelihood: 0,
              rfs: 'http://www.gamehouse.com'
            };
            aminstant.preload(preloadGameData, function(response) {
              if (response.error !== null) {
                gatheringSvc.sendErrorInfo(
                  'Game-preload-stop',
                  installations[i].content_id + ' Error: ' + response.error
                );
              }
            });
          }
        }
      }
    });
  }

  /*  <<<<<<<<<<<<< DOWNLOAD MANAGER >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
  var downloadManager = (function() {
    function insertGame(game, elementOffSet) {
      $rootScope.gameManager.sessionGamesById[game.id] = game;
      $rootScope.gameManager.sessionGamesByContentId[game.contentId] = game;
      if (
        !$rootScope.gameManager.sessionGamesInfo[game.contentId] ||
        getGameValue(game.contentId, 'status') === 'deleted'
      ) {
        var tempGame = {};
        tempGame['state'] = 'inserted';
        tempGame['gameStarted'] = false;
        tempGame['showLoader'] = false;
        tempGame['gameLoading'] = false;
        tempGame['installProgress'] = 0;
        tempGame['gameReady'] = false;
        tempGame['functionalId'] = game.seoName;
        tempGame['contentId'] = game.contentId;
        tempGame['trackingCode'] = '';
        tempGame['gameInfo'] = game;
        $rootScope.gameManager.sessionGamesInfo[game.contentId] = tempGame;
      }
      if (elementOffSet) {
        $rootScope.gameManager.sessionGamesInfo[
          game.contentId
        ].elementOffSet = elementOffSet;
      }
    }

    function addGameToDownloadQueue(contentId) {
      downloadQueueManager.addToQueue(contentId);
      $rootScope.$apply();
    }

    function updateGame(contentId, status, value) {
      if ($rootScope.gameManager.sessionGamesInfo[contentId]) {
        $rootScope.gameManager.sessionGamesInfo[contentId][status] = value;
      }
    }

    function deleteGame(contentId) {
      messageService.removeGameMessage(contentId);
      downloadQueueManager.deleteFromQueue(contentId);
      updateGame(contentId, 'status', 'deleted');
      updateGame(contentId, 'gameStarted', false);
      updateGame(contentId, 'showLoader', false);
      updateGame(contentId, 'gameLoading', false);
      updateGame(contentId, 'installProgress', 0);
      updateGame(contentId, 'gameReady', false);
      updateGame(contentId, 'trackingCode', '');
    }

    function installNextFromQueue() {
      downloadQueueManager.installNextFromQueue();
    }

    function deleteFromQueue(contentId) {
      downloadQueueManager.deleteFromQueue(contentId);
    }

    function getGameValue(contentId, status) {
      if (
        $rootScope.gameManager.sessionGamesInfo[contentId] &&
        $rootScope.gameManager.sessionGamesInfo[contentId][status]
      ) {
        return $rootScope.gameManager.sessionGamesInfo[contentId][status];
      }
      return '';
    }

    function getGameInfoValue(contentId, status) {
      if (
        $rootScope.gameManager.sessionGamesInfo[contentId] &&
        $rootScope.gameManager.sessionGamesInfo[contentId].gameInfo &&
        $rootScope.gameManager.sessionGamesInfo[contentId].gameInfo[status]
      ) {
        return $rootScope.gameManager.sessionGamesInfo[contentId].gameInfo[
          status
        ];
      }
      return '';
    }

    var downloadQueueManager = (function() {
      var currentDownload = 0;

      function addToQueue(contentId) {
        $rootScope.gameManager.downloadQueue.push(contentId);
        downloadManager.updateGame(contentId, 'state', 'queued');

        if (downloadManager.getGameValue(contentId, 'elementOffSet')) {
          $rootScope.animateGamePlay(
            downloadManager.getGameValue(contentId, 'elementOffSet'),
            downloadManager.getGameValue(contentId, 'gameInfo').gameImages
              .small,
            function() {
              messageService.addGame(contentId, 'queued');
            }
          );
        } else {
          messageService.addGame(contentId, 'queued');
        }

        gatheringSvc.sendClickTracking(
          'GameManager-Queued',
          $rootScope.gameManager.downloadQueue.length
        );
        if (currentDownload === 0) {
          currentDownload = contentId;
          installGame(contentId);
        }
      }

      function deleteFromQueue(contentId) {
        if ($rootScope.gameManager.downloadQueue.indexOf(contentId) > -1) {
          $rootScope.gameManager.downloadQueue.splice(
            $rootScope.gameManager.downloadQueue.indexOf(contentId),
            1
          );
        }
      }

      function installNextFromQueue() {
        if ($rootScope.gameManager.downloadQueue.length !== 0) {
          installGame($rootScope.gameManager.downloadQueue[0]);
        } else {
          currentDownload = 0;
        }
      }

      return {
        addToQueue: addToQueue,
        deleteFromQueue: deleteFromQueue,
        installNextFromQueue: installNextFromQueue
      };
    })();

    return {
      insertGame: insertGame,
      addGameToDownloadQueue: addGameToDownloadQueue,
      updateGame: updateGame,
      deleteGame: deleteGame,
      installNextFromQueue: installNextFromQueue,
      deleteFromQueue: deleteFromQueue,
      getGameValue: getGameValue,
      getGameInfoValue: getGameInfoValue
    };
  })();

  /*  <<<<<<<<<<<<< PUBLIC FUNCTIONS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
  return {
    startGame: function(game, elementOffSet) {
      if (
        typeof game != 'object' ||
        !('contentId' in game) ||
        !('id' in game)
      ) {
        gatheringSvc.sendErrorInfo('startGame', 'Error: Invalid game object.');
        return;
      }
      downloadManager.insertGame(game, elementOffSet);

      if (!$rootScope.hasAMI) {
        if ($rootScope.hasOGM) {
          installAmiWithOgm(game.contentId);
        } else {
          installAmi(game.contentId);
        }
      } else {
        playOrInstallGame(game.contentId);
      }
    },
    startGamePreload: function(game) {
      startGamePreload(game);
    },
    stopAllGamePreloads: function() {
      stopAllGamePreloads();
    },
    // returns True if given game installation is in progress, or if OGM installation
    // is in progress.
    isInstallationInProgress: function(game) {
      return (
        downloadManager.getGameValue(
          game ? game.contentId : null,
          'showLoader'
        ) ||
        downloadManager.getGameValue(
          game ? game.contentId : null,
          'gameLoading'
        )
      );
    },
    uninstall: function(contentId) {
      if ($rootScope.hasAMI) {
        aminstant.uninstall(contentId);
      }
    },
    getInstalledGames: function(callBack) {
      aminstant.listGames(false, function(result) {
        if (result.error == null) {
          callBack(result.games);
        } else {
          callBack([]);
        }
      });
    },
    getGame: function(contentId, callback) {
      aminstant.listGames(true, function(result) {
        if (result.error === null) {
          for (var index = 0; index < result.games.length; index++) {
            const game = result.games[index];
            if (game.content_id === contentId) {
              return callback(game);
            }
          }
        }
        callback(null);
      });
    },
    downloadAmi: function(contentId, skipWait) {
      startAmiDownload(contentId, skipWait);
    },
    deleteFromQueue: function(contentId) {
      downloadManager.updateGame(contentId, 'showLoader', false);
      downloadManager.updateGame(contentId, 'state', 'stopped');
      downloadManager.deleteFromQueue(contentId);
    },
    stopInstallation: function(contentId) {
      downloadManager.updateGame(contentId, 'showLoader', false);
      downloadManager.updateGame(contentId, 'gameLoading', false);
      downloadManager.updateGame(contentId, 'state', 'stopped');
      downloadManager.deleteFromQueue(contentId);
      downloadManager.installNextFromQueue();
      var preloadGameData = {
        content_id: contentId,
        play_likelihood: 0,
        rfs: 'http://www.gamehouse.com'
      };
      aminstant.preload(preloadGameData, function(response) {
        if (response.error !== null) {
          gatheringSvc.sendErrorInfo(
            'Game-installation-stop',
            contentId + ' Error: ' + response.error
          );
        }
      });
    },
    insertGame: function(game) {
      downloadManager.insertGame(game);
    }
  };
}

AmiSvc.$inject = [
  '$rootScope',
  '$http',
  'gatheringSvc',
  '$modal',
  '$modalStack',
  '$location',
  '$cookies',
  'gameDataSvc',
  'abtestService',
  'messageService'
];
module.exports = AmiSvc;

},{}],51:[function(require,module,exports){
var CustomPaymentService = function (retryService, $http, $q, $document, gatheringSvc, $rootScope) {

    // This deferred will resolve/reject based on succesful payment of the Zuora payment form
    var deferredPayment = $q.defer();

    // Fetch the payment method details metadata from our API
    // This includes a few tokens so that we can access Zuora
    var getPaymentMethodDetails = function () {
        return retryService.retry(function () {
            return $http.get('/myaccount/custompayment/method');
        });
    };

    var getPaymentFormSelectFields = function () {
        return retryService.retry(function () {
            return $http.get('/myaccount/custompayment/fields');
        });
    };

    // handle callback
    var handleCallback = function (routeParams) {
        return $http.post("/myaccount/custompayment/callback", JSON.stringify(routeParams))
            .then(successCallback, errorCallback);
    };

    var successCallback = function (response) {
        $rootScope.$broadcast('payment:done', response);
        deferredPayment.resolve(response);
    };

    var errorCallback = function (response) {
        $rootScope.$broadcast('payment:error', response);
        gatheringSvc.sendErrorInfo('Payment', 'Failed callback on subscribe');
        deferredPayment.reject(response);
    };

    return {
        getPaymentFormSelectFields: getPaymentFormSelectFields,
        getPaymentMethodDetails: getPaymentMethodDetails,
        handleCallback: handleCallback
    }
};

CustomPaymentService.$inject = ['retryService', '$http', '$q', '$document', 'gatheringSvc', '$rootScope'];
module.exports = CustomPaymentService;

},{}],52:[function(require,module,exports){
function gatheringSvc($http, $location, $rootScope, userSvc, $cookies) {

    function getCookieValue(cookieName) {
        if ($cookies.get(cookieName) !== undefined) {
            return $cookies.get(cookieName);
        }
        return '';
    }

    function addDefaultInfo(data) {
        if ($rootScope.player) {
            data.playerId = $rootScope.player.userId;
            data.userName = $rootScope.player.userName;
            data.emailAddress = $rootScope.player.email;
            data.isLoggedIn = $rootScope.player.isLoggedIn;
            data.isEntitled = $rootScope.player.isEntitled;
        }
        data.g_websiteid = 'gamehouse-new';
        data.abtest = $rootScope.playerAbtests.toString();
        data.pageloadtime = $rootScope.pageLoadTime;
        data.deviceId = $rootScope.deviceId;
        data.visitorId = getCookieValue('ghvid');
        data.sessionId = getCookieValue('gamehouse.sid') || getCookieValue('ghsid');
        data.utmsource = getCookieValue('utmsource');
        data.utmmedium = getCookieValue('utmmedium');
        data.utmcampaign = getCookieValue('utmcampaign');
        data.utmcontent = getCookieValue('utmcontent');
        data.utmterm = getCookieValue('utmterm');
    }

    function sendToGatheringServer(data) {
        userSvc.checkSessionId().then(function () {
            addDefaultInfo(data);
            return $http.post(gatheringEndpoint, data);
        });
    }

    return {
        sendBiPageVisitInfo: function (pageUrl) {
            var data = {
                logname: 'pageView',
                pageUrl: (pageUrl ? pageUrl : $location.absUrl())
            };
            sendToGatheringServer(data);
        },
        sendBiAmiInfo: function (status, gameId, extraData) {
            var data = extraData || {};
            data.logname = 'installAmi';
            data.status = status;
            data.gameId = gameId;

            sendToGatheringServer(data);
        },
        sendBiDownloadGameInfo: function (gameId, trackingCode, status) {
            var data = {
                logname: 'downloadGame',
                gameId: gameId,
                trackingCode: trackingCode,
                status: status
            };
            sendToGatheringServer(data);
        },
        sendBiPlayGameInfo: function (gameId, trackingCode) {
            var data = {
                logname: 'playGame',
                gameId: gameId,
                trackingCode: trackingCode
            };
            sendToGatheringServer(data);
        },
        sendBiGameLeaveInfo: function(gameId) {
            var data = {
                logname: 'leaveGame',
                gameId: gameId
            };
            sendToGatheringServer(data);
        },
        sendBiSearchInfo: function (searchTerm, amountOfResults, source) {
            var data = {
                logname: 'searchGames',
                searchterm: searchTerm,
                amount: amountOfResults,
                // source: "searchbar" or "showall"
                source: source
            };
            sendToGatheringServer(data);
        },
        sendUpcomingGameEmail: function (email, seoName) {
            var data = {
                logname: 'upcomingGameEmail',
                email: email,
                game: seoName
            };
            sendToGatheringServer(data);
        },

        sendErrorInfo: function (location, error) {
            var data = {
                logname: 'error',
                location: location,
                error: error
            };
            sendToGatheringServer(data);
        },
        sendCreateAccountSuccess: function () {
            var data = {
                logname: 'createAccountSuccess'
            };
            sendToGatheringServer(data);
        },
        sendCreateAccountSubmitError: function (email, emailValid, passwordValid) {
            var data = {
                logname: 'createAccountSubmitError',
                email: email,
                emailvalid: emailValid,
                passwordvalid: passwordValid
            };
            sendToGatheringServer(data);
        },
        sendCreateAccountError: function (email, errorMessage) {
            var data = {
                logname: 'createAccountError',
                email: email,
                errormessage: JSON.stringify(errorMessage)
            };
            sendToGatheringServer(data);
        },
        sendExtendedPlayerDetails: function () {
            var data = {
                logname: 'extendedPlayerDetails',
                screenwidth: screen.width,
                screenheight: screen.height,
                viewportwidth: document.documentElement.clientWidth,
                viewportheight: document.documentElement.clientHeight,
                useragent: navigator.userAgent,
                referrer: document.referrer
            };
            sendToGatheringServer(data);
        },
        sendClickTracking: function (location, item) {
            var data = {
                logname: 'clickTracking',
                location: location,
                item: item,
                clickTime: new Date().getTime()
            };
            sendToGatheringServer(data);
        },
        cancelSubscription: function (surveyResults) {
            var data = {
                logname: 'cancelMembership',
                version: 2,
                question1Text: surveyResults.question1.text,
                question1AnswerId: surveyResults.question1.answerId,
                question1AnswerText: surveyResults.question1.answerText,
                question1FollowUpAnswerId: surveyResults.question1.followUpAnswerId,
                question1FollowUpAnswerText: surveyResults.question1.followUpAnswerText,
                question1FreeUserInput: surveyResults.question1.freeUserInput,
                question2Text: surveyResults.question2.text,
                question2FreeUserInput: surveyResults.question2.freeUserInput
            };
            sendToGatheringServer(data);
        },
        sendPaymentMethod: function (method) {
            var data = {
                logname: 'paymentMethod',
                method: method
            };
            sendToGatheringServer(data);
        }
    };
}
gatheringSvc.$inject = ['$http', '$location', '$rootScope', 'userSvc', '$cookies'];
module.exports = gatheringSvc;

},{}],53:[function(require,module,exports){
function EmailVerificationService ($http, $rootScope) {

  var sendSuccessCallback = function(response) {
    $rootScope.$broadcast('notification:confirm', 'The validation email has been sent. Please, check your inbox!');
  };

  var sendErrorCallback = function(response) {
    $rootScope.$broadcast('notification:error', 'Error sending the validation email');
  };

  var sendValidationEmail = function(id, hash) {
    var data = {
      id: id || null,
      hash: hash || null
    };
    $http.post(baseUrlNoContext + "/csi/validate/send", data).then(
      sendSuccessCallback,
      sendErrorCallback
    );
  };

  return {
    sendValidationEmail: sendValidationEmail
  };
};

EmailVerificationService.$inject = ['$http', '$rootScope'];
module.exports = EmailVerificationService;

},{}],54:[function(require,module,exports){
function GameDataSvc($q, $http, $rootScope, $cookies, abtestService) {
  $rootScope.cancelRequest = $q.defer();

  return {
    //----------------
    //Cancel request call
    cancelRequest: function() {
      $rootScope.cancelRequest.resolve();
      $rootScope.cancelRequest = $q.defer();
    },

    //----------------
    //Search box calls
    getAllGames: function() {
      var url = baseUrlNoContext + '/website/api/games/search-all-select.json';
      return $http.get(url);
    },
    getSearchedGames: function(query) {
      var url = baseUrlNoContext + '/website/api/search?q=' + query;
      return $http.get(url);
    },

    //----------------
    //Get Games calls
    getAllCategories: function() {
      var url =
        baseUrlNoContext + '/website/api/categories/all.json?type=categorybox';
      return $http.get(url);
    },
    getRecentGames: function(amount) {
      var url =
        baseUrlNoContext +
        '/website/api/games/recentlyplayed-select.json?amount=' +
        amount;
      return $http.get(url, { timeout: 8000 });
    },
    getAllRecentGames: function() {
      var url =
        baseUrlNoContext + '/website/api/games/recentlyplayed-all-select.json';
      return $http.get(url, { timeout: 8000 });
    },

    getNewGames: function(pageCount, gamesPerPage) {
      // pageCount is zero-based
      var url =
        baseUrlNoContext +
        '/website/api/games/new-select.json?start=' +
        pageCount +
        '&count=' +
        gamesPerPage;
      return $http.get(url);
    },
    getHomeCarousel: function() {
      var url = baseUrlNoContext + '/api/v1/homecarousel';
      return $http.get(url, { timeout: 8000 });
    },
    getRecommendedBecauseYouPlayedGames: function(amount) {
      var url =
        baseUrlNoContext +
        '/website/api/games/recommendation-because-select.json?amount=' +
        amount;
      return $http.get(url);
    },
    getRecommendedGames: function(amount) {
      var url =
        baseUrlNoContext +
        '/website/api/games/recommendation-select.json?amount=' +
        amount;
      return $http.get(url, { timeout: 8000 });
    },
    getExclusiveGames: function(limit) {
      var url =
        baseUrlNoContext + '/website/api/games/exclusive?limit=' + limit;
      return $http.get(url, { timeout: 8000 });
    },
    getTopPlayedGames: function(limit, lastdays) {
      var lastdaysQuery = '';
      if (lastdays != undefined && lastdays > 0) {
        lastdaysQuery = '&lastdays=' + lastdays;
      }
      var url =
        baseUrlNoContext +
        '/website/api/games/top-played?limit=' +
        limit +
        lastdaysQuery;
      return $http.get(url, { timeout: 8000 });
    },
    getTopRatedGames: function(pageCount, gamesPerPage) {
      // pageCount is zero-based
      var url =
        baseUrlNoContext +
        '/website/api/games/toprated-select.json?start=' +
        pageCount +
        '&count=' +
        gamesPerPage;
      return $http.get(url);
    },
    /**
     * @param categoryKey
     * @param pageCount which page we are retrieve. Defaults to 0
     * @param pageSize number of games per "page". Defaults to 4
     * @param sortField: use the backend names of the gamebox object. Defaults to launchDate
     * @param sortOrder: ASC or DESC. Defaults to DESC
     */
    getCategoryGames: function(
      categoryKey,
      pageCount,
      pageSize,
      sortField,
      sortOrder
    ) {
      pageCount = pageCount || '0';
      pageSize = pageSize || '4';
      sortField = sortField || 'launchDate';
      sortOrder = sortOrder || 'DESC';
      var url =
        baseUrlNoContext +
        '/website/api/games/category-select.json?categoryname=' +
        categoryKey +
        '&page=' +
        pageCount +
        '&size=' +
        pageSize +
        '&sortField=' +
        sortField +
        '&sortOrder=' +
        sortOrder;
      return $http.get(url);
    },

    //---------------
    //Game page calls
    getSpecificGame: function(seoName) {
      var url =
        baseUrlNoContext +
        '/website/api/games/gamepage-select.json?seoName=' +
        seoName;
      return $http.get(url);
    },
    getGameBasedRecommendations: function(gameId, amount) {
      var url =
        baseUrlNoContext +
        '/website/api/games/recommendation-item-select.json?amount=' +
        amount +
        '&gameId=' +
        gameId;
      return $http.get(url, { timeout: 8000 });
    },

    getMostRecentUpcomingGame: function() {
      var url = baseUrlNoContext + 'api/v1/upcoming/latest';
      return $http.get(url);
    },

    //---------------
    // get game-based recommendated games, but only serve games that have the same genre as the input game's genre
    getGameBasedRecommendationsForceGenre: function(gameId, amount) {
      var url =
        baseUrlNoContext +
        '/website/api/games/recommendation-genre-select.json?amount=' +
        amount +
        '&gameId=' +
        gameId;
      return $http.get(url, { timeout: 8000 });
    },

    // Remove recently played
    removeplayerrecentlyplayed: function(gameId) {
      try {
        var url =
          baseUrlNoContext +
          '/website/api/games/remove-player-recentlyplayed.json?gameId=' +
          gameId;
        return $http.post(url);
      } catch (e) {
        return false;
      }
    },

    // Get user reviews
    getUserReviews: function(seoName) {
      var url = baseUrlNoContext + '/legacy/reviews/' + seoName;
      return $http.get(url);
    },

    // Post (new) game rating
    postGameRating: function(gameId, ratingObject) {
      try {
        var url =
          baseUrlNoContext +
          '/website/api/games/rategame.json?gameId=' +
          gameId;
        return $http.post(url, ratingObject);
      } catch (e) {
        return false;
      }
    },

    //---------------
    // Upcoming Game Page calls
    getUpcomingGame: function(seoName) {
      try {
        var url = baseUrlNoContext + 'api/v1/upcoming/seoname/' + seoName;
        return $http.get(url);
      } catch (e) {
        return false;
      }
    },

    // Subscribe the email to the upcoming game
    postUpcomingGameEmail: function(email, seoName) {
      try {
        var url = baseUrlNoContext + '/api/v1/upcoming/subscribe';
        return $http.post(url, { email: email, seoName: seoName });
      } catch (e) {
        console.error('Error sending the email');
        return false;
      }
    },

    isPlayerSubscribed: function(seoName) {
      try {
        var url =
          baseUrlNoContext + 'api/v1/upcoming/' + seoName + '/subscription';
        return $http.get(url);
      } catch (e) {
        return { isSubscribed: false };
      }
    },

    //---------------
    //Global specific game calls
    getSpecificGameByContentId: function(contentId) {
      var url =
        baseUrlNoContext +
        '/website/api/games/game-select.json?contentId=' +
        contentId;
      return $http.get(url);
    },

    //---------------
    // Promotion notification
    getCarouselPromoNotification: function() {
      var cookieDeviceId = $cookies.get('deviceId');
      var url =
        baseUrlNoContext +
        '/api/v1/promo/notification/' +
        (cookieDeviceId || '');
      return $http.get(url, { timeout: 8000 });
    },

    /**
     * @param seoName
     * @param pageCount which page we are retrieve. Defaults to 0
     * @param pageSize number of games per "page". Defaults to 100
     * @param sortField: use the backend names of the gamebox object. Defaults to launchDate
     * @param sortOrder: ASC or DESC. Defaults to ASC
     */
    getSeriesGames: function(
      seoName,
      pageCount,
      pageSize,
      sortField,
      sortOrder
    ) {
      pageCount = pageCount || '0';
      pageSize = pageSize || '100';
      sortField = sortField || 'launchDate';
      sortOrder = sortOrder || 'ASC';
      var url =
        baseUrlNoContext +
        '/website/api/games/series-select.json?seriesname=' +
        seoName +
        '&page=' +
        pageCount +
        '&size=' +
        pageSize +
        '&sortField=' +
        sortField +
        '&sortOrder=' +
        sortOrder;
      return $http.get(url);
    }
  };
}

GameDataSvc.$inject = [
  '$q',
  '$http',
  '$rootScope',
  '$cookies',
  'abtestService'
];
module.exports = GameDataSvc;

},{}],55:[function(require,module,exports){
function GenreService ($q, $http) {
    var cachedGenreDetails = null;

    // Store genre details in a variable cache
    var saveGenreDetails = function (response) {
        cachedGenreDetails = response.data;
        return cachedGenreDetails;
    };

    var getGenreDetails = function () {
        if (cachedGenreDetails) {
                return $q.resolve(cachedGenreDetails);
        }
        
        return $http.get('/website/api/categories/all.json').then(saveGenreDetails);
    };

    return {
        getGenreDetails: getGenreDetails
    }

}


GenreService.$inject = ['$q', '$http'];
module.exports = GenreService;
},{}],56:[function(require,module,exports){
function httpsRedirectService() {
  var redirectHttps = function(href) {
    if (isSecurePage(href) && !isHttps(href)) {
      redirect(href, 'https');
      return true;
    }

    if (!isSecurePage(href) && isHttps(href)) {
      redirect(href, 'http');
      return true;
    }

    return false;
  };

  function getChromeAndFirefoxVersion() {
    var ver = navigator.userAgent.match(
      /((chrom(e|ium))|firefox)\/([0-9]+)\./i
    );
    return ver ? parseInt(ver[4], 10) : 0;
  }

  // All pages shall be considered secure on recent Chrome/FF whereas for the
  // rest of browsers (IE/Edge mainly) and older versions of Chrome/FF only
  // only certain pages should be secure for the AMI to run.
  function isSecurePage(href) {
    var isChromeOrFFAndNotIEOrEdge =
      /(chrome|firefox|chromium|opera)/i.test(navigator.userAgent) &&
      !/(edge|trident|msie)/i.test(navigator.userAgent);

    if (isChromeOrFFAndNotIEOrEdge) {
      // Some people have older FF and older Chrome even though they should
      // automatically upgrade. That's why we check for recent versions of both.
      var isRecentFF =
        /firefox/i.test(navigator.userAgent) &&
        getChromeAndFirefoxVersion() >= 61;
      var isRecentChrome =
        /chrome|chromium/i.test(navigator.userAgent) &&
        getChromeAndFirefoxVersion() >= 67;
      if (isRecentChrome || isRecentFF) return true;
    }

    var securePages = [
      '/signup',
      '/payment',
      '/payment/promo',
      '/callback',
      '/paymentupdate',
      '/upcoming'
    ];

    for (var i = 0; i < securePages.length; i++) {
      if (href.indexOf(securePages[i]) != -1) {
        return true;
      }
    }
    return false;
  }

  function isHttps(href) {
    return href.indexOf('https') != -1;
  }

  function redirect(href, protocol) {
    window.location.href = href.replace(new RegExp('^http[s]?'), protocol);
  }

  return {
    redirectHttps: redirectHttps
  };
}

httpsRedirectService.$inject = [];
module.exports = httpsRedirectService;

},{}],57:[function(require,module,exports){
function messageService($rootScope, localStorageService, gameDataSvc, gatheringSvc, accountService, $timeout) {

    function initializeService() {
        var tempMessageList = localStorageService.get('messageList');
        if (tempMessageList) {
            tempMessageList.forEach(function (message, index) {
                if (message.type === 'game' && (message.status === 'installed')) {
                    gameDataSvc.getSpecificGameByContentId(message.contentId).success(function (game) {
                        if (game && game.contentId && game.id) {
                            $rootScope.insertGame(game);
                            //TODO review if needed/wanted
                            $rootScope.gameManager.sessionGamesInfo[message.contentId].state = 'installed';
                            $rootScope.gameManager.sessionGamesInfo[message.contentId].gameReady = true;
                        }
                    });
                    addGameToList(message.contentId, message.status);
                }
            });
        }
    }

    function addGameToList(contentId, status) {
        removeGameFromList(contentId);
        $rootScope.messageList.push({type: 'game', contentId: contentId, status: status});
        localStorageService.set('messageList', $rootScope.messageList);
    }

    function removeGameFromList(contentId) {
        $rootScope.messageList.every(function (message, index) {
            if (message.type === 'game' && message.contentId === contentId) {
                $rootScope.messageList.splice(index, 1);
                return false;
            } else {
                return true;
            }
        });
    }

    function triggerEndOfSubscriptionMessage() {
        var currentTime = new Date().getTime();
        var threeDays = 259200000;
        var twoWeeks = 1209600000;

        accountService.getEntitlement().then(function (response) {
            if (response.data && response.data.status) {
                var entitlement = response.data;
                var messageStatus = getMessageStatus();

                if (entitlement.status === 'CANCELLED' && entitlement.endDate &&
                    currentTime > (entitlement.endDate - threeDays)) {
                    var daysLeft = Math.round((entitlement.endDate - currentTime) / (1000 * 60 * 60 * 24));
                    if (daysLeft > -1) {
                        if (!messageStatus.endOfSubscription[entitlement.endDate + '-' + daysLeft + '-deleted']) {
                            if (!messageStatus.endOfSubscription[entitlement.endDate + '-' + daysLeft + '-shown']) {
                                $rootScope.messageList.push({
                                    type: 'endofsubscription',
                                    id: entitlement.endDate + '-' + daysLeft,
                                    daysLeft: daysLeft
                                });
                                $timeout(function() {
                                    showMessageWindow(true);
                                    showGlowEffect("messageid-" + entitlement.endDate + '-' + daysLeft, 'red');
                                });
                                messageStatus.endOfSubscription[entitlement.endDate + '-' + daysLeft + '-shown'] = true;
                                gatheringSvc.sendClickTracking('messagecenter', 'Show subscription ends in ' + daysLeft);
                            } else {
                                $rootScope.messageList.push({
                                    type: 'endofsubscription',
                                    id: entitlement.endDate + '-' + daysLeft,
                                    daysLeft: daysLeft
                                });
                                gatheringSvc.sendClickTracking('messagecenter', 'Load subscription ends in ' + daysLeft);
                            }
                        }
                    }
                } else if (entitlement.status === 'EXPIRED' && entitlement.endDate &&
                    (entitlement.endDate + twoWeeks) > currentTime) {
                    if (!messageStatus.endOfSubscription[entitlement.endDate + '-deleted']) {
                        if (!messageStatus.endOfSubscription[entitlement.endDate + '-shown']) {
                            $rootScope.messageList.push({
                                type: 'subscriptionexpired',
                                id: entitlement.endDate
                            });
                            $timeout(function() {
                                showMessageWindow(true);
                                showGlowEffect("messageid-" + entitlement.endDate, 'red');
                            });
                            messageStatus.endOfSubscription[entitlement.endDate + '-shown'] = true;
                            gatheringSvc.sendClickTracking('messagecenter', 'Show subscription ended');
                        } else {
                            $rootScope.messageList.push({
                                type: 'subscriptionexpired',
                                id: entitlement.endDate
                            });
                            gatheringSvc.sendClickTracking('messagecenter', 'Load subscription ended');
                        }
                    }
                }
                localStorageService.set('messageStatus', messageStatus);
            }
        });
    }

    function removeMessageFromList(id) {
        var messageStatus = getMessageStatus();
        $rootScope.messageList.every(function (message, index) {
            if (message.type !== 'game' && message.id === id) {
                $timeout(function() {
                    $rootScope.messageList.splice(index, 1);
                });
                messageStatus.endOfSubscription[id + '-deleted'] = true;
                gatheringSvc.sendClickTracking('messagecenter', 'Remove subscription end message');
                return false;
            } else {
                return true;
            }
        });
        localStorageService.set('messageStatus', messageStatus);
    }

    function getMessageStatus() {
        var messageStatus = localStorageService.get('messageStatus');
        if (!messageStatus) {
            messageStatus = {
                endOfSubscription: {}
            };
        }
        return messageStatus;
    }

    function showGlowEffect(elementId, classColor) {
        var message = angular.element(document.getElementById(elementId));
        setTimeout(function () {
            message.removeClass('white').addClass(classColor);
            setTimeout(function () {
                message.removeClass(classColor).addClass('white');
            }, 650);
        }, 250);
    }

    function showMessageWindow(scrollToTop) {
        if (!$rootScope.messageCenterWindow.show) {
            $rootScope.messageCenterWindow.show = true;
            $rootScope.$apply();
            if (scrollToTop) {
                angular.element(document.getElementById("dropdown-messagelist")).scrollTop(0);
            }
        }
    }

    return {
        initialize: function () {
            initializeService();
        },
        addGame: function (contentId, status) {
            var listSize = $rootScope.messageList.length;
            var openWindow = (status === 'installed' || status === 'queued');
            //This states indicate when the dropdown is forcefully shown
            //Only allow when external calls initiate it.
            if (openWindow) {
                showMessageWindow(true);
            }

            //Actual adding the message
            addGameToList(contentId, status);
            $rootScope.$apply();

            if (openWindow) {
                showGlowEffect("messageid-" + contentId, 'blue');
            }

            if ($rootScope.messageList.length > listSize) {
                gatheringSvc.sendClickTracking('messagecenter', 'Number of messages: ' + $rootScope.messageList.length);
            }
        },
        removeGameMessage: function (contentId) {
            removeGameFromList(contentId);
            localStorageService.set('messageList', $rootScope.messageList);
        },
        removeGameMessageWithFadeOut: function (contentId, messageId) {
            setTimeout(function () {
                angular.element('#' + messageId).find('.media-body').html('');
            });
            angular.element('#' + messageId).addClass('fade-out');
            setTimeout(function () {
                removeGameFromList(contentId);
                $rootScope.$apply();
                localStorageService.set('messageList', $rootScope.messageList);
            }, 1000);
        },
        removeMessage: function (id) {
            removeMessageFromList(id)
        },
        triggerEndOfSubscriptionMessage: function(){
            triggerEndOfSubscriptionMessage();
        },
        removeSubscriptionExpiringMessage: function() {
            $rootScope.messageList.every(function (message, index) {
                if (message.type === 'endofsubscription' ||
                    message.type === 'subscriptionexpired') {
                    $timeout(function() {
                        $rootScope.messageList.splice(index, 1);
                    });
                    return false;
                } else {
                    return true;
                }
            });
        }
    }
}

messageService.$inject = ['$rootScope', 'localStorageService', 'gameDataSvc', 'gatheringSvc', 'accountService', '$timeout'];
module.exports = messageService;
},{}],58:[function(require,module,exports){
function privacyService($http, $q, $cookies) {
  let installed = false;
  const cached = {
    isOutdated: false,
    signed: null,
    active: null
  };

  function cacheUpdated() {
    if (cached.active) {
      cached.isOutdated = cached.signed !== cached.active;
    }
  }

  function getSigned() {
    cached.signed = $cookies.get('gamehouse.privacy');
    cacheUpdated();
    return cached.signed;
  }

  function getActive() {
    const deferred = $q.defer();
    $http
      .get('/api/privacy/active')
      .success(function onSuccess(data) {
        if (data && data.version) {
          cached.active = data.version;
          cacheUpdated();
          deferred.resolve(data.version);
        } else {
          deferred.reject('Missing Active Policy Version');
        }
      })
      .error(function onError(msg) {
        console.error('Rejected', msg);
        deferred.reject(msg);
      });
    return deferred.promise;
  }

  function refresh() {
    if (!installed) {
      installed = true;
      getSigned();
      getActive();
      // Check every hour
      setInterval(function onInterval() {
        getActive();
        getSigned();
      }, 3600 * 1000);
    }
  }

  function isOutdated() {
    refresh();
    if ($cookies.get('gamehouse.ignore-terms')) {
      return false;
    }
    return cached.isOutdated;
  }

  function isOutdatedSync() {
    const deferred = $q.defer();

    if ($cookies.get('gamehouse.ignore-terms')) {
      deferred.resolve(false);
    } else if (cacheUpdated()) {
      deferred.resolve(cached.isOutdated);
    } else {
      getSigned(); // Cache signed cookie
      getActive().then(function(version) {
        deferred.resolve(cached.isOutdated);
      });
    }

    return deferred.promise;
  }

  function acceptActiveVersion() {
    const deferred = $q.defer();
    $http
      .post('/api/privacy/sign')
      .success(function onSuccess(data) {
        console.log('acceptActiveVersion', data);
        getSigned();
        deferred.resolve();
      })
      .error(function onError(data) {
        console.error('acceptActiveVersion', data);
        getSigned();
        deferred.reject();
      });
    return deferred.promise;
  }

  return {
    acceptActiveVersion: acceptActiveVersion,
    isOutdated: isOutdated,
    isOutdatedSync: isOutdatedSync
  };
}

privacyService.$inject = ['$http', '$q', '$cookies'];
module.exports = privacyService;

},{}],59:[function(require,module,exports){
function PromoService($http) {
  return {
    renderPromo: function(name, code) {
      var url = baseUrlNoContext + '/api/v1/promo/render/' + name;
      if (typeof code !== 'undefined' && code !== '') {
        url = url + '/' + code;
      }
      return $http.get(url);
    },
    applyPromoUpsell: function(name, code) {
      var url = baseUrlNoContext + '/api/v1/promo/apply/' + name;
      var payload = {};
      if (typeof code !== 'undefined' && code !== '') {
        payload.code = code;
      }
      return $http.post(url, payload);
    },
    promoInfo: function(name) {
      var url = baseUrlNoContext + '/api/v1/promo/' + name + '/info';
      return $http.get(url);
    }
  };
}

PromoService.$inject = ['$http'];
module.exports = PromoService;

},{}],60:[function(require,module,exports){
// Retry Service
//
// Example use:
//
// var promise = retryService.retry(function () {
//     return $http.get(url);
// });
//
// Make sure to return an Angular Promise at the exit of the function
//
// now use `promise.then()` etc
// as if you'd use the `.then()` on the `.get()` or so
//
// Settings:
// retryService.retry(function () { .. }, {
//     delay: 250,
//     retries: 5
// });
var RetryService = function ($q, $timeout) {

    var defaultConfig = {
        delay: 250,
        retries: 5
    };
    
    var retry = function (callback, preferences) {

        // Return an Angular Promise
        // When calling `succeed`, the promise succeeds; vice versa for `fail`
        return $q(function (succeed, fail) {

            // Keep track of how many times we try the thing
            var timesTried = 0;

            var config = angular.extend({}, defaultConfig, preferences);

            // Check if we tried too many times already,
            // Else: retry within a set time
            var setRetry = function (data) {
                if (timesTried > config.retries) {
                    return fail(data);
                }

                $timeout(tryCallback, config.delay);
            };

            // Try performing our thing
            // The `callback` as passed to the `retry` function should return an Angular promise
            // Depending on success/failure of it, we can retry
            var tryCallback = function () {
                ++timesTried;
                var working = callback();
                working.then(succeed, setRetry);
            };

            // Try for the first time
            tryCallback();
        });
    };


    return {
        retry: retry
    }
};



RetryService.$inject = ['$q', '$timeout'];
module.exports = RetryService;
},{}],61:[function(require,module,exports){
function SeriesService ($q, $http) {
    var cachedSeriesDetails = null;

    // Store series details in a variable cache
    var saveSeriesDetails = function (response) {
        cachedSeriesDetails = response.data;
        return cachedSeriesDetails;
    };

    var getSeriesDetails = function () {
        if (cachedSeriesDetails) {
                return $q.resolve(cachedSeriesDetails);
        }
        
        return $http.get('/website/api/series/all.json').then(saveSeriesDetails);
    };

    return {
        getSeriesDetails: getSeriesDetails
    }

}


SeriesService.$inject = ['$q', '$http'];
module.exports = SeriesService;
},{}],62:[function(require,module,exports){
function userSvc($http, $q, $cookies) {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  function getUUID() {
    return (S4() +
      S4() +
      '-' +
      S4() +
      '-4' +
      S4().substr(0, 3) +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    ).toLowerCase();
  }

  function getCurrentFormattedDate() {
    var currentDate = new Date();
    var year = currentDate.getUTCFullYear();
    var month = currentDate.getUTCMonth() + 1;
    var day = currentDate.getUTCDate();
    return year + '-' + month + '-' + day;
  }

  function hasSessionId() {
    if (
      $cookies.get('gamehouse.sid') === undefined &&
      $cookies.get('ghsid') === undefined
    ) {
      return false;
    } else {
      return true;
    }
  }

  return {
    //
    //Get player details
    //
    getDefaultPlayer: function() {
      var player = {
        playerName: null,
        isLoggedIn: false,
        isEntitled: false,
        userId: -1,
        userName: 'anonymous',
        email: '',
        deviceId: '',
        legacyId: null,
        isPreloadingEnabled: false
      };
      return player;
    },
    getPlayer: function() {
      var url = baseUrlNoContext + '/website/api/player/whoami.json';
      return $http.get(url);
    },
    getPlayerByDeviceId: function(deviceId) {
      var url =
        baseUrlNoContext +
        '/website/api/player/getPlayerByDeviceId.json?deviceid=' +
        deviceId;
      return $http.get(url);
    },
    getPlayerBrowserOs: function() {
      var url = baseUrlNoContext + '/website/api/player/whatdoihave.json';
      return $http.get(url);
    },
    getPlayerLocation: function() {
      var url = baseUrlNoContext + '/website/api/player/whereami.json';
      return $http.get(url);
    },
    checkSessionId: function() {
      var deferred = $q.defer();
      if (hasSessionId()) {
        deferred.resolve();
      } else {
        this.getPlayer()
          .success(function(data) {
            if (hasSessionId()) {
              deferred.resolve();
            } else {
              deferred.reject('Do not have ghsid');
            }
          })
          .error(function(msg) {
            deferred.reject(msg);
          });
      }
      return deferred.promise;
    },
    checkVisitorId: function() {
      if ($cookies.get('ghvid') === undefined) {
        //Set cookie for 25 years
        $cookies.put('ghvid', getCurrentFormattedDate() + '_' + getUUID(), {
          path: '/',
          expires: new Date(new Date().getTime() + 25 * 365 * 86400000)
        });
      }
    }
  };
}
userSvc.$inject = ['$http', '$q', '$cookies'];
module.exports = userSvc;

},{}],63:[function(require,module,exports){
function welcomeLandingPageService($rootScope, $cookies, $window, $timeout) {
  var _currentTemplate = null;
  var _userRetrieved = false;

  function _redirectToWelcomePage() {
    if (!_userRetrieved || !_currentTemplate) return;

    var userRegistered = $rootScope.player.isLoggedIn;
    var welcomeCookie = $cookies.get('gamehouse.welcome');
    var isHome = _currentTemplate === 'homeView.html';

    if (userRegistered || welcomeCookie === 'true' || !isHome) return;

    if (!welcomeCookie || welcomeCookie === 'false') {
      $cookies.remove('gamehouse.welcome');
      $window.location.href = '/welcome';
    }
  }

  function _setUserRetrieved() {
    _userRetrieved = true;
    _redirectToWelcomePage();
  }

  function _updateTemplate(template) {
    _currentTemplate = template;
    _redirectToWelcomePage();
  }

  $rootScope.$on('$routeChangeStart', function($event, next, current) {
    var routeDest = next ? next.templateUrl : current.templateUrl;
    _updateTemplate(routeDest);
  });

  function _showBannerChanged(show) {
    $timeout(function() {
      if (_currentTemplate == 'welcomeLandingPage.html') {
        $('static-banner').css('z-index', 1031);
        $('.ie-browser-banner').css('z-index', -999);
      } else $('static-banner').css('z-index', 999);
    }, 0);
  }

  return {
    // This function must be called when the user object is retrieved from
    // the server, and the data in $rootScope.player is valid.
    setUserRetrieved: function() {
      _setUserRetrieved();
    },
    showBannerChanged: function(show) {
      _showBannerChanged(show);
    }
  };
}

welcomeLandingPageService.$inject = [
  '$rootScope',
  '$cookies',
  '$window',
  '$timeout'
];
module.exports = welcomeLandingPageService;

},{}]},{},[47]);
